webpackJsonp([1],Array(99).concat([
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_HeaderLayout__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_SideNavLayout__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_MessageCentreLayout__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_FooterLayout__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      // mapping:null
    };
  },

  components: {
    'header-layout': __WEBPACK_IMPORTED_MODULE_1__components_app_HeaderLayout__["a" /* default */],
    'sidenav-layout': __WEBPACK_IMPORTED_MODULE_2__components_app_SideNavLayout__["a" /* default */],
    'message-centre-layout': __WEBPACK_IMPORTED_MODULE_3__components_app_MessageCentreLayout__["a" /* default */],
    'footer-layout': __WEBPACK_IMPORTED_MODULE_4__components_app_FooterLayout__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["setBusiness", "logout", "unRegister"]), {
    commonactions: function commonactions(args) {
      switch (args.action) {

        case 'logout':
          this.logout();
          break;
        case 'unregister':
          this.unRegister();
          break;
        case 'closesidebar':
          this.closeSidebar();
          break;
        case 'opensidebar':
          document.getElementById("mySidebar").style.display = "block";
          break;
        case 'openhelppage':
          this.$refs.helpdialog.show();
          break;
        default:
          break;
      }
    },

    closeSidebar: function closeSidebar() {
      var sb = document.getElementById("mySidebar");
      if (sb) {
        sb.style.display = "none";
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["newversionavailable"]))

});

/***/ }),
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {};
  },
  methods: {
    click: function click(action) {
      this.$emit("click", {
        action: action
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["business", "person",, "adminrights", "alladminrights", "profile", "routetitle", "sysadmin"]))
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {};
  },
  methods: {
    click: function click(action) {
      this.$emit("click", {
        action: action
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["business", "person", "personorders", "adminrights", "alladminrights", "profile"]))
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showmessagebar: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setBannerMessage", "setNotifications", "setCurrentLocation"]), {
    click: function click(action) {
      this.$emit("click", {
        action: action
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["fcmToken", "last10messages", "location", "bannermessage"]))
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_How__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WPP__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TANDCS__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_GoogleMap__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_About__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_BusinessSelect__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Profile__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_Admin__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_AdminBusinessProjects__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_AdminBusinessLinks__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_AdminCommon__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_admin_AdminStoreStaffGroups__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_customerremedials_AdminCustomersRemedialsProcessing__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_customerremedials_AdminCustomersRemedialsDeclined__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_customerremedials_AdminCustomersRemedialsHome__ = __webpack_require__(106);

























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
    meta: {
      title: 'Home'
    }
  }, {
    path: '/admin/home',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_11__components_admin_Admin__["a" /* default */],
    meta: {
      title: 'Admin'
    }

  }, {
    path: '/admin/customerremedials/home',
    name: 'AdminCustomersRemedialsHome',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_customerremedials_AdminCustomersRemedialsHome__["a" /* default */],
    meta: {
      title: 'Remedials'
    }
  }, {
    path: '/admin/customerremedials/processing',
    name: 'AdminRemedialsProcessing',
    component: __WEBPACK_IMPORTED_MODULE_16__components_admin_customerremedials_AdminCustomersRemedialsProcessing__["a" /* default */],
    meta: {
      title: 'Process'
    }
  }, {
    path: '/admin/customerremedials/declined',
    name: 'AdminCustomersRemedialsDeclined',
    component: __WEBPACK_IMPORTED_MODULE_17__components_admin_customerremedials_AdminCustomersRemedialsDeclined__["a" /* default */],
    meta: {
      title: 'Declined'
    }
  }, {
    path: '/admin/common',
    name: 'AdminCommon',
    component: __WEBPACK_IMPORTED_MODULE_14__components_admin_AdminCommon__["a" /* default */],
    meta: {
      title: 'Common'
    }
  }, {
    path: '/admin/projects',
    name: 'AdminBusinessProjects',
    component: __WEBPACK_IMPORTED_MODULE_12__components_admin_AdminBusinessProjects__["a" /* default */],
    meta: {
      title: 'Projects'
    }
  }, {
    path: '/admin/businesslinks',
    name: 'AdminBusinessLinks',
    component: __WEBPACK_IMPORTED_MODULE_13__components_admin_AdminBusinessLinks__["a" /* default */],
    meta: {
      title: 'BusinessLinks'
    }
  }, {
    path: '/admin/staff',
    name: 'AdminStoreStaffGroups',
    component: __WEBPACK_IMPORTED_MODULE_15__components_admin_AdminStoreStaffGroups__["a" /* default */],
    meta: {
      title: 'Staff'
    }
  }, {
    path: '/googlemap',
    name: 'GoogleMap',
    component: __WEBPACK_IMPORTED_MODULE_6__components_GoogleMap__["a" /* default */]
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
    meta: {
      title: 'Home'
    }
  }, {
    path: '/how',
    name: 'how',
    component: __WEBPACK_IMPORTED_MODULE_3__components_How__["a" /* default */],
    meta: {
      title: 'How to Links'
    }
  }, {
    path: '/wpp',
    name: 'WPP',
    component: __WEBPACK_IMPORTED_MODULE_4__components_WPP__["a" /* default */],
    meta: {
      title: 'Privacy Policy'
    }
  }, {
    path: '/termsconditions',
    name: 'TANDCS',
    component: __WEBPACK_IMPORTED_MODULE_5__components_TANDCS__["a" /* default */],
    meta: {
      title: 'Terms of use'
    }
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_7__components_About__["a" /* default */],
    meta: {
      title: 'About'
    }
  }, {
    path: '/businessselect',
    name: 'BusinessSelect',
    component: __WEBPACK_IMPORTED_MODULE_8__components_BusinessSelect__["a" /* default */],
    meta: {
      title: 'Shops'
    }
  },

  // {
  //   path: '/offers/:id',
  //   name: 'Offers',
  //   component: Offers
  // },
  {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Login__["a" /* default */],
    meta: {
      title: 'Login'
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Profile__["a" /* default */],
    meta: {
      title: 'My Profile'
    }
  }]
}));

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_customerremedials_AdminCustomersRemedialsHome__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_CustomerRemedialsTile__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_BusinessImageBasicTile__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_HomeAboutTile__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_MyRemedialsTile__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_home_OptionsTile__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['addToHomeScreen'])),
  computed: Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["business", "addtohomescreen", "adminrights", "sysadmin"]),
  components: {
    'remedials-home': __WEBPACK_IMPORTED_MODULE_1__components_admin_customerremedials_AdminCustomersRemedialsHome__["a" /* default */],
    'customer-remedials-tile': __WEBPACK_IMPORTED_MODULE_2__components_home_CustomerRemedialsTile__["a" /* default */],
    'home-about-tile': __WEBPACK_IMPORTED_MODULE_4__components_home_HomeAboutTile__["a" /* default */],
    'business-image-basic-tile': __WEBPACK_IMPORTED_MODULE_3__components_home_BusinessImageBasicTile__["a" /* default */],
    'my-remedials-tile': __WEBPACK_IMPORTED_MODULE_5__components_home_MyRemedialsTile__["a" /* default */],
    'options-tile': __WEBPACK_IMPORTED_MODULE_6__components_home_OptionsTile__["a" /* default */]
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCustomersRemedialsHome_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de1e71d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCustomersRemedialsHome_vue__ = __webpack_require__(434);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCustomersRemedialsHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de1e71d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCustomersRemedialsHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["adminrights", "sysadmin", "business"]))

});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["adminrights", "sysadmin"]
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["business"],
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["business"]
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    process: function process() {
      var _this = this;

      var sample = [{
        "JobNumber": "",
        "Received": "10/03/2016",
        "Address": "37 Andrew Jack Rd Millwater",
        "Issue": "Knock down all  pins on stairs & transitions",
        "Installer": "Ross",
        "CustomerName": "Zhang &Song",
        "CustomerPhone": 210655356,
        "GBContact": "Mike Clark Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Mike Clark Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/09/2016",
        "Address": "28 Pioneer",
        "Issue": "Issues Johnny sorted",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Zhang",
        "CustomerPhone": 2101592,
        "GBContact": "Nic Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Nic Smith",
        "Status": "Fixed by Johnny",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "GB035",
        "Received": "3/06/2016",
        "Address": "12 Skipjack Pass, Silverdale",
        "Issue": "Carpet at ranch slider needs tucking",
        "Installer": "Kelvin",
        "CustomerName": "Zane",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "TBF 10/06/2016",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/06/2017",
        "Address": "72 Paremoremo Rd Paremoremo",
        "Issue": "carpet lifting in hall & hwc due to flooding",
        "Installer": "Ross",
        "CustomerName": "Yun",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "3/03/2018",
        "Address": "31 Liquidambar Dr Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Yoon",
        "CustomerPhone": 211718457,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/07/2016",
        "Address": "28 Gumdigger Rise Millwater",
        "Issue": "Carpet is pulling away from smooth edge",
        "Installer": "Ross",
        "CustomerName": "Yolanda",
        "CustomerPhone": 2102488681,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "yolandavt@gmail.com",
        "GBStart": "Ross Murray",
        "Status": "Completed",
        "Notes": "Ross completed",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/04/2018",
        "Address": "16 Vue Terrace Silverdale",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Yaping",
        "CustomerPhone": "0210 323254",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "26/04/2017",
        "Address": "5 Saltmarsh Rd Hobsonville",
        "Issue": "lift carpet for floor remedial& return to refit",
        "Installer": "Dave Walker",
        "CustomerName": "Yan",
        "CustomerPhone": "021 909 605 Brad Small",
        "GBContact": "Brad Small Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brad Small Uni",
        "Status": "Fixed by Dave",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/07/2016",
        "Address": "5 Aporo Dr Huapai",
        "Issue": "Join in Lounge",
        "Installer": "Ross",
        "CustomerName": "Worthington",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Completed",
        "Notes": "Explained join good, wait a few months to see if settles",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/01/2017",
        "Address": "12 Captain Mitchell Drive Papakura",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Wilamina Poto",
        "CustomerPhone": "021 768 423",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "6/04/2017",
        "Address": "12 Captain Mitchell Drive Papakura",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Wilamina Poto",
        "CustomerPhone": "021 768 423",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/03/2018",
        "Address": "97 Hobsonville Pt Rd",
        "Issue": "refit smoothedge at main bathroom",
        "Installer": "Ross",
        "CustomerName": "Wen-Song",
        "CustomerPhone": "021 027 383 69",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/08/2017",
        "Address": "14 Hooton Dr Huapai",
        "Issue": "reinstate carpet where repair undertaken",
        "Installer": "",
        "CustomerName": "Wendy Crenfeldt",
        "CustomerPhone": "021 848 844",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/02/2016",
        "Address": "34 Marae Rd Greenhithe",
        "Issue": "re-stretch bedroom",
        "Installer": "Grant(Jared)",
        "CustomerName": "Wendy",
        "CustomerPhone": "027 204 3792",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/12/2017",
        "Address": "33 Headland Dr Long Bay",
        "Issue": "lift carpet for Stonewood to repair floor, relay Jan 2018",
        "Installer": "Ross",
        "CustomerName": "Wellingham",
        "CustomerPhone": "027  270 5003",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/03/2016",
        "Address": "43 Harris Dr Millwater",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "Wayne Harris",
        "CustomerPhone": "021 366 346",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/01/2017",
        "Address": "70 Westmuir Crescent Pokeno",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Warwick Steele",
        "CustomerPhone": 220455037,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "woky1955@yahoo.com",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/04/2017",
        "Address": "59 Harris Dr Millwater",
        "Issue": "inspect joins and attend",
        "Installer": "Norm",
        "CustomerName": "Warren Seet",
        "CustomerPhone": 223539979,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/07/2017",
        "Address": "28 Peters Lane Taupaki",
        "Issue": "vinyl plank lifting",
        "Installer": "Dave",
        "CustomerName": "Vicki Hamilton",
        "CustomerPhone": "027 283 0413",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Dave",
        "Notes": "Dave  completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "22/03/2018",
        "Address": "56 Onekiritea Rd Hobsonville",
        "Issue": "carpet lifting at tiles + different coloured tufts cut out",
        "Installer": "Ross",
        "CustomerName": "Vicki",
        "CustomerPhone": 272442860,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "15/12/2017",
        "Address": "21 Dida Park Ave Huapai",
        "Issue": "knock down all pins and refit carpet lifting",
        "Installer": "Ross",
        "CustomerName": "Vianca Lagerwall",
        "CustomerPhone": "021 0607 168",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 13,
        "Received": "17/04/2018",
        "Address": "LOT 7, 74 SQUADRON DRIVE HOB",
        "Issue": "Rodney",
        "Installer": "COMPLETED BY WAYNE, CREDIT IN SYSTEM FOR NZC UNDERLAY",
        "CustomerName": "UNIVERSAL HOMES?????????",
        "CustomerPhone": "GABE AK FLOORING",
        "GBContact": "021-578 250",
        "GB": "",
        "CustomerEmail": "TRACEY",
        "GBStart": "021-578 250",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 50,
        "Received": "3/05/2018",
        "Address": "LOT 1, 34 TONAR STREET, NORTHCOTE",
        "Issue": "Central",
        "Installer": "SEAL CUT IN VINYL DONE",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": "RHYS BAKER 021-588 591",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "SITE MANAGNER",
        "GBStart": "RHYS BAKER 021-588 591",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 60,
        "Received": "11/04/2018",
        "Address": "37 MAPOU RD HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "CHECK ALL CARPET AT STAIRS-TREADS-SOME LOOSE ROSS TO FIX 15/05/2018",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": "021 2099234",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "Rachel",
        "GBStart": "021 2099234",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 51,
        "Received": "7/05/2018",
        "Address": "LOT 26, 27 MAPOU RD, HOB",
        "Issue": "Rodney",
        "Installer": "NO SMOOTHEDGE STAIRS-GRANT BOOKED THURS 12/07/2018 COMPLETED GRANT MIN CHARGE",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "BADDI",
        "GBContact": 294736590,
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "CLAIRE",
        "GBStart": 294736590,
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 44,
        "Received": "26/04/2018",
        "Address": "LOT 4, 38 TONAR ST, NORTHCOTE",
        "Issue": "Central",
        "Installer": "REPAIR VINYL JOIN  DONE KANE",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "REECE BAKER 021-588 591",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 38,
        "Received": "20/04/2018",
        "Address": "LOT 2, 4 PAETAHI LANE, NORTHCOTE",
        "Issue": "Central",
        "Installer": "REPAIR JOIN IN THE VINYL - BOOK ROSS 11/5/18 ORGANISE KANE",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "RHYS BAKER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 39,
        "Received": "20/04/2018",
        "Address": "LOT 5, 135 HOBSONVILLE PT RD",
        "Issue": "Rodney",
        "Installer": "CARPET COMING LOOSE AT STAIRS WAYNE BOOKED WED 16/05/2018 CODE = 7072",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": "021-268 5514",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "JUAN",
        "GBStart": "021-268 5514",
        "Status": "",
        "Notes": "IAN DONACHIE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 53,
        "Received": "3/05/2018",
        "Address": "15 HARVARD ST HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "WAYNE DONE 22/05/2018",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "JOHNNY NICHOLSON",
        "GBContact": "0212 121 998",
        "GB": "",
        "CustomerEmail": "CHRIS",
        "GBStart": "0212 121 998",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 43,
        "Received": "26/04/2018",
        "Address": "LOT 4, 80 SQUADRON DRIVE, HOB",
        "Issue": "Rodney",
        "Installer": "CARPET PULLING UP - ROSS BOOKED MON 21/05/2018 8.30AM",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": "021-070 3962",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "KIRSTY",
        "GBStart": "021-070 3962",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 55,
        "Received": "7/05/2018",
        "Address": "LOT 15, 2 CHAFFINCH RD HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "FIX CARPET LEADING FROM BEDROOM TO ENSUITE ROSS BOOKED TO FIX 11/05/2018",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "GRANT",
        "GBContact": "021 824 933",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "MARIA",
        "GBStart": "021 824 933",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/05/2018",
        "Address": "10 RANGIHINA RD HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "COMPLETED BY ROSS",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": 211714390,
        "GB": "",
        "CustomerEmail": "JO",
        "GBStart": 211714390,
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 59,
        "Received": "15/05/2018",
        "Address": "51 MAPOU RD HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "CARPET IS LIFTING IN 2 AREAS- ROSS TO FIX 16/05/2018",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "",
        "GBContact": 21622004,
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "Karen",
        "GBStart": 21622004,
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 6,
        "Received": "17/04/2018",
        "Address": "LOT 6, TONAR ST",
        "Issue": "Central",
        "Installer": "JOINS (Rommel still to do) - NEED TO CHECK WITH KELVIN",
        "CustomerName": "UNIVERSAL HOMES",
        "CustomerPhone": "KELVIN AND BOYS",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 88,
        "Received": "26/06/2018",
        "Address": "49 ANDREW JACK RD , SILVERDALE",
        "Issue": "Rodney",
        "Installer": "COMPLETED 03/07/2018  CHARGE OUT!!!!!!!!",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "021 615 865",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "SHAUN",
        "GBStart": "021 615 865",
        "Status": "",
        "Notes": "IAN DONACHIE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 59,
        "Received": "11/05/2018",
        "Address": "lot 11,22 PAETAHI LANE",
        "Issue": "Central",
        "Installer": "RESILICON VINYL COVE BY SHOWER KANE TO FIX",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "021 588 591",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "021 588 591",
        "Status": "",
        "Notes": "REECE BAKER 021-588 591",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 65,
        "Received": "25/05/2018",
        "Address": "LOT 54, 73 ANDREW JACK RD SILVERDALE",
        "Issue": "Rodney",
        "Installer": "FIX CARPET AT JUNCTION WITH TILES - ROSS BOOKED 9.30AM 11/06/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "GRANT",
        "GBContact": 274413144,
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "BRYAN",
        "GBStart": 274413144,
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 68,
        "Received": "29/05/2018",
        "Address": "19 SACRED KINGFISHER RD HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "IMPROVE JOIN, REMOVE TACKS AT TOP OF STAIRS",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": 212375894,
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "YUAN DAI",
        "GBStart": 212375894,
        "Status": "",
        "Notes": "DEAN HODGSON",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 57,
        "Received": "11/05/2018",
        "Address": "lot 13, 26 TONAR ST NORTHCOTE",
        "Issue": "Central",
        "Installer": "REPAIR VINYL COVING KANE TO FIX",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "REECE BAKER 021-588 591",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 69,
        "Received": "30/05/2018",
        "Address": "LOT 17, 109 HOBSONVILLE PT ROAD",
        "Issue": "Rodney",
        "Installer": "PREINSPECT REPAIRS  -  ROSS BOOKED WEDNESDAY 30/05/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "BRANDON LEE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 70,
        "Received": "30/05/2018",
        "Address": "LOT 16,  107 HOBSONVILLE PT ROAD",
        "Issue": "Rodney",
        "Installer": "PREINSPECT REPAIRS  -  ROSS BOOKED WEDNESDAY 30/05/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "BRANDON LEE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 81,
        "Received": "15/06/2018",
        "Address": "LOT 6, 3 CHAFFINCH RD HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "FIT CARPET IN ENTRY CUPBOARD",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "DEAN",
        "GBStart": "",
        "Status": "",
        "Notes": "DEAN HODGSON",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 82,
        "Received": "15/06/2018",
        "Address": "LOT 702, 23 HELENVALE CRES, POKENO",
        "Issue": "South    -   COLIN ADVISED 'ALL DONE'  27/06/2018",
        "Installer": "SHOWHOME - TRACK MARKS - ROSS SEND COMPLAINT FORM TO KARL - COLIN INSPECTING",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "TAINUI RICKARD",
        "GBContact": "09-415 2714",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "GRANT COUTTS",
        "GBStart": "09-415 2714",
        "Status": "",
        "Notes": "GRANT COUTTS",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 105,
        "Received": "27/08/2018",
        "Address": "LOT 17, 6 CHAFFINCH RD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "2 X JOINS, FIX LUMP UNDER STEP 2 - ROSS TO CHECK 28/08/2018 3.30PM",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "NORM HUNT",
        "GBContact": "027-892 7165",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "LYSHAAN",
        "GBStart": "027-892 7165",
        "Status": "",
        "Notes": "JOANNE BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 74,
        "Received": "7/06/2018",
        "Address": "11 MOA STONE RD, MILLWATER",
        "Issue": "Rodney",
        "Installer": "FIX LOOSE CARPET FAMILY AREA - ROSS INSPECTING 14/06/2018 9.00AM",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "NORM HUNT",
        "GBContact": "027-654 9777",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "SOPO",
        "GBStart": "027-654 9777",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 63,
        "Received": "22/05/2018",
        "Address": "8 VUE TERRACE, MILLWATER",
        "Issue": "Rodney",
        "Installer": "2 JOINS IN LOUNGE CARPET STICKING UP - Grant fixing Saturday 26th May",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "GRANT",
        "GBContact": "027-591 9395",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "GARY",
        "GBStart": "027-591 9395",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 98,
        "Received": "26/07/2018",
        "Address": "LOT 40, 27 SALTMARSH ROAD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "REPLACEMENT/RELAY - SAT 08/09/2018 KELVIN - GB349",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "MATTHEW BUNN",
        "GBContact": "027-570 0480",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "STUART",
        "GBStart": "027-570 0480",
        "Status": "",
        "Notes": "JOANNE BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 64,
        "Received": "23/05/2018",
        "Address": "LOT 8, 44 ONEKIRITEA RD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "FIX CARPET AT TOP OF STAIR RISER, CARPET AT LAUNDRY LOOSE ROSS BOOKED 8.30AM 25/05/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "KELVIN, ROBERT",
        "GBContact": "027-556 5300",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "GREG",
        "GBStart": "027-556 5300",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 103,
        "Received": "17/08/2018",
        "Address": "14 VUE TERRACE, SILVERDALE",
        "Issue": "Rodney",
        "Installer": "CARPET LIFTING AT ENTRANCE ROSS BOOKED TUES 21/08/2018 MID MORNING",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "KELS FLOORING",
        "GBContact": "027-551 7160",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "ADRIAN",
        "GBStart": "027-551 7160",
        "Status": "",
        "Notes": "JOANNE BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 71,
        "Received": "7/06/2018",
        "Address": "LOT 20, 3E KIOKIO ST, LONG BAY",
        "Issue": "Central",
        "Installer": "FIX LOOSE CARPET JOINS AT KITCHEN, LIVING AREA & BATHROOMS - ROSS BOOKED PM 07/06/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "MATTHEW BUNN",
        "GBContact": "022-586 6913",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "EMMA",
        "GBStart": "022-586 6913",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 91,
        "Received": "3/07/2018",
        "Address": "LOT 28, 31 MAPOU ROAD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "CARPET AT STAIRS-ROSS BOOKED TO INSPECT THURSDAY 04/07/18 CLIENT REQUESTED NOT BEFORE 9.00AM!!!",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "AK FLOORING",
        "GBContact": "021-927 412",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "TONY",
        "GBStart": "021-927 412",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 2,
        "Received": "17/05/2018",
        "Address": "LOT 2, 31A CASTLEDINE CRES, GI",
        "Issue": "South",
        "Installer": "BUMPS IN CARPET -  ROSS !!!!! - COMPLETED THURSDAY 17/05/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "KELVIN",
        "GBContact": "021-623 009",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "JAN",
        "GBStart": "021-623 009",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 102,
        "Received": "7/08/2018",
        "Address": "47 ANDREW JACK ROAD, SILVERDALE",
        "Issue": "Rodney",
        "Installer": "3 X SQUEAKY AREAS ON UPSTAIRS CARPET -  (ROSS to go back Aug 21st, lift 3 bedrooms, cut out squeaks)",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "GRANT",
        "GBContact": "021-321 492",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "SIMON",
        "GBStart": "021-321 492",
        "Status": "",
        "Notes": "JOANNE BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 75,
        "Received": "8/06/2018",
        "Address": "LOT 31, 37 MAPOU RD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "BDM CARPET NEEDS RELAYING AFTER BUILDER. BY 18/06/2018 CHARGE OUT! Ross DOING 25/06/2018 PM",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "GRANT",
        "GBContact": "021-2209 9234",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "RACHEL",
        "GBStart": "021-2209 9234",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 87,
        "Received": "26/06/2018",
        "Address": "LOT 12, 3 ANDREW ROAD, SILVERDALE",
        "Issue": "Rodney",
        "Installer": "LOOSE & FRAYED CARPET AT KITCHEN JUNCTION ROSS BOOKED 9.00AM MON 02/07/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "CADDYSHACK",
        "GBContact": "021-176 3224",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "EMMA",
        "GBStart": "021-176 3224",
        "Status": "",
        "Notes": "KARA SMITH",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 49,
        "Received": "3/05/2018",
        "Address": "LOT 12, 52 ONEKIRITEA RD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "CARPET REPAIRS AFTER BUILDER HAS FINISHED   -  BOOKED IN 14/05/2018 NASH",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "021-073 4730",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "KATIE",
        "GBStart": "021-073 4730",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 96,
        "Received": "16/07/2018",
        "Address": "42 BOMB POINT DR, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "CARPET IN DINING ROOM COMING APART AT JOIN-MATT WED 18/07/2018 9.30AM",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "CADDY",
        "GBContact": "021-069 9889",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "BUNREANG",
        "GBStart": "021-069 9889",
        "Status": "",
        "Notes": "JOANNE BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 95,
        "Received": "10/07/2018",
        "Address": "LOT 3, 13 SPOTTED DOVE RD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "FRAYED CARPET- ROSS BOOKED TUESDAY 10/07/2018 4.15PM",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "MATTHEW",
        "GBContact": "021-044 2163",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "HELEN",
        "GBStart": "021-044 2163",
        "Status": "",
        "Notes": "IAN DONACHIE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 40,
        "Received": "20/04/2018",
        "Address": "LOT 2, 129 HOBSONVILLE PT RD",
        "Issue": "Rodney",
        "Installer": "CARPET ON STAIRS NEEDS FIXING WAYNE WED 16/05/2018",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "",
        "GBContact": "021-042 4214",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "AMY",
        "GBStart": "021-042 4214",
        "Status": "",
        "Notes": "KARA SMITH",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 83,
        "Received": "19/06/2018",
        "Address": "125 HOBSONVILLE RD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "CAREPT FIXING BACK AFTER SQUEAKY STAIR FIXED  -  CHARGE OUT JOB!!!ROSS BOOKED FRI 22/06/2018 4.00PM",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "KELVIN",
        "GBContact": "021-035 3678",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "JEN",
        "GBStart": "021-035 3678",
        "Status": "",
        "Notes": "IAN DONACHIE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 27,
        "Received": "17/04/2018",
        "Address": "LOT 11, 16-24 MERFIELD STREET, GI",
        "Issue": "Central",
        "Installer": "FIX VINYL KITCHEN FLOOR BUBBLING -JOB DONE???? JO TO CONFIRM. JO CONFIRMED DONE!",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "MARK FLEMMING",
        "GBContact": "021-0257 8660",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "KENNITH",
        "GBStart": "021-0257 8660",
        "Status": "",
        "Notes": "IAN DONACHIE",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/05/2017",
        "Address": "LOT 4/13 MELLING ST GLEN INNES",
        "Issue": "Central",
        "Installer": "CHECK SIDES OF STAIRS",
        "CustomerName": "UNIVERSAL",
        "CustomerPhone": "GARY",
        "GBContact": "",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "AB",
        "GBStart": "",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/03/2016",
        "Address": "127 Hobsonville Pt Rd",
        "Issue": "Carpet loose on stairs",
        "Installer": "",
        "CustomerName": "Tracy Knight",
        "CustomerPhone": "021 082 26071",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/04/2017",
        "Address": "127 Hobsonville Pt Rd",
        "Issue": "Fix Stairs",
        "Installer": "Andrew Walker",
        "CustomerName": "Tracey Lee",
        "CustomerPhone": "021 082 26071",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "26/04/2017",
        "Address": "127 Hobsonville Pt Rd",
        "Issue": "Fix Stairs",
        "Installer": "Andrew Walker",
        "CustomerName": "Tracey Lee",
        "CustomerPhone": "021 082 26071",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "18/08/2017",
        "Address": "7 Grut Greens Millwater",
        "Issue": "replace carpet & underlay in cupboard due to leak",
        "Installer": "Ross",
        "CustomerName": "Tracey",
        "CustomerPhone": "021 497 920",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/11/2017",
        "Address": "21 Tua Tua Rd Hobsonville",
        "Issue": "carpet needs gap stretched",
        "Installer": "Ross",
        "CustomerName": "Tony",
        "CustomerPhone": "0211 750 954",
        "GBContact": "Brandon",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brandon",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/11/2016",
        "Address": "4 Woodridge Dr Whangaparoa",
        "Issue": "refit carpet round tile remedial work",
        "Installer": "Ross",
        "CustomerName": "Tim Sweet",
        "CustomerPhone": "021 241 9480",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "8/08/2017",
        "Address": "3 Eric Farley Drive Huapai",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "Tim & Megan Runnalls",
        "CustomerPhone": 278075080,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/03/2016",
        "Address": "36 Te Oneroa Way, Long Bay",
        "Issue": "Replace carpet with stain on it",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Tim",
        "CustomerPhone": "027 353 5961",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Spoke to Tim",
        "Notes": "Carpet on order 8th July. Tim not ready until 8th July",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E0134",
        "Received": "31/05/2016",
        "Address": "Superlot 36, Lot 11, 39 Liquidambar Drive",
        "Issue": "Refit loose carpet and tap smooth edge down in kids bedrooms and sliders",
        "Installer": "",
        "CustomerName": "Tim",
        "CustomerPhone": "0274 334 334",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "TBF 16/06/2016",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/04/2018",
        "Address": "LOT 44, 53 ANDREW JACK RD",
        "Issue": "RESTRETCH CARPET ON TRIM",
        "Installer": "ROSS",
        "CustomerName": "THOMAS",
        "CustomerPhone": "021-0290 3217",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "FIXED BY ROSS",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/02/2018",
        "Address": "18 Mollusc Rd Hobsonville",
        "Issue": "fix stairs",
        "Installer": "Ross",
        "CustomerName": "Teresa",
        "CustomerPhone": 221535041,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "9/09/2017",
        "Address": "20C Torrington Cres Glen Innes",
        "Issue": "join splitting",
        "Installer": "Kelvin",
        "CustomerName": "Terangi",
        "CustomerPhone": 2102677513,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Kelvin",
        "Notes": "Kelvin completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/02/2018",
        "Address": "7 Martingale Dr Kingseat",
        "Issue": "carpet lifting & reglue join",
        "Installer": "Ross",
        "CustomerName": "Tasha",
        "CustomerPhone": 211451293,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "15/11/2017",
        "Address": "9 Arrier Lane Millwater",
        "Issue": "inspect hump in carpet",
        "Installer": "Ross",
        "CustomerName": "Swamy Umar",
        "CustomerPhone": 224007416,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "24/11/2016",
        "Address": "11 Matua Rd Huapai",
        "Issue": "carpet lifting in lounge",
        "Installer": "Ross",
        "CustomerName": "Susan Renata",
        "CustomerPhone": "021 333 378",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/12/2017",
        "Address": "182 Hobsonville Pt Rd",
        "Issue": "Restretch stairs",
        "Installer": "Ross",
        "CustomerName": "Susan Dobbie-Ede",
        "CustomerPhone": "021 407 509",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/05/2017",
        "Address": "45 Manuel Rd Millwater",
        "Issue": "carpet lifting",
        "Installer": "",
        "CustomerName": "Sukh Singh",
        "CustomerPhone": "021 046 3664",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "sukhzkool@gmail.com",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "1/06/2017",
        "Address": "30 Pony Park Pl Beachlands",
        "Issue": "re-stretch with Darryl Church",
        "Installer": "",
        "CustomerName": "Sue McGrath",
        "CustomerPhone": "021 040 8742",
        "GBContact": "MavisTulima",
        "GB": "OMAHA HOLDINGS LTD",
        "CustomerEmail": "",
        "GBStart": "MavisTulima",
        "Status": "Fixed by Darryl",
        "Notes": "Darryl completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/03/2016",
        "Address": "lot 88 8D Huarahi Pai Rd",
        "Issue": "Check joins, layer changed cutting plan",
        "Installer": "Richard & Andrew",
        "CustomerName": "Sue Hellesoe",
        "CustomerPhone": "021 851135",
        "GBContact": "Dan Young Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Dan Young Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "8/03/2016",
        "Address": "15 Thornton Green Karaka",
        "Issue": "Stretch and refit in various places",
        "Installer": "",
        "CustomerName": "Sue",
        "CustomerPhone": "021 2525063",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "Universal",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/03/2016",
        "Address": "57 Barcliff Terrace Gulf Harbour",
        "Issue": "carpet lifting in places and cropping needed",
        "Installer": "",
        "CustomerName": "Sue",
        "CustomerPhone": "021 022 36866",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/02/2018",
        "Address": "2 Weta Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Sudesh",
        "CustomerPhone": "029 127 0327",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "30/08/2016",
        "Address": "Lot 21, 3 Mapou Rd Hobsonville",
        "Issue": "fraying and lifting round kitchen tiles, stair bubble, nap join",
        "Installer": "Ross",
        "CustomerName": "Stuart Tomlinson",
        "CustomerPhone": "021 837 863",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2016",
        "Address": "27 Saltmarsh Rd Hobsonville",
        "Issue": "re stretch carpet lifting at tiles and stretch stairs",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Stuart &Rene Hartley",
        "CustomerPhone": "021 570 478",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "stuart.hartley@mail.com",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2016",
        "Address": "27 Saltmarsh Rd Hobsonville",
        "Issue": "replace carpet lifting at tiles",
        "Installer": "Matt",
        "CustomerName": "Stuart &Rene Hartley",
        "CustomerPhone": "021 570 478",
        "GBContact": "Brad Small",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "stuart.hartley@mail.com",
        "GBStart": "Brad Small",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/12/2016",
        "Address": "27 Saltmarsh Rd Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "Matt",
        "CustomerName": "Stuart",
        "CustomerPhone": "021 570 478",
        "GBContact": "Brad Small",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brad Small",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/03/2018",
        "Address": "39 Ormonde Dr Millwater",
        "Issue": "refit lifting carpet",
        "Installer": "Ross",
        "CustomerName": "Straka",
        "CustomerPhone": 211571602,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 15,
        "Received": "17/04/2018",
        "Address": "45 HARRIS DRIVE, MILLWATER",
        "Issue": "Rodney",
        "Installer": "WATER LEAK FROM SHOWER - GB300 CARPET IN STORE  -  BOOK DAVE - COMPLETED",
        "CustomerName": "STONEWOOD",
        "CustomerPhone": "",
        "GBContact": "021-118 5241",
        "GB": "",
        "CustomerEmail": "JO",
        "GBStart": "021-118 5241",
        "Status": "",
        "Notes": "STONEWOOD",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 52,
        "Received": "7/05/2018",
        "Address": "11 JAVELIN CLOSE GULF HARBOUR",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "RE FIT CARPET AT ENSUITE DOOR FOLLOWING LEAK ROSS SIGHTING 10/05/2018 FIXED AND INVOICED",
        "CustomerName": "STONEWOOD",
        "CustomerPhone": "",
        "GBContact": "021 464 496",
        "GB": "",
        "CustomerEmail": "LORRAINE JONES",
        "GBStart": "021 464 496",
        "Status": "",
        "Notes": "ROSS MURRAY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "",
        "Address": "105 Karepiro Dr Stanmore Bay",
        "Issue": "Norm  Re did his join",
        "Installer": "Norm",
        "CustomerName": "Stevi",
        "CustomerPhone": "021 081 05 801",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Norm Hunt",
        "Notes": "Norm  completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/05/2017",
        "Address": "225 Wainui Rd Millwater",
        "Issue": "Tuck carpet into smoothedge behind door",
        "Installer": "",
        "CustomerName": "Steven Bradshaw",
        "CustomerPhone": 278078131,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/10/2016",
        "Address": "lot 147,10 Eric Farley Drive Huapai",
        "Issue": "Refit to wall and tile",
        "Installer": "Ross",
        "CustomerName": "Steve Robinson",
        "CustomerPhone": 272016651,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/04/2017",
        "Address": "221 Wainui Rd Silverdale",
        "Issue": "inspect discoloured carpet/install issues",
        "Installer": "Matt Bunn",
        "CustomerName": "Stephen Arnott",
        "CustomerPhone": "021 830 026",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/06/2017",
        "Address": "221 Wainui Rd Silverdale",
        "Issue": "Refit and join carpet",
        "Installer": "Matt Bunn",
        "CustomerName": "Stephen Arnott",
        "CustomerPhone": "021 830 026",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "25/01/2018",
        "Address": "221 Wainui Rd Silverdale",
        "Issue": "carpet lifting",
        "Installer": "Matt Bunn",
        "CustomerName": "Stephen Arnott",
        "CustomerPhone": "021 830 026",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "30/01/2018",
        "Address": "17 Spotted Dove Rd Hobsonville",
        "Issue": "carpet lifting",
        "Installer": "Ross",
        "CustomerName": "Stephanie",
        "CustomerPhone": 21515130,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "13/10/2016",
        "Address": "68 Timberland Dr Millwater",
        "Issue": "Refit to walls where lifting",
        "Installer": "Ross",
        "CustomerName": "Stephan Potgieter",
        "CustomerPhone": "027 838 6131",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "5/07/2016",
        "Address": "102 Hillpark Dr Pokeno",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "Stacey Hartshorne",
        "CustomerPhone": 272799225,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2018",
        "Address": "`17 O'Ruamano Cres Puke",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Siraj",
        "CustomerPhone": 277427017,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "18/11/2016",
        "Address": "75C Martyn St Waiuku",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Darryl",
        "CustomerName": "Simon Williams",
        "CustomerPhone": "027 455 0443",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/10/2017",
        "Address": "47 Andrew Jack Rd",
        "Issue": "Check join.",
        "Installer": "",
        "CustomerName": "Simon",
        "CustomerPhone": "021 321 492",
        "GBContact": "Morne Botha Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Morne Botha Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/01/2018",
        "Address": "47 Andrew Jack Rd",
        "Issue": "Check join.",
        "Installer": "",
        "CustomerName": "Simon",
        "CustomerPhone": "021 321 492",
        "GBContact": "Morne Botha Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Morne Botha Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/11/2017",
        "Address": "4 Skylark Rd Hobsonville",
        "Issue": "refit carpet after repairs",
        "Installer": "Ross",
        "CustomerName": "Shivaun",
        "CustomerPhone": 212330534,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "23/06/2016",
        "Address": "202 Hobsonville Point Road",
        "Issue": "Relay carpet to middle level stairs and Bed2 following squeak fix. Keith (builder) 021 112 0967",
        "Installer": "",
        "CustomerName": "Sheila + Tim Chen",
        "CustomerPhone": "021 173 4058",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "pending Keith",
        "Notes": "Keith in 6/7 July to fix floor, will be in touch",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "8/09/2016",
        "Address": "202Hobsonville Point Road",
        "Issue": "ADVISED Ian need to go back when squeaky floor fixed",
        "Installer": "Ross",
        "CustomerName": "Sheila",
        "CustomerPhone": 211734058,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "12/04/2017",
        "Address": "202Hobsonville Point Road",
        "Issue": "ADVISED Ian need to go back when squeaky floor fixed",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Sheila",
        "CustomerPhone": 211734058,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": 323247,
        "Received": "22/04/2016",
        "Address": "Lot 53, 18 Malbec Place, Huapai",
        "Issue": "Remove object under carpet in main bedroom",
        "Installer": "George",
        "CustomerName": "Sharon Walton",
        "CustomerPhone": "021 356 009",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "unknown",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/03/2016",
        "Address": "139 Hillpark Dr Pokeno",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "Shaney Anderson",
        "CustomerPhone": "027 447 0105",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/06/2017",
        "Address": "8 Skipjack Pass Millwater",
        "Issue": "repair water damaged carpet",
        "Installer": "",
        "CustomerName": "Shalini",
        "CustomerPhone": "021 231 6632",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": 58,
        "Received": "11/05/2018",
        "Address": "45 BOUNTY RD, LONG BAY",
        "Issue": "Central",
        "Installer": "JOIN AFTER REPAIR WORK NOT ACCEPTABLE - KELVIN HAS PAPER WORK THURSDAY 31/05/2018",
        "CustomerName": "SENTINEL",
        "CustomerPhone": "KELVIN",
        "GBContact": "027-552 3333",
        "GB": "SENTINEL HOMES",
        "CustomerEmail": "KYLIE",
        "GBStart": "027-552 3333",
        "Status": "",
        "Notes": "SENTINEL",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 33,
        "Received": "12/07/2018",
        "Address": "15 KAHIKA GROVE HUAPAI",
        "Issue": "Rodney",
        "Installer": "ROSS VIEWED 11/07/2018 - KELVIN TO RETURN AND FIX ISSUES  WED am JULY 25th",
        "CustomerName": "SENTINEL",
        "CustomerPhone": "KELVIN MARCH 2017",
        "GBContact": "021 266 8847",
        "GB": "SENTINEL HOMES",
        "CustomerEmail": "GEMMA",
        "GBStart": "021 266 8847",
        "Status": "",
        "Notes": "HILTON BARTHOLOMEW",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 33,
        "Received": "17/04/2018",
        "Address": "15 KAHIKA GROVE HUAPAI",
        "Issue": "Rodney",
        "Installer": "CARPET ISSUES 26/4/18 ROSS FIXED ALL ISSUES EXCEPT FLOOR NEEDS FIXING SENTINEL - 16/05/2018 HILTON CANCELLED. ROSS DOING 3.00PM 29/05/2018",
        "CustomerName": "SENTINEL",
        "CustomerPhone": "",
        "GBContact": "021 266 8847",
        "GB": "SENTINEL HOMES",
        "CustomerEmail": "GEMMA",
        "GBStart": "021 266 8847",
        "Status": "",
        "Notes": "HILTON BARTHOLOMEW",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "31/05/2017",
        "Address": "7 Moho Lane Takanini",
        "Issue": "relay flood damaged carpet",
        "Installer": "",
        "CustomerName": "Sarah Naidu",
        "CustomerPhone": "021 486 536",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "2/08/2017",
        "Address": "22 Ara Kakara Ave Huapai",
        "Issue": "refit carpet where lifting",
        "Installer": "",
        "CustomerName": "Sarah",
        "CustomerPhone": "021 0227 5242",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "29/11/2017",
        "Address": "12 Belvedere Place, Warkworth",
        "Issue": "staple all tile transitions",
        "Installer": "Ross",
        "CustomerName": "Sarah",
        "CustomerPhone": "",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/09/2016",
        "Address": "Rohae Pl Papakura",
        "Issue": "Napped and flattened join",
        "Installer": "Ross",
        "CustomerName": "Sampayo",
        "CustomerPhone": 221797646,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/03/2016",
        "Address": "170 Hobsonville Pt Rd",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Sam",
        "CustomerPhone": "027 807 8885",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/01/2017",
        "Address": "1 Captain Mitchell Dr Papakura",
        "Issue": "loose s/e and lump under carpet",
        "Installer": "Ross",
        "CustomerName": "Sally Dunphy",
        "CustomerPhone": 211810995,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/03/2018",
        "Address": "79 Andrew Jack Rd",
        "Issue": "trim tufts",
        "Installer": "Ross",
        "CustomerName": "Sagan",
        "CustomerPhone": "",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/11/2016",
        "Address": "6 Leadership Cres Addison",
        "Issue": "Check fault and hump in floor",
        "Installer": "Darryl",
        "CustomerName": "Ryan Morris",
        "CustomerPhone": "02103222089 Suzi",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "suzi.im25@gmail.com",
        "GBStart": "Meridith Gilmour",
        "Status": "",
        "Notes": "Darryl to inspect",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "21/03/2016",
        "Address": "38 Tuatua Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Rowan Bezuidenhout",
        "CustomerPhone": "021 254 1989",
        "GBContact": "Brad White (Uni)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brad White (Uni)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/07/2017",
        "Address": "13 Mapou Rd Hobsonville",
        "Issue": "Fix stairs etc",
        "Installer": "Gabe",
        "CustomerName": "Rosie",
        "CustomerPhone": 273005497,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "15/06/2017",
        "Address": "15 Kahika Grove Huapai",
        "Issue": "attend to join",
        "Installer": "",
        "CustomerName": "Roger MacKellow",
        "CustomerPhone": 223130908,
        "GBContact": "Roger MacKellow",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Roger MacKellow",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/04/2017",
        "Address": "219 Wainui Rd Silverdale",
        "Issue": "lift carpet for floor remedial& return to refit",
        "Installer": "",
        "CustomerName": "Roger Lan",
        "CustomerPhone": "021 037 6846",
        "GBContact": "Universal Dean",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Universal Dean",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/09/2017",
        "Address": "227 Wainui Rd Silverdale",
        "Issue": "Refit and join carpet",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Robbie",
        "CustomerPhone": "021 2094220",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "29/03/2016",
        "Address": "15 Magnolia Lane Kaukapakapa",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Rob & Kaye Gunston",
        "CustomerPhone": 226809392,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/05/2016",
        "Address": "15 Magnolia Lane Kaukapakapa",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Rob & Kaye Gunston",
        "CustomerPhone": 226809392,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/04/2017",
        "Address": "49 Clemows Lane Albany FX client",
        "Issue": "restretch main bedroom",
        "Installer": "Ross",
        "CustomerName": "RM Power",
        "CustomerPhone": "027 216 5579",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "rmpower@xtra.co.nz",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "8/03/2018",
        "Address": "26 Rosalind Rd Glenfield",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Richard",
        "CustomerPhone": "021 683 054",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/03/2018",
        "Address": "12B Dida Park Ave Huapai",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Richard",
        "CustomerPhone": 211408880,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/01/2017",
        "Address": "15 Captain Mitchell Drive Papakura",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Rebekah Hooker",
        "CustomerPhone": 223773154,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/01/2017",
        "Address": "17 Swindon Close Mellons Bay",
        "Issue": "carpet needs restretch all over #830347",
        "Installer": "Ross",
        "CustomerName": "Rebecca Charlton",
        "CustomerPhone": 21673671,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "findbecs@yahoo.com",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/05/2017",
        "Address": "21 Rahotu Way Glenfield",
        "Issue": "re-stretch",
        "Installer": "",
        "CustomerName": "Ray mathews",
        "CustomerPhone": "",
        "GBContact": "Universal Dean",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Universal Dean",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/05/2017",
        "Address": "2 Huarahi Pai Rd",
        "Issue": "staple all tile transitions",
        "Installer": "",
        "CustomerName": "Ray",
        "CustomerPhone": "022 414 0041",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "15/12/2016",
        "Address": "3 Cornwall Pl Karaka",
        "Issue": "restretch whole house",
        "Installer": "Ross& Johnny",
        "CustomerName": "Raphael",
        "CustomerPhone": "027 7050878",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/02/2017",
        "Address": "19 Tennessee Rd Mangere",
        "Issue": "hit down smoothedge",
        "Installer": "Ross",
        "CustomerName": "Raj Prasad",
        "CustomerPhone": "",
        "GBContact": "Mavis GJ",
        "GB": "OMAHA HOLDINGS LTD",
        "CustomerEmail": "",
        "GBStart": "Mavis GJ",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "31/08/2017",
        "Address": "28 Outlook Terrace",
        "Issue": "tighten stairs",
        "Installer": "Ross",
        "CustomerName": "Rachel Atkinson",
        "CustomerPhone": "021 231 7073",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/09/2016",
        "Address": "28 Outlook Terrace",
        "Issue": "Bubbling Stairs",
        "Installer": "Darryl",
        "CustomerName": "Rachel",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "GB024",
        "Received": "30/06/2016",
        "Address": "Lot 15, 47 Liquidambar Dr Hobsonville",
        "Issue": "Refit carpet to stair treads before mid level landing",
        "Installer": "Matt",
        "CustomerName": "PM Delyse - 021 752 823. Tenant Kathleen - 021 128 1303",
        "CustomerPhone": "",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "TBF 5/7/16",
        "Notes": "Tenant moves in on 7th July",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/06/2016",
        "Address": "Lot 15, 47 Liquidambar Dr Hobsonville",
        "Issue": "Refit carpet to stair treads before mid level landing",
        "Installer": "Matt",
        "CustomerName": "PM Delyse - 021 752 823. Tenant Kathleen - 021 128 1303",
        "CustomerPhone": "",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "TBF 5/7/16",
        "Notes": "Tenant moves in on 7th July",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "1/06/2017",
        "Address": "33 Headland Dr Long Bay",
        "Issue": "carpet lifting",
        "Installer": "",
        "CustomerName": "Pia Wellingham",
        "CustomerPhone": "021 445 685",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/07/2017",
        "Address": "33 Headland Dr Long Bay",
        "Issue": "refit carpet and new smoothedge",
        "Installer": "",
        "CustomerName": "Pia Wellingham",
        "CustomerPhone": "021 445 685",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "7/10/2016",
        "Address": "28 Te Oneroa Way",
        "Issue": "Carpet loose on stairs",
        "Installer": "Ross",
        "CustomerName": "Pia",
        "CustomerPhone": "021 445 685",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/02/2018",
        "Address": "97 Glidepath Rd Hobsonville",
        "Issue": "carpet short up to tiles",
        "Installer": "Ross",
        "CustomerName": "Phillip Terris",
        "CustomerPhone": "021 073 7977",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/12/2017",
        "Address": "46 Onekiritea Rd Hobsonville",
        "Issue": "carpet short in lg",
        "Installer": "Rommel & Robert",
        "CustomerName": "Paul Westwood",
        "CustomerPhone": "022 4050709 Lauren",
        "GBContact": "Lauren (Uni)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Lauren (Uni)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/04/2017",
        "Address": "74 Caldera Dr Long Bay",
        "Issue": "repair carpet at stairs and refit to tiles",
        "Installer": "Ross",
        "CustomerName": "Paul Farnan",
        "CustomerPhone": 21648497,
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "24/03/2016",
        "Address": "23 Barcliff Terrace Gulf Harbour",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Paul Doesburg",
        "CustomerPhone": "021 0296 9142",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/02/2016",
        "Address": "1722 East Coast Rd Kaiaua",
        "Issue": "refit bar at kitchen",
        "Installer": "Ross",
        "CustomerName": "Paul Cronin GJ",
        "CustomerPhone": "021 846 909",
        "GBContact": "Paul Cronin",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Paul Cronin",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/04/2017",
        "Address": "43 Andrew Jack Rd Silverdale",
        "Issue": "Fix Stairs and carpet lifting",
        "Installer": "Gabe",
        "CustomerName": "Paul Chapman",
        "CustomerPhone": "021 235 3968",
        "GBContact": "Universal Dean",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Universal Dean",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/01/2018",
        "Address": "6 Ara Kakara Ave Huapai",
        "Issue": "carpet lifting",
        "Installer": "Ross",
        "CustomerName": "Patricia",
        "CustomerPhone": 211784880,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/06/2017",
        "Address": "5 Touhou Rd Hobsonville",
        "Issue": "Fix lump in stair",
        "Installer": "",
        "CustomerName": "Olivia",
        "CustomerPhone": "021 397 700",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/07/2017",
        "Address": "29 Andrew Jack Rd Silverdale",
        "Issue": "refit carpet under breakfast bar",
        "Installer": "",
        "CustomerName": "Oleg Bogomazov",
        "CustomerPhone": "021 105 2694",
        "GBContact": "Universal Tony",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Universal Tony",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/03/2016",
        "Address": "95 Hamilton Rd Snells Beach",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "Nyal Grant",
        "CustomerPhone": "021 757 988",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/06/2016",
        "Address": "578 Harris Drive",
        "Issue": "Bedroom uplifted, needs relaying",
        "Installer": "",
        "CustomerName": "None",
        "CustomerPhone": "None",
        "GBContact": "Paul Withers",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "paulw@universal.co.nz",
        "GBStart": "Paul Withers",
        "Status": "TBF 10/6/16",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/01/2017",
        "Address": "11B Riversdale Rd Avondale",
        "Issue": "Fit carpet to trims",
        "Installer": "Ross",
        "CustomerName": "Nick Pearson",
        "CustomerPhone": 21478852,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/10/2016",
        "Address": "280 Trig Rd Whitford",
        "Issue": "Stairs",
        "Installer": "Ross",
        "CustomerName": "Nick & Claire Grant",
        "CustomerPhone": "021 227 5118",
        "GBContact": "Christian",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Christian",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "31/01/2018",
        "Address": "93 Hillpark Dr Pokeno",
        "Issue": "carpet lifting",
        "Installer": "Ross",
        "CustomerName": "Nelly",
        "CustomerPhone": 210543529,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "5/07/2016",
        "Address": "10 Provence Esplanade, Te Atatu",
        "Issue": "Tuck carpet into smooth",
        "Installer": "Ross",
        "CustomerName": "Navin",
        "CustomerPhone": "021 839 780",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "grant e-mail",
        "Notes": "Pending contact with Ross",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/09/2017",
        "Address": "17 Saltmarsh Rd Hobsonville",
        "Issue": "tuck in stairs",
        "Installer": "Ross",
        "CustomerName": "Natalie",
        "CustomerPhone": 211940434,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "18/11/2016",
        "Address": "lot 13 47 Yates Rd Mangere",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "Naresh",
        "CustomerPhone": 221858193,
        "GBContact": "Ryan Meynell",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Ryan Meynell",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/06/2016",
        "Address": "47 Madison Tce, Millwater",
        "Issue": "Replace removed carpet from cupboard after flood. Carpet in garage",
        "Installer": "",
        "CustomerName": "Nancy Zhang",
        "CustomerPhone": "021 801 926",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "TBF 21/6/16 9:30",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/02/2016",
        "Address": "40 Outlook Tce Millwater",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Mr Cochrane",
        "CustomerPhone": "021 337 734",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/02/2017",
        "Address": "32 Beachwood Drive Hatfields Beach",
        "Issue": "re-stretch",
        "Installer": "Ross",
        "CustomerName": "Mr & Mrs Ball (GJ Clients)",
        "CustomerPhone": "021 131 8101",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/06/2017",
        "Address": "47 Mapou Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Moore",
        "CustomerPhone": 21478113,
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "11/07/2017",
        "Address": "47 Mapou Rd Hobsonville",
        "Issue": "refit flooded carpet",
        "Installer": "",
        "CustomerName": "Moore",
        "CustomerPhone": 21478113,
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "26/01/2017",
        "Address": "46 Moira Drive Tuakau",
        "Issue": "Carpet worn badly for being installed 1yr underlay faulty",
        "Installer": "Ross",
        "CustomerName": "Monique Francis",
        "CustomerPhone": 211547456,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Inspected by Ross",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "11/08/2017",
        "Address": "20E Merfield St GI",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "Monique",
        "CustomerPhone": "021 02008292",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/07/2017",
        "Address": "192 Hobsonville Pt Rd",
        "Issue": "Restretch stairs",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Mitchell Nook",
        "CustomerPhone": 223540116,
        "GBContact": "Gail Blair(Universal)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Gail Blair(Universal)",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/12/2016",
        "Address": "3/15 Sprott Rd",
        "Issue": "refit carpet where lifting",
        "Installer": "Ross",
        "CustomerName": "Mike Maloney",
        "CustomerPhone": "021 777 303",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 22741,
        "Received": "15/04/2016",
        "Address": "3 McCall Drive, Waiuku",
        "Issue": "Carpet lifting in hallway",
        "Installer": "Darryll",
        "CustomerName": "Michelle Lennard",
        "CustomerPhone": "021 128 7964",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "TBF 16/05/16",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": 42571,
        "Address": "72 Eighth View Ave, Beachlands",
        "Issue": "Kick carpet onto smoothedge at ensuite door",
        "Installer": "Kelvin/Darryl",
        "CustomerName": "Michele Matheson",
        "CustomerPhone": "021 474 221- 9787080",
        "GBContact": "GJ Angela Munro",
        "GB": "",
        "CustomerEmail": "mikeandmichelle@vodafone.co.nz",
        "GBStart": "GJ Angela Munro",
        "Status": "Completed",
        "Notes": "Ross completed",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/11/2017",
        "Address": "4 Captain Mitchell Drive Papakura",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Michael(Tenant)",
        "CustomerPhone": 277273018,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/06/2017",
        "Address": "12 Captain Mitchell Drive Papakura",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Michael(Tenant)",
        "CustomerPhone": "",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/04/2017",
        "Address": "168 Hobsonville Pt Rd",
        "Issue": "repair lg floor and relay",
        "Installer": "Andrew Walker",
        "CustomerName": "Michael Brecknell",
        "CustomerPhone": 212633142,
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/07/2016",
        "Address": "Lot1 15 Turua Rise Karaka",
        "Issue": "Knock down pins  and scrape paint from carpet",
        "Installer": "Ross",
        "CustomerName": "Melissa Mills",
        "CustomerPhone": "021 402 402",
        "GBContact": "Universal Dean",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Universal Dean",
        "Status": "Completed",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/12/2016",
        "Address": "16 Tuatua Rd Hobsonville",
        "Issue": "hit down smoothedge on stairs",
        "Installer": "Ross",
        "CustomerName": "Melissa Lou",
        "CustomerPhone": "",
        "GBContact": "Damon Hoskins",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Damon Hoskins",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E0060",
        "Received": 42514,
        "Address": "3 Floyd Road, Riverhead",
        "Issue": "Edges coming up and vinyl adhesive left on top of joins",
        "Installer": "Dave Walker",
        "CustomerName": "Melissa",
        "CustomerPhone": "021 0279 7058",
        "GBContact": "Brett Lennon",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett Lennon",
        "Status": "TBF 1.06.16",
        "Notes": "1-130pm check vinyl planks take photos. Naplock is dented, require replacement.",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E8871",
        "Received": "30/05/2016",
        "Address": "5 Portofino Point Karaka",
        "Issue": "Carpet lifting in hallway",
        "Installer": "Matt",
        "CustomerName": "Megren",
        "CustomerPhone": "021 45 747 8",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "TBF 02.05.16",
        "Notes": "TBF Thur 2nd 4pm",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/03/2018",
        "Address": "37 Resolution Dr Gulf Harbour",
        "Issue": "carpet lifting at tiles and joins",
        "Installer": "Ross",
        "CustomerName": "Meghan Heaney",
        "CustomerPhone": "021 180 3462",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/03/2018",
        "Address": "20 Mollusc Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Megan",
        "CustomerPhone": 211143300,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "22/03/2016",
        "Address": "36 Tuatua Rd Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "Max Wong",
        "CustomerPhone": "022 360 6128",
        "GBContact": "Brad Small Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brad Small Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "12/09/2017",
        "Address": "21 Park Grove Cr Pokeno",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Matthew Mowbray",
        "CustomerPhone": 21810440,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "1/06/2017",
        "Address": "60 Seventh View Ave Beachlands",
        "Issue": "re-fit popped smoothedge",
        "Installer": "Darryl",
        "CustomerName": "Matt & Alicia Pratt",
        "CustomerPhone": "021 379 813 Matt",
        "GBContact": "MavisTulima",
        "GB": "OMAHA HOLDINGS LTD",
        "CustomerEmail": "",
        "GBStart": "MavisTulima",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/04/2017",
        "Address": "5 Arriere Lane Millwater",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Maryanne",
        "CustomerPhone": "027 445 2423",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "18/08/2017",
        "Address": "84 Squadron Dr Hobsonville",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "Mark Minors",
        "CustomerPhone": "021 1083477",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/03/2018",
        "Address": "17 Arrier Lane Millwater",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Marj Noble",
        "CustomerPhone": "021 711 540",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "11/04/2017",
        "Address": "29 Saltmarsh Rd Hobsonville",
        "Issue": "Refit carpet and small amount levelling",
        "Installer": "Matt",
        "CustomerName": "Marissa",
        "CustomerPhone": "021 025 46813",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Matt",
        "Notes": "Matt completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "14/06/2017",
        "Address": "36 Doment Cr Orewa",
        "Issue": "Johnny to powerstretch carpet to naplock",
        "Installer": "Kelvin",
        "CustomerName": "Marie Hansen",
        "CustomerPhone": 276638696,
        "GBContact": "Marie(Uni)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Marie(Uni)",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "11/04/2017",
        "Address": "36 Doment Cr Orewa",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "Marie Hansen",
        "CustomerPhone": 21998301,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 3011,
        "Received": 42508,
        "Address": "12 Pitoitoi Drive, Riverhead",
        "Issue": "Foul smell eminating from corner of room. Uplift carpet and relay once issue resolved",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Marie",
        "CustomerPhone": "027 243 0300",
        "GBContact": "Brett Lennon",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett Lennon",
        "Status": "TBF 3.06.16",
        "Notes": "Andy Belcher - Builder repairing wall, not ready until Wed 1st. 027525 9799",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "9/05/2016",
        "Address": "11 Remana Crescent, Huapai",
        "Issue": "Two walls have been fixed, replacement from lift",
        "Installer": "Matthew",
        "CustomerName": "Maria",
        "CustomerPhone": "021 261 5206",
        "GBContact": "Brett Lennon",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett Lennon",
        "Status": "11/05/2016",
        "Notes": "Johnny to fix",
        "Advised": "",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "20/09/2017",
        "Address": "20 Fermier Greens",
        "Issue": "trim carpet",
        "Installer": "Ross",
        "CustomerName": "Marcola Oliver",
        "CustomerPhone": 223509389,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/06/2017",
        "Address": "Hull Rd Waitoki",
        "Issue": "lay carpet up to laminate",
        "Installer": "",
        "CustomerName": "Mandy Mitten",
        "CustomerPhone": "021 618 775",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 89,
        "Received": "28/06/2018",
        "Address": "11 FLOYD ROAD, RIVERHEAD",
        "Issue": "Rodney",
        "Installer": "REPAIR/FIX CARPET AFTER LEAK - ROSS BOOKED THURSDAY 3.30PM 28/06/2018",
        "CustomerName": "MADISON PARK HOMES LTD",
        "CustomerPhone": "",
        "GBContact": "021-264 6036",
        "GB": "",
        "CustomerEmail": "CLAIRE",
        "GBStart": "021-264 6036",
        "Status": "",
        "Notes": "ROSS MURRAY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "EO122",
        "Received": "3/08/2016",
        "Address": "38 Liquidambar Dr Hobsonville",
        "Issue": "tidy up all areas, need to go back grind concrete+cupboard re layed",
        "Installer": "Andrew",
        "CustomerName": "Lyshan Bailey",
        "CustomerPhone": 21819768,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "ross doing 3/8/16",
        "Notes": "All completed except for grind concrete",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "EO122",
        "Received": "23.3.2017",
        "Address": "38 Liquidambar Dr Hobsonville",
        "Issue": "carpet lifting on stairs",
        "Installer": "Andrew",
        "CustomerName": "Lyshan Bailey",
        "CustomerPhone": 21819768,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/09/2017",
        "Address": "91 Valley Rd Pukekohe",
        "Issue": "refit lifting carpet",
        "Installer": "Ross",
        "CustomerName": "Lynn",
        "CustomerPhone": 272977419,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/03/2016",
        "Address": "16 Whaley Greens Millwater",
        "Issue": "restretch stairs",
        "Installer": "Kelvin",
        "CustomerName": "Lusher",
        "CustomerPhone": "0224 782706",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "6/04/2018",
        "Address": "3C Kiokio St Long Bay",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Luong",
        "CustomerPhone": "021 680 386",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "22/08/2017",
        "Address": "37 Ormonde Dr Millwater",
        "Issue": "refit lifting carpet",
        "Installer": "Ross",
        "CustomerName": "Luke",
        "CustomerPhone": "021 052 8137",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/06/2017",
        "Address": "84 Caldera Dr Long Bay",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Lucinda",
        "CustomerPhone": "021 028 21488",
        "GBContact": "Gail Blair(Universal)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Gail Blair(Universal)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2016",
        "Address": "1 Resolution Dr Fairway Bay",
        "Issue": "join new carpet to doorway",
        "Installer": "Dave",
        "CustomerName": "Louis & Stacey Nel",
        "CustomerPhone": 212775445,
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Dave",
        "Notes": "Dave completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/06/2016",
        "Address": "30 Tuatua Rd Hobsonville",
        "Issue": "refit carpet lifted",
        "Installer": "",
        "CustomerName": "Lossie",
        "CustomerPhone": "021 240 8383",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/03/2018",
        "Address": "18 Raithburn Terrace Pokeno",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Lindsey",
        "CustomerPhone": "0275 991 254",
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 830449,
        "Received": "1/04/2016",
        "Address": "8 Artists Ave, Beachlands",
        "Issue": "Pins felt through carpet in numerous areas",
        "Installer": "Kelvin",
        "CustomerName": "Lindsay",
        "CustomerPhone": "021 398 925",
        "GBContact": "Soane Wainiqolo",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Soane Wainiqolo",
        "Status": "TBF 20/6/16 930am",
        "Notes": "GJ's to do work before FJ. Lift and replace. - Extra FJ work than listed on this order. Work done, carpet to be relaid",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/07/2017",
        "Address": "9A Routley Ave Pukekohe",
        "Issue": "carpet badly fading under mat",
        "Installer": "Darryl",
        "CustomerName": "Linda Chapman",
        "CustomerPhone": 226351980,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "2/06/2017",
        "Address": "5 Mapou Rd Hobsonville",
        "Issue": "carpet lifting in several areas + stairs",
        "Installer": "",
        "CustomerName": "Lianne Maude",
        "CustomerPhone": "021 875 454",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "15/11/2017",
        "Address": "24 Eric Farley Drive Huapai",
        "Issue": "refit lifting carpet",
        "Installer": "Ross",
        "CustomerName": "Les Gates",
        "CustomerPhone": 21353160,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/06/2017",
        "Address": "199 Wainui Rd Silverdale",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Lee",
        "CustomerPhone": 212346906,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "8/06/2017",
        "Address": "8B Huarahi Pai Rd Huapai",
        "Issue": "relay flood damaged carpet",
        "Installer": "",
        "CustomerName": "Lee",
        "CustomerPhone": "021 079 6710",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "12/09/2017",
        "Address": "13 Captain Mitchell Drive Papakura",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Latham(Tenant)",
        "CustomerPhone": 275252810,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "29/04/2017",
        "Address": "16 Riverleigh Dr Snells Beach",
        "Issue": "Flood damage, suggested clean/insurance claim",
        "Installer": "",
        "CustomerName": "Lance Moncrieff",
        "CustomerPhone": "027 4444 257",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "EO258",
        "Received": "27/07/2016",
        "Address": "Lot 12, 32 Capriole Cres Karaka",
        "Issue": "Join in Lounge",
        "Installer": "Darryl",
        "CustomerName": "Lachlan Downing",
        "CustomerPhone": "0275 388948",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "meridith.gilmour@gjgardner.co.nz",
        "GBStart": "Meridith Gilmour",
        "Status": "Completed",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 22815,
        "Received": "9/05/2016",
        "Address": "17 Captain Mitchell Drive, Papakura",
        "Issue": "Carpet lifting by ranch slider in hallway",
        "Installer": "Kelvin",
        "CustomerName": "Krishna",
        "CustomerPhone": "021 0827 5847",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "TBF 13/05/16",
        "Notes": "Elderly woman home all day",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/08/2017",
        "Address": "80 Squadron Dr Hobsonville",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "Kirsty-Lee Venter",
        "CustomerPhone": "021 070 3962",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/04/2017",
        "Address": "80 Squadron Dr",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Kirsty Lee-Venter",
        "CustomerPhone": "",
        "GBContact": "Damon Hoskins Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Damon Hoskins Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "",
        "Address": "2 Beacon Rd Riverhead",
        "Issue": "Lump under carpet in underlay",
        "Installer": "Ross",
        "CustomerName": "Kirsty",
        "CustomerPhone": "021 033 4307",
        "GBContact": "GJ Kim Ardin",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "GJ Kim Ardin",
        "Status": "Completed",
        "Notes": "Ross completed",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/06/2017",
        "Address": "14 Artist Ave Beachlands",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Kirstine Kelly",
        "CustomerPhone": "0274 402200",
        "GBContact": "Mavis GJ",
        "GB": "OMAHA HOLDINGS LTD",
        "CustomerEmail": "",
        "GBStart": "Mavis GJ",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E7752",
        "Received": "30/05/2016",
        "Address": "8 Cottage Court",
        "Issue": "Walls have been moved and missing two planks. Ghost gum",
        "Installer": "",
        "CustomerName": "Kieran",
        "CustomerPhone": "021 115 5309",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "TBF 20/6/16 12pm",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/03/2016",
        "Address": "8Aro Mato Pl Huapai",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Ki&Hoonjong Lee",
        "CustomerPhone": 21533797,
        "GBContact": "Dan Young Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Dan Young Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "5/04/2016",
        "Address": "8 Aro Mato Pl Huapai",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Ki&Hoonjong Lee",
        "CustomerPhone": 21533797,
        "GBContact": "Dan Young Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Dan Young Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/04/2017",
        "Address": "25 Liquidambar Dr Hobsonville",
        "Issue": "Fix Stairs",
        "Installer": "Kelvin",
        "CustomerName": "Kevin Lidgard",
        "CustomerPhone": "0275 469 921",
        "GBContact": "Universal Dean",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Universal Dean",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/05/2017",
        "Address": "15 Floyd Rd Riverhead",
        "Issue": "carpet lifting",
        "Installer": "",
        "CustomerName": "Keryn Algie",
        "CustomerPhone": 21552582,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "29/04/2017",
        "Address": "15 Floyd Rd Riverhead",
        "Issue": "carpet lifting",
        "Installer": "",
        "CustomerName": "Keryn Algie",
        "CustomerPhone": "021 552 582",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/11/2017",
        "Address": "5 Steamer Rd Silverdale",
        "Issue": "bubble in floor under planks",
        "Installer": "Cole",
        "CustomerName": "Kerry Edmondson",
        "CustomerPhone": "027 244 4391",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Dave",
        "Notes": "Dave completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/06/2017",
        "Address": "9 Touhou Rd Hobsonville",
        "Issue": "lift carpet for floor remedial& return to refit",
        "Installer": "",
        "CustomerName": "Kennedy",
        "CustomerPhone": "021 588 591 Rhys",
        "GBContact": "Rhys Baker Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Rhys Baker Universal",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/10/2017",
        "Address": "9 Touhou Rd Hobsonville",
        "Issue": "replace front bedroom robe",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Kennedy",
        "CustomerPhone": 21786468,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "13/12/2016",
        "Address": "8 Deverell Pl Northcross",
        "Issue": "restretch 3 bedrooms (Jared laid)",
        "Installer": "Jared",
        "CustomerName": "Kelly Wills",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/01/2018",
        "Address": "117 Matua Rd Huapai",
        "Issue": "replace smoothedge and refit carpet",
        "Installer": "Ross",
        "CustomerName": "Kelly",
        "CustomerPhone": 21595685,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "7/03/2018",
        "Address": "3 Te Makuru Lane Maraetai",
        "Issue": "carpet lifting at ranchslider (concrete breaking away)",
        "Installer": "Ross",
        "CustomerName": "Kaye Baldwin",
        "CustomerPhone": 212860944,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/11/2016",
        "Address": "29 Captain Mitchell Dr Papakura",
        "Issue": "refit carpet around ranchsliders",
        "Installer": "Ross",
        "CustomerName": "Kate Ryder",
        "CustomerPhone": "027 889 5498",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "kate@bhwl.co.nz",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "21/11/2017",
        "Address": "51 Mapou Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Karen",
        "CustomerPhone": 21622004,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": 101505,
        "Received": "20/05/2016",
        "Address": "15 Kohia Way, Huapai",
        "Issue": "High traffic areas waring badly",
        "Installer": "",
        "CustomerName": "Karen",
        "CustomerPhone": "",
        "GBContact": "Brett Lennon",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett Lennon",
        "Status": "Assess 27.05.16",
        "Notes": "Normal track and shade listed by Grant T. Believes more foot traffic will flatten carpet and joins",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/03/2016",
        "Address": "18 Tuatua Rd Hobsonville",
        "Issue": "carpet lifting at tiles and lump in underlay",
        "Installer": "",
        "CustomerName": "Kadriye Kaya",
        "CustomerPhone": "027 777 6694",
        "GBContact": "Paul Westwood",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "paulwe@universal.co.nz",
        "GBStart": "Paul Westwood",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/02/2018",
        "Address": "47 Mapou Rd Hobsonville",
        "Issue": "carpet lifting at ranchslider and stairs",
        "Installer": "Ross",
        "CustomerName": "Justin",
        "CustomerPhone": "021 478 113",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "21/04/2017",
        "Address": "Judy Howe",
        "Issue": "restretch",
        "Installer": "Ross",
        "CustomerName": "Judy",
        "CustomerPhone": 4799773,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "3/11/2017",
        "Address": "18c Torrington Cres Glen Innes",
        "Issue": "bubble in floor under vanity",
        "Installer": "Kane",
        "CustomerName": "Josh",
        "CustomerPhone": 2102203214,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Kane",
        "Notes": "Kane completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "29/11/2017",
        "Address": "22 Merfield St GI",
        "Issue": "refit carpet where lifted for repairs",
        "Installer": "Ross",
        "CustomerName": "Josh",
        "CustomerPhone": "027 463 5038",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/02/2016",
        "Address": "1 malbec Pl Huapai",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Joseph",
        "CustomerPhone": 21454702,
        "GBContact": "Gail Blair(Universal)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Gail Blair(Universal)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/03/2016",
        "Address": "28 Tilden Ave Hillcrest (FX client)",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Jonathan Whittaker",
        "CustomerPhone": "0211 475591",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/07/2017",
        "Address": "157 Hobsonville Pt Rd",
        "Issue": "Restretch stairs",
        "Installer": "",
        "CustomerName": "Jonathan",
        "CustomerPhone": 220372787,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/06/2016",
        "Address": "11 Woodridge Drive, Stanmore Bay",
        "Issue": "New smooth edge required due to leak",
        "Installer": "Someone from GJ completed",
        "CustomerName": "John Pearce",
        "CustomerPhone": "021 256 5416",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Phoned John",
        "Notes": "Needs builder to attend to skirting first. Samantha in contact",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 23202,
        "Received": "6/05/2016",
        "Address": "984 Paerata Road",
        "Issue": "Carpet in front of ranch slider not fixed down properly",
        "Installer": "Darryll",
        "CustomerName": "John Oliver",
        "CustomerPhone": "027 730 9292",
        "GBContact": "Meredith Gilmour",
        "GB": "",
        "CustomerEmail": "john@mcdni.co.nz",
        "GBStart": "Meredith Gilmour",
        "Status": "9/05/2016",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "31/08/2016",
        "Address": "32 Liquidambar Dr Hobsonville",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "John Lee",
        "CustomerPhone": 2040896257,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "15/11/2016",
        "Address": "32 Liquidambar Dr Hobsonville",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "John Lee",
        "CustomerPhone": 2040896257,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/01/2017",
        "Address": "33 Headland Dr Long Bay",
        "Issue": "carpet lifting",
        "Installer": "Ross",
        "CustomerName": "John & Pia Wellingham",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/07/2017",
        "Address": "21 Onekiritea Rd Hobsonville",
        "Issue": "Re stretch all stairs",
        "Installer": "Andrew & Richard",
        "CustomerName": "Joel Bayangos",
        "CustomerPhone": "021 0266 4443",
        "GBContact": "Gail Blair(Universal)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Gail Blair(Universal)",
        "Status": "Fixed by Andrew",
        "Notes": "Andrew completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "24/02/2016",
        "Address": "26D Moses Rd Kaukapakapa",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Jodie",
        "CustomerPhone": "09420 4244",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley GJ",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/08/2017",
        "Address": "34 Tuatua Rd Hobsonville",
        "Issue": "refit carpet 7 knock down pins",
        "Installer": "",
        "CustomerName": "Jin Moon",
        "CustomerPhone": "027 973 6969",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/08/2017",
        "Address": "3B Hobbs Rd Whangaparaoa",
        "Issue": "lump under vinyl",
        "Installer": "Dave",
        "CustomerName": "Jim & Kathy Stevens",
        "CustomerPhone": 212704720,
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Dave",
        "Notes": "Dave  completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/04/2018",
        "Address": "LOT 3B HOBBS RD, WHANGAPARAOA",
        "Issue": "CARPET EDGE",
        "Installer": "ROSS",
        "CustomerName": "JIM",
        "CustomerPhone": "021-270 4720",
        "GBContact": "GJG RODNEY",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "GJG RODNEY",
        "Status": "Fixed by Ross",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/03/2018",
        "Address": "125 Hobsonville Pt Rd",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Jia",
        "CustomerPhone": "021 035 3678",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/02/2016",
        "Address": "31 Onekiritea Rd Hobsonville",
        "Issue": "Re stretch all stairs",
        "Installer": "Ross",
        "CustomerName": "Jeremy Duffin",
        "CustomerPhone": "021 129 5050",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/08/2016",
        "Address": "25 Paso Fino Cres Kingseat",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "Jenny Lee",
        "CustomerPhone": 2102401457,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "mitchelljennylee@gmail.com",
        "GBStart": "Meridith Gilmour",
        "Status": "ross doing 4/8/16",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/05/2017",
        "Address": "18 Huarahi Pai Rd GB327",
        "Issue": "Norm Hunt fixed all Lee cock ups",
        "Installer": "Lee",
        "CustomerName": "Jenny",
        "CustomerPhone": "021 042 7159",
        "GBContact": "Kara",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara",
        "Status": "Fixed by Norm Hunt",
        "Notes": "Norn completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/03/2016",
        "Address": "21 Aporo Dr Huapai",
        "Issue": "Carpet lifting in 2 corners",
        "Installer": "Ross",
        "CustomerName": "Jennifer McKay",
        "CustomerPhone": 2102637085,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah GJ",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/03/2016",
        "Address": "164 Hobsonville Pt Rd",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Jeff Paul",
        "CustomerPhone": "021 507 270",
        "GBContact": "Damon Hoskins Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Damon Hoskins Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/07/2017",
        "Address": "164 Hobsonville Pt Rd",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Jeff",
        "CustomerPhone": "021 507 270",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/03/2016",
        "Address": "35 Saltmarsh Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Jay",
        "CustomerPhone": 2102599559,
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 101593,
        "Received": "10/05/2016",
        "Address": "12 Belvedere Place, Warkworth",
        "Issue": "Carpet lifting around kitchen tiles, master bedroom, garage door and front counter. Carpet in WIR does not meet skirting. Hard lump in underlay",
        "Installer": "George",
        "CustomerName": "Jason",
        "CustomerPhone": "0274 88 4610",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "TBF 18/05/2016",
        "Notes": "Glue woven into backing, with Grant T now.",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/03/2016",
        "Address": "25 Cape Cod Dr Gulf Harbour",
        "Issue": "carpet needs restretch all overBrett Amos",
        "Installer": "Brett Amos",
        "CustomerName": "Janine Wells",
        "CustomerPhone": 274305189,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "Universal",
        "GBStart": "Ian Donachie",
        "Status": "To be done ross/john",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/03/2016",
        "Address": "25 Cape Cod Dr Gulf Harbour",
        "Issue": "Re-Stretch with Johnny",
        "Installer": "Brett Amos",
        "CustomerName": "Janine Wells",
        "CustomerPhone": "0274 305 189",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/04/2017",
        "Address": "86 Squadron Dr Hobsonville",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "janie patroni",
        "CustomerPhone": "",
        "GBContact": "Damon Hoskins Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Damon Hoskins Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "11/03/2016",
        "Address": "37 Discovery Dr Gulf Harbour",
        "Issue": "carpet lifting & delaminating",
        "Installer": "Gabe",
        "CustomerName": "Jamie Clutterbuck",
        "CustomerPhone": "021 232 6784",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "To be repaired",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "25/11/2017",
        "Address": "53 Mapou Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Jae",
        "CustomerPhone": 210620705,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "3/03/2018",
        "Address": "2F Spotted Dove Rd Hobsonville",
        "Issue": "carpet lifting",
        "Installer": "Ross",
        "CustomerName": "Jacky",
        "CustomerPhone": 211112281,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "2/09/2017",
        "Address": "2 Spotted Dove Rd Hobsonville",
        "Issue": "trim carpet",
        "Installer": "Ross",
        "CustomerName": "Jackie Boyd",
        "CustomerPhone": 211112281,
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2018",
        "Address": "24 Makatiti St Puke",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Iona Cussen",
        "CustomerPhone": 2102718217,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "24/03/2016",
        "Address": "196 Hobsonville Pt Rd",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Ian Tay",
        "CustomerPhone": "021 041 7766",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/10/2016",
        "Address": "7 Laly Haddon Place, Matakana",
        "Issue": "Refit to wall and tile",
        "Installer": "Ross",
        "CustomerName": "Ian Tarpey",
        "CustomerPhone": "027 715 9359",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/10/2016",
        "Address": "49 Westmuir Cres Pokeno",
        "Issue": "Fraying edges by 3 ranch sliders",
        "Installer": "Darryl",
        "CustomerName": "Ian Brearley",
        "CustomerPhone": "027 488 2138",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Darryl",
        "Notes": "Darryl completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E9419",
        "Received": "20/06/2016",
        "Address": "7 Laly Haddon Place, Matakana",
        "Issue": "Carpet is pulling away from smooth edge",
        "Installer": "",
        "CustomerName": "Ian and Sally",
        "CustomerPhone": "021 184 6850",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "TBF 7/7/16 10:30am",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/03/2018",
        "Address": "48 Onekiritea Rd Hobsonville",
        "Issue": "fix stairs",
        "Installer": "Ross",
        "CustomerName": "Iain",
        "CustomerPhone": "02188 6863",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/03/2016",
        "Address": "45 Barcliff Tce Gulf Harbour",
        "Issue": "3 stairs re-stretch",
        "Installer": "Ross",
        "CustomerName": "Hennie",
        "CustomerPhone": 21827622,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "Universal",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/07/2016",
        "Address": "10 Gulf Crest, Bucklands Beach",
        "Issue": "Kick carpet onto smoothedge at ensuite door",
        "Installer": "Ross",
        "CustomerName": "Helen Tan",
        "CustomerPhone": "0274 428 638",
        "GBContact": "GJ Angela Munro",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "GJ Angela Munro",
        "Status": "Completed",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/05/2017",
        "Address": "18B Martindale Lane Tuakau",
        "Issue": "carpet lifting in several areas",
        "Installer": "Andrew Walker",
        "CustomerName": "Hayley Thompson",
        "CustomerPhone": 21702872,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "hayleyt@nzinvest.co.nz",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/03/2016",
        "Address": "5 Kuawa Dr Huapai",
        "Issue": "replace s/e and refit water damage",
        "Installer": "Ross",
        "CustomerName": "Hayley Arnold",
        "CustomerPhone": 2102603577,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "9/04/2018",
        "Address": "7 Chaffinch Rd Hobsonville",
        "Issue": "need to improve join",
        "Installer": "Grant",
        "CustomerName": "Hannah Kelly",
        "CustomerPhone": "021 0269 4420",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/02/2018",
        "Address": "1 Andrew Jack Rd Silverdale",
        "Issue": "Carpet loose",
        "Installer": "Ross",
        "CustomerName": "Hannah",
        "CustomerPhone": "021 261 7684",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/06/2017",
        "Address": "20 Tuatua Rd Hobsonville",
        "Issue": "carpet lifting in ares & restretch stairs",
        "Installer": "",
        "CustomerName": "Gregory",
        "CustomerPhone": "021 2448921  Gregory",
        "GBContact": "Morne Botha Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "greg.vaughan@edlfast.co.nz",
        "GBStart": "Morne Botha Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/03/2018",
        "Address": "1 Copestake Lane Warkworth",
        "Issue": "trim sprouted carpet",
        "Installer": "Ross",
        "CustomerName": "Greg Powell",
        "CustomerPhone": "027 470 1028",
        "GBContact": "Ricky Sampson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Ricky Sampson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/10/2016",
        "Address": "26 Pioneer Rise Millwater",
        "Issue": "carpet lifting on landings",
        "Installer": "Ross",
        "CustomerName": "Greg & Rachel Brand",
        "CustomerPhone": "021 191 2621  Greg",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/04/2018",
        "Address": "LOT 18, 26 PIONEER RISE, MILLWATER",
        "Issue": "FIX CARPET BACK DOWN - CHARGED",
        "Installer": "ROSS",
        "CustomerName": "GREG",
        "CustomerPhone": "021-191 2621",
        "GBContact": "GJG RODNEY",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "GJG RODNEY",
        "Status": "Fixed by Ross",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E9264",
        "Received": "3/06/2016",
        "Address": "15A Inglewood Street, Wai O Taki Bay",
        "Issue": "Carpet pulling off stairs",
        "Installer": "Kelvin",
        "CustomerName": "Graham",
        "CustomerPhone": "021 847 939",
        "GBContact": "Angela Munro",
        "GB": "",
        "CustomerEmail": "graham.kock@gmail.com",
        "GBStart": "Angela Munro",
        "Status": "TBF 29/6/16 930am",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/03/2016",
        "Address": "64 Harris Dr Millwater",
        "Issue": "carpet lifting at tiles",
        "Installer": "AK Flooring",
        "CustomerName": "Graeme Sorenson",
        "CustomerPhone": 274987865,
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/05/2017",
        "Address": "28 Portland Park Millwater",
        "Issue": "carpet lifting",
        "Installer": "",
        "CustomerName": "Graeme Osborne",
        "CustomerPhone": "027 245 8822",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "graemarj@xtra.co.nz",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/03/2016",
        "Address": "13 Oak Valley Rd Dairy Flat",
        "Issue": "Replace carpet in main bedroom",
        "Installer": "Matt",
        "CustomerName": "Glen McLeod",
        "CustomerPhone": 21835574,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/05/2017",
        "Address": "9 Barcliff Tce Gulf Harbour",
        "Issue": "Remove object under carpet in LG/Dining",
        "Installer": "",
        "CustomerName": "Glen Jujinovich",
        "CustomerPhone": 272853668,
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 66,
        "Received": "28/05/2018",
        "Address": "LOT 35, 111 KAREPIRO DRIVE, STANMORE BAY",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "CARPET LIFTING IN SMALL AREA ROSS 12.00PM 29/05/2018",
        "CustomerName": "GJG RODNEY",
        "CustomerPhone": "",
        "GBContact": "021 0239 3010",
        "GB": "",
        "CustomerEmail": "SUREKHA",
        "GBStart": "021 0239 3010",
        "Status": "",
        "Notes": "SAM HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 86,
        "Received": "25/06/2018",
        "Address": "11 KAURI HEART AVE, ADDISON",
        "Issue": "South",
        "Installer": "CARPET IN HALL LIFTING/NAILS ETC - ANDREW TO DO THIS WHEN INSTALLING GARAGE CARPET",
        "CustomerName": "GJG PAPAKURA",
        "CustomerPhone": "ANDREWS CARPETS",
        "GBContact": "021-990 867",
        "GB": "",
        "CustomerEmail": "BRIAR",
        "GBStart": "021-990 867",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 77,
        "Received": "5/06/2018",
        "Address": "15 KAPIA ST, BELMONT GB2028",
        "Issue": "South",
        "Installer": "INJOON WATER LEAK  INJOON BOOKED 21/07/2018 ROSS HAS FOLDER PO 060787 - TO CHARGE",
        "CustomerName": "GJG PAPAKURA",
        "CustomerPhone": "INJOON",
        "GBContact": "021-918 579",
        "GB": "",
        "CustomerEmail": "CHARL",
        "GBStart": "021-918 579",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 61,
        "Received": "16/05/2018",
        "Address": "HNZ HAPAI PRESIDENT BELGRAVE AND WIKI",
        "Issue": "SOUTH",
        "Installer": "3 HAPAI 32-34 PRESIDENT DOING 20/06/2018 BOOKED 9.30-2.00PM",
        "CustomerName": "GJG PAPAKURA",
        "CustomerPhone": "WAGE BOYS",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 30,
        "Received": "17/04/2018",
        "Address": "LOT 8, 90 MOUNT ALBION RISE, TAUPAKI",
        "Issue": "Rodney",
        "Installer": "CARPET LIFTING IN NUMEROUS - ROSS FIXING FRI 11/05/2018 3.30PM",
        "CustomerName": "GJ Rodney West",
        "CustomerPhone": "",
        "GBContact": "020-420 2122",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "DALLAS",
        "GBStart": "020-420 2122",
        "Status": "",
        "Notes": "GJG WEST",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/05/2016",
        "Address": "6 Aporo Dr Huapai",
        "Issue": "fit own carpet to robe",
        "Installer": "Johnny Nicholson",
        "CustomerName": "GJ Rodney West",
        "CustomerPhone": 94125371,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Johnny",
        "Notes": "To be done 31st May Johnny",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/06/2017",
        "Address": "3 Flavell Dr Millwater",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "GJ Rodney East",
        "CustomerPhone": "427 9231",
        "GBContact": "Ross Murray",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 45,
        "Received": "26/04/2018",
        "Address": "9 PAPA ORCHARD, HUAPAI",
        "Issue": "Rodney",
        "Installer": "CRACKLING UNDER CARPET - WAYNE WED 16/05/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "RODNEY RESIDENTIAL LTD",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "SARAH FOLEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 72,
        "Received": "7/06/2018",
        "Address": "LOT 1, 64 KAIPARA COAST H/W, HELENSVILLE",
        "Issue": "Rodney",
        "Installer": "DAMAGE TO WALLS - GJG TO INVOICE FLOORING JUNCTION FOR REPAIRS - FILE CLOSED",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "RODNEY RESIDENTIAL LTD",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 73,
        "Received": "7/06/2018",
        "Address": "23 HENLEY ROAD, KAUKAPAKAPA",
        "Issue": "Rodney",
        "Installer": "BUILDER UPLIFTED CARPET - FLOORING JUNCTION REINSTATED CARPET AS BEST AS POSSIBLE - FILE CLOSED",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "RODNEY RESIDENTIAL LTD",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "SAM HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 76,
        "Received": "13/06/2018",
        "Address": "LOTS 59, 60, 61 KAREPIRO DRIVE",
        "Issue": "Rodney",
        "Installer": "ROSS INSPECTING 13/06/2018 2.00PM",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "RODNEY RESIDENTIAL LTD",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 90,
        "Received": "2/07/2018",
        "Address": "15 JOHN ANDREW DRIVE, WARKWORTH",
        "Issue": "North",
        "Installer": "CARPET IN BEDROOM LIFTING - ROSS INSPECTING/FIXING 02/07/2018 OUT OF WARRANTY-SAM ADVISED",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "JOHN NICHOLSON",
        "GBContact": "09-422 2241",
        "GB": "",
        "CustomerEmail": "MIKE OR SUZANNE",
        "GBStart": "09-422 2241",
        "Status": "",
        "Notes": "SAMANTHA HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 20,
        "Received": "17/04/2018",
        "Address": "LOT 1, 16 LAGOON VIEW HOBBS BAY",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "CARPET NOT SITTING FLAT -  DAVE BOOKED TUES 19/06/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "027-405 2989",
        "GB": "",
        "CustomerEmail": "ADAM",
        "GBStart": "027-405 2989",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/04/2018",
        "Address": "LOT 242, 16 WHALEY GREENS, MILLWATER",
        "Issue": "Rodney",
        "Installer": "VINYL / CARPET NEEDS TO BE FIXED  -  ROSS BOOKED 08/05/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "027-305 1817",
        "GB": "",
        "CustomerEmail": "GRANT",
        "GBStart": "027-305 1817",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 21,
        "Received": "17/04/2018",
        "Address": "LOT 1, 64 KAIPARA COAST H/W",
        "Issue": "Rodney",
        "Installer": "CARPET LOOKING OLD FOR WEAR Replacement arrived, - BOOKED FOR 09/05/2018 - DONE / CHARGED YES",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "027-283 3295",
        "GB": "",
        "CustomerEmail": "BRONWYN",
        "GBStart": "027-283 3295",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 10,
        "Received": "17/04/2018",
        "Address": "LOT 320, 11 FERMIER GREENS, MILLWATER",
        "Issue": "Rodney",
        "Installer": "GB0849 - REPAIR PLANKS - DAVE HAS PRODUCT - DONE!!@ 7.30 THURSDAY 24/05/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-806 083",
        "GB": "",
        "CustomerEmail": "STEVE",
        "GBStart": "021-806 083",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "18/4/2018 Ross inspected, need 1 box",
        "Chargeable": ""
      }, {
        "JobNumber": 62,
        "Received": "21/05/2018",
        "Address": "LOT 3, 25 HOBBS ROAD, MATAKATIA BAY",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "ROSS BOOKED 28/05/2018 MORNING CARPET REPAIR AS THE SMOOTH EDGE HAS COME AWAY FROM THE CONCRETE KITCHEN/FAMILY ROOM",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-530 166",
        "GB": "",
        "CustomerEmail": "KAREN BROOKE",
        "GBStart": "021-530 166",
        "Status": "",
        "Notes": "SAM HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 56,
        "Received": "7/05/2018",
        "Address": "LOT 9, 18 RESOLUTION DRIVE, WHANGA",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "NO WARRANTY FOR FADING - DAVE TO TIDY UP GAPS - 31/05/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-517 843",
        "GB": "",
        "CustomerEmail": "JACK AND LOUISE",
        "GBStart": "021-517 843",
        "Status": "",
        "Notes": "SAM HYLAND",
        "Advised": "",
        "Billed": "11/5/18 Inspected, send complaint",
        "Chargeable": ""
      }, {
        "JobNumber": 24,
        "Received": "17/04/2018",
        "Address": "LOT 96, 39 AURORA AVE, SNELLS BEACH",
        "Issue": "North",
        "Installer": "50/50 CHARGE OUT ON INSTALL - 2ND FAULT - CASH OFFER PAID -  deliver garage carpet in settlement",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-488 455",
        "GB": "",
        "CustomerEmail": "LYNNE",
        "GBStart": "021-488 455",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 17,
        "Received": "17/04/2018",
        "Address": "LOT 6, 12 RESOLUTION DRIVE, GULF HAR",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "VINYL FLOORING MESSY WITH GLUE AND JOINS - ROSS  SIGHTED 08/05/2018 - DAVE- COMPLETED",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-457 029",
        "GB": "",
        "CustomerEmail": "KIRSTY",
        "GBStart": "021-457 029",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 28,
        "Received": "17/04/2018",
        "Address": "LOT 3, 3B HOBBS RD, WHANGAPARAOA",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "VINYL LIFTING  DAVE COMPLETED 15/05/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-270 4720`",
        "GB": "",
        "CustomerEmail": "JIM",
        "GBStart": "021-270 4720`",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 79,
        "Received": "13/06/2018",
        "Address": "LOT 54, 37 DISCOVERY DRIVE, GH  -   E0127",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "CRACK IN CONCRETE - DAVE - GO AHEAD FIX NO MATTER WHAT 'SAM' PO 19471 ROSS HAS FOLDER",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-232 6784",
        "GB": "",
        "CustomerEmail": "JAMIE",
        "GBStart": "021-232 6784",
        "Status": "",
        "Notes": "SAMANTHA HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 1,
        "Received": "17/04/2018",
        "Address": "LOT 20, 23 TUATUA ROAD, HOBSONVILLE",
        "Issue": "Rodney",
        "Installer": "LOUNGE CARPET DIFFERENT COLOUR REPLACING CARPET - ROSS INSTALLING 12/05/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "GRANT",
        "GBContact": "021-216 8086",
        "GB": "",
        "CustomerEmail": "COURTNEY",
        "GBStart": "021-216 8086",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 101,
        "Received": "7/08/2018",
        "Address": "26 PIONEER RISE, MILLWATER",
        "Issue": "Rodney",
        "Installer": "CARPET FRAYING AT ENTRANCE TO ENSUITE- ROSS BOOKED THURSDAY 9.00AM 09/08/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "DARRYLL",
        "GBContact": "021-191 2621",
        "GB": "",
        "CustomerEmail": "GREG",
        "GBStart": "021-191 2621",
        "Status": "",
        "Notes": "SAMANTHA",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 26,
        "Received": "17/05/2018",
        "Address": "88 SOLAN DRIVE, WAIMAUKU",
        "Issue": "Rodney",
        "Installer": "DISCOLOURATION AROUND JOINS VINYL  -  DAVE COMPLETED THURSDAY 17/05/2018 ADVISED SARAH",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "DAVE WALKER",
        "GBContact": "021-121 9880",
        "GB": "",
        "CustomerEmail": "DEEP",
        "GBStart": "021-121 9880",
        "Status": "",
        "Notes": "SARAH FOLEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 19,
        "Received": "17/04/2018",
        "Address": "L0T 22,4 GRAPNEL ST PARKWAY ESTATE",
        "Issue": "Rodney",
        "Installer": "DISHWASHER LEAK REPAIR  - DAVE TO FIX AND CHARGE DIRECT",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "? CHARGE DIRECT",
        "GBContact": "021-112 0055",
        "GB": "",
        "CustomerEmail": "HENRY (BROTHER)",
        "GBStart": "021-112 0055",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "need to order plank &repair",
        "Chargeable": ""
      }, {
        "JobNumber": 93,
        "Received": "9/07/2018",
        "Address": "LOT 81, 13 MOTITI ST, WARKWORTH",
        "Issue": "NORTH",
        "Installer": "SOMETHING UNDER CARPET SPARE ROOM - MATT BOOKED FRI 20/07/2018 9.30AM",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "ROMMEL",
        "GBContact": "021-051 0529",
        "GB": "",
        "CustomerEmail": "EMMA",
        "GBStart": "021-051 0529",
        "Status": "",
        "Notes": "SAMANTHA HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 12,
        "Received": "17/04/2018",
        "Address": "LOT 103, 6 TIROHANGA CRES, STANMORE",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "DAVE DONE!!!!! - BRING OLD PLANKS BACK!!  TO INVOICE POLYFLOR",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-0263 3247",
        "GB": "",
        "CustomerEmail": "CORINNE",
        "GBStart": "021-0263 3247",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 80,
        "Received": "13/06/2018",
        "Address": "LOT 103, 6 TIROHANGA CRES, STANMORE BAY",
        "Issue": "Whangaparaoa Peninsula",
        "Installer": "CARPET COMING 'UNDONE' -  DAVE BOOKED TUES 19/06/2018",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-0263 3247",
        "GB": "",
        "CustomerEmail": "CORINNE",
        "GBStart": "021-0263 3247",
        "Status": "",
        "Notes": "SAMANTHA HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 9,
        "Received": "17/04/2018",
        "Address": "LOT 109, 18 ARRIERE LANE, MILLWATER",
        "Issue": "Rodney",
        "Installer": "JOINS - RYAN GJG TO CONTACT US - COLIN - FILE IS NOW CLOSED",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021-0227 7206",
        "GB": "",
        "CustomerEmail": "MELINDA",
        "GBStart": "021-0227 7206",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 81,
        "Received": "14/06/2018",
        "Address": "Lot 6, 3 CHAFFINCH RD",
        "Issue": "Rodney",
        "Installer": "LAY CARPET IN ENTRY CUPBOARD 14/6/18 Ross inspected, need carpet for cupboard(charge)",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "",
        "GBContact": "021 750 474",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "021 750 474",
        "Status": "",
        "Notes": "DEAN HODGSON",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 99,
        "Received": "31/07/2018",
        "Address": "LOT 97, 41 AUROA AVE, SNELLS BEACH",
        "Issue": "North",
        "Installer": "CARPET INPERFECTIONS - JOINS KELVIN BOOKED MON 06/08/2018 - BLUE KEY",
        "CustomerName": "GJ RODNEY",
        "CustomerPhone": "KELVIN",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "RICKY SAMPSON",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 47,
        "Received": "26/04/2018",
        "Address": "9 TAWAKI AVE, ADDISON PARK",
        "Issue": "South",
        "Installer": "RESULT - NEEDS POWER STRETCH!! TAINUI MEETING WITH KEITH MONDAY 30/07/2018",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "",
        "GBContact": "298 7977 BARFOOT",
        "GB": "",
        "CustomerEmail": "PEGGY FELL",
        "GBStart": "298 7977 BARFOOT",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 110,
        "Received": "31/08/2018",
        "Address": "13 CAPTAIN MITCHELL DRIVE, PAPAKURA",
        "Issue": "SOUTH",
        "Installer": "CARPET LIFTING BETWEEN KITCHEN TILES AND LOUNGE ROSS 04/09/2018",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "KELVIN/DARRYLL",
        "GBContact": "022-324 9714",
        "GB": "",
        "CustomerEmail": "TIMOTHY",
        "GBStart": "022-324 9714",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 85,
        "Received": "20/06/2018",
        "Address": "3B HILLPARK DRIVE POKENO",
        "Issue": "South",
        "Installer": "RESTRETCH CARPET BACK ON TO SMOOTHEDGE- ROSS DOING FRIDAY 22/06/2018",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "",
        "GBContact": "022 163 0270",
        "GB": "",
        "CustomerEmail": "KIMBERLEY",
        "GBStart": "022 163 0270",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 106,
        "Received": "28/08/2018",
        "Address": "LOT 19 FENCHURCH, GLEN INNES",
        "Issue": "SOUTH",
        "Installer": "NAILS FELT THROUGHT CARPET ON STAIRS- ROSS/MINESH 2.30PM 04/09/2018",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "FLOORBIZ",
        "GBContact": "021-990 162",
        "GB": "",
        "CustomerEmail": "MINESH",
        "GBStart": "021-990 162",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 84,
        "Received": "19/06/2018",
        "Address": "18 HELENVALE CRESCENT, POKENO",
        "Issue": "South",
        "Installer": "CARPET PULLING UP FROM UNDER TRIM - ANDREW DOING FRIDAY 22/06/2018",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "ANDREWS CARPETS",
        "GBContact": "021-978 798",
        "GB": "",
        "CustomerEmail": "STEFANIE",
        "GBStart": "021-978 798",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 46,
        "Received": "26/04/2018",
        "Address": "ESK ROAD, MIRANDA",
        "Issue": "South",
        "Installer": "RESTRETCH - DID KELVIN DO THIS 05/05/2018?????????",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "",
        "GBContact": "021-522 333",
        "GB": "",
        "CustomerEmail": "MAREE",
        "GBStart": "021-522 333",
        "Status": "",
        "Notes": "MERIDITH",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 100,
        "Received": "1/08/2018",
        "Address": "35 MCNALLY ROAD, PUKEKOHE",
        "Issue": "South",
        "Installer": "CARPET LIFTING FROM ENTRANCE TO ENSUITE - KELVIN BOOKED THUR 02/08/2018 'AM'",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "KELVIN",
        "GBContact": "021-068 7532",
        "GB": "",
        "CustomerEmail": "JACQUE SIMMONS",
        "GBStart": "021-068 7532",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 78,
        "Received": "24/05/2018",
        "Address": "29 SEARLE DR PATUMAHOE",
        "Issue": "South",
        "Installer": "REFIT CARPET AT TILES 13/06/2018 TODD RANG - ROSS Doing Friday June 15th",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "",
        "GBContact": "021 783 082",
        "GB": "",
        "CustomerEmail": "TODD",
        "GBStart": "021 783 082",
        "Status": "",
        "Notes": "AMANDA REID",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 97,
        "Received": "23/07/2018",
        "Address": "70A HILLPARK DRIVE POKENO",
        "Issue": "South",
        "Installer": "ROSS CONTACTED TENANT. BOOKED FRIDAY 27/07/2018",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "DARRYL CHURCH",
        "GBContact": "021 277 6227",
        "GB": "",
        "CustomerEmail": "SHANNON",
        "GBStart": "021 277 6227",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/05/2018",
        "Address": "18 CANINI GROVE KARAKA",
        "Issue": "SOUTH",
        "Installer": "CARPET FRAYING ROUND TILES",
        "CustomerName": "GJ PAPAKURA",
        "CustomerPhone": "",
        "GBContact": 92984645,
        "GB": "",
        "CustomerEmail": "JAN",
        "GBStart": 92984645,
        "Status": "",
        "Notes": "AMANDA",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/01/2018",
        "Address": "GJ Showhome Millwater",
        "Issue": "vinyl lifting",
        "Installer": "",
        "CustomerName": "GJ Gardner",
        "CustomerPhone": 94279231,
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "10/03/2018",
        "Address": "57 Colonial Dr Silverdale",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "George",
        "CustomerPhone": "027 279 9415",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "15/10/2016",
        "Address": "761 Woodcocks Rd warkworth",
        "Issue": "Vinyl planking  re glue",
        "Installer": "Cole",
        "CustomerName": "Gaye Ward",
        "CustomerPhone": "0274 838 949",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Dave",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 101564,
        "Received": "9/05/2016",
        "Address": "16 Pioneer Rise, Millwater",
        "Issue": "Vinyl sticking up in front of slider",
        "Installer": "Mark",
        "CustomerName": "Gary",
        "CustomerPhone": "021 244 6561",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "TBF 8th 430pm",
        "Notes": "Had photos through and Mark looking to attend week of 7th June",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/06/2016",
        "Address": "24 Riverhead Point Drive",
        "Issue": "2 lines across the carpet",
        "Installer": "",
        "CustomerName": "Gary",
        "CustomerPhone": "027 801 3241",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "gary.grenfell@swirecnco.com",
        "GBStart": "Ross Murray",
        "Status": "Inspection sent",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "27/09/2017",
        "Address": "56 Helenslee Rd Pokeno",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Garpell",
        "CustomerPhone": 220432951,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": 92,
        "Received": "3/07/2018",
        "Address": "LOT 13, 23 TE MAKURU LANE, MARAETAI",
        "Issue": "SOUTH",
        "Installer": "CARPET COMING AWAY FROM SMOOTHEDGE - BOOKED ROSS 06/07/2018 CLIENT HOME ALL DAY",
        "CustomerName": "G J MANUKAU",
        "CustomerPhone": "ANDREWS CARPETS",
        "GBContact": "021-0243 6226",
        "GB": "",
        "CustomerEmail": "IRINA",
        "GBStart": "021-0243 6226",
        "Status": "",
        "Notes": "MAVIS",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/02/2016",
        "Address": "12 Eric Farley Dr Huapai",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Fiona Murray 027 261 1939",
        "CustomerPhone": "",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley GJ",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/06/2017",
        "Address": "12 Eric Farley Dr Huapai",
        "Issue": "attend to crackle in floor",
        "Installer": "",
        "CustomerName": "Fiona Murray",
        "CustomerPhone": 272611939,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "24/11/2016",
        "Address": "1 Corsair St Hobsonville",
        "Issue": "repair carpet join opening up( De-Lamination)",
        "Installer": "Ross",
        "CustomerName": "Fiona (tenant)",
        "CustomerPhone": "021 107 9651",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "15/11/2017",
        "Address": "21 Meteor Rd Hobsonville",
        "Issue": "Stairs and fill hole",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Ferdinand",
        "CustomerPhone": 220218808,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Kelvin",
        "Notes": "Kelvin completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/11/2016",
        "Address": "64 Cape Cod Dr Gulf Harbour",
        "Issue": "Fix stair and fit underlay in step to entry",
        "Installer": "Ross",
        "CustomerName": "Fay Tikey",
        "CustomerPhone": 275477007,
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "24/02/2016",
        "Address": "367 Millwater Parkway Silverdale",
        "Issue": "refit flood damage from shower leak",
        "Installer": "Ross",
        "CustomerName": "Eve Taylor",
        "CustomerPhone": "021 407 200",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "16/06/2017",
        "Address": "14 Outlook Tce Millwater",
        "Issue": "Fix stairs etc",
        "Installer": "Matt Bunn",
        "CustomerName": "Eric Legasto",
        "CustomerPhone": "021 078 0384",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/08/2017",
        "Address": "3 Andrew Jack Rd Millwater",
        "Issue": "trim white thread out of carpet",
        "Installer": "Ross",
        "CustomerName": "Emma-Jane",
        "CustomerPhone": "021 176 3224",
        "GBContact": "Tony Bibbie",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Tony Bibbie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/07/2017",
        "Address": "31 Pamela Christine Rd Patumahoe",
        "Issue": "carpet lifting at ranchsliders, and check for excess wear",
        "Installer": "",
        "CustomerName": "Emma Klokie",
        "CustomerPhone": 211631893,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "emmaklokie@gmail.com",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "7/10/2016",
        "Address": "10 Harvard St Hobsonville",
        "Issue": "Restretch in hall,Lg and all stairs",
        "Installer": "Matt",
        "CustomerName": "Emma",
        "CustomerPhone": "550 3892",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Johnny",
        "Notes": "Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/10/2017",
        "Address": "54 Harbour Crest Drive Waiuku",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Elie",
        "CustomerPhone": 211488094,
        "GBContact": "Briar Irwin",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Briar Irwin",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 101517,
        "Received": "29/03/2016",
        "Address": "Lot 185, 88 Tapu Road, Huapai",
        "Issue": "Garage transition strip required",
        "Installer": "",
        "CustomerName": "Ehsan and Shadi",
        "CustomerPhone": "021 0233 6281",
        "GBContact": "Brett Lennon",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett Lennon",
        "Status": "TBF 21/6/16 3:30",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/09/2017",
        "Address": "24 Colonial Dr Silverdale",
        "Issue": "Relay carpet to LG & Bedroom after builder",
        "Installer": "Ross",
        "CustomerName": "Echo",
        "CustomerPhone": 210322106,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "21/06/2017",
        "Address": "lot 3/6 Pioneer Rise Millwater",
        "Issue": "supply/fit new planking where wall moved",
        "Installer": "Dave",
        "CustomerName": "Dunlop",
        "CustomerPhone": "027 220 9515 Heather",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Dave",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "25/11/2016",
        "Address": "20A Grove Rd Papakura",
        "Issue": "re-stretch and split join",
        "Installer": "Ross",
        "CustomerName": "Doris Brading",
        "CustomerPhone": "92995954  021068 1010",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "2/06/2017",
        "Address": "9 Mapou Rd Hobsonville",
        "Issue": "carpet lifting in several areas + stairs",
        "Installer": "",
        "CustomerName": "Dmitri",
        "CustomerPhone": "021 746 963",
        "GBContact": "Gail Blair(Universal)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Gail Blair(Universal)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/12/2016",
        "Address": "19 Tennessee Rd Mangere",
        "Issue": "hit down smoothedge",
        "Installer": "Ross",
        "CustomerName": "Desma",
        "CustomerPhone": 211185338,
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "6/09/2017",
        "Address": "22 Whaley Greens Millwater",
        "Issue": "refit lifting carpet",
        "Installer": "Ross",
        "CustomerName": "Dennis",
        "CustomerPhone": "021 132 0404",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "12/09/2017",
        "Address": "11 Spotted Dove Rd",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Denis Feoktistov",
        "CustomerPhone": 220398683,
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "31/08/2017",
        "Address": "200B Bawden Rd Albany",
        "Issue": "refit leak carpet",
        "Installer": "Ross",
        "CustomerName": "Debbie Glen",
        "CustomerPhone": "021 450 871",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/02/2016",
        "Address": "200B Bawden Rd Albany",
        "Issue": "refit flood damage",
        "Installer": "Ross",
        "CustomerName": "Debbie Glen",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "20/09/2016",
        "Address": "366 Riddell Rd Glendowie",
        "Issue": "rejoined join cut by builders",
        "Installer": "Matt",
        "CustomerName": "Dean Pointon",
        "CustomerPhone": "027 252 8720",
        "GBContact": "Christian",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Christian",
        "Status": "Fixed by Matt",
        "Notes": "Matt completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "N/A",
        "Received": "",
        "Address": "366A Riddell Road, Glendowie",
        "Issue": "Sucked up pieces of carpet, appears to be cut short. Builder had cut and rejoined carpet for access.",
        "Installer": "Darryll + Johnny",
        "CustomerName": "Dean",
        "CustomerPhone": "",
        "GBContact": "Christian Welham",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Christian Welham",
        "Status": "10/05/2016",
        "Notes": "Chargeable, builder ripped open carpet to mend floor",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "29/04/2017",
        "Address": "3 Micheala Lane Kaukapakapa",
        "Issue": "major floor levelling to entry tiles",
        "Installer": "Dave Walker",
        "CustomerName": "David Paul",
        "CustomerPhone": "021 675 137",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Dave",
        "Notes": "Dave completed May 1  2017",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/12/2017",
        "Address": "46 Boundary Rd Papakura",
        "Issue": "staple all tile transitions",
        "Installer": "Ross",
        "CustomerName": "David Barnett",
        "CustomerPhone": "021 061 0773",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 101606,
        "Received": "30/05/2016",
        "Address": "53 Discovery Drive, Gulf Harbour",
        "Issue": "Vinyl planking raised in kitchen",
        "Installer": "",
        "CustomerName": "David",
        "CustomerPhone": "021 288 0303",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "TBF 10/06/2016 930am",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/09/2017",
        "Address": "12 Tua Tua Rd Hobsonville",
        "Issue": "Stretch and refit to kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "Darryl",
        "CustomerPhone": 211900379,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "26/09/2017",
        "Address": "6 Aro Mato, Matua",
        "Issue": "carpet lifting in several areas",
        "Installer": "Ross",
        "CustomerName": "Daniel",
        "CustomerPhone": 221766123,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/06/2017",
        "Address": "159 Hobsonville Pt Rd",
        "Issue": "repair floor relay carpet",
        "Installer": "",
        "CustomerName": "Daniel",
        "CustomerPhone": "021 430 154",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/09/2017",
        "Address": "22 Colonial Dr Silverdale",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Dan",
        "CustomerPhone": 274740007,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "10/05/2017",
        "Address": "3 Aro Mato, Matua",
        "Issue": "carpet lifting in several areas",
        "Installer": "",
        "CustomerName": "Dan",
        "CustomerPhone": 274033882,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/03/2018",
        "Address": "32 Screen Rd Coatesville",
        "Issue": "trim faults in carpet",
        "Installer": "Ross",
        "CustomerName": "Crow",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/04/2017",
        "Address": "1096A Awhitu Rd Waiuku",
        "Issue": "restretch",
        "Installer": "Ross",
        "CustomerName": "Craig Rollitt",
        "CustomerPhone": 211589475,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "crag71@gmail.com",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/11/2016",
        "Address": "50 Milano Boulevard Karaka",
        "Issue": "replace s/e and refit water damage",
        "Installer": "Ross",
        "CustomerName": "Colin Hussys",
        "CustomerPhone": 274961937,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "9/09/2016",
        "Address": "25 Westmuir Crescent Pokeno",
        "Issue": "Fixed all joins and carpet at transitions and tear in carpet",
        "Installer": "Ross",
        "CustomerName": "Clinton Ballot",
        "CustomerPhone": 212421696,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "clinton@cp-1.co.nz",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/11/2016",
        "Address": "25 Westmuir Crescent Pokeno",
        "Issue": "Fixed all joins and carpet at transitions and tear in carpet",
        "Installer": "Ross",
        "CustomerName": "Clinton Ballot",
        "CustomerPhone": 212421696,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "clinton@cp-1.co.nz",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 94,
        "Received": "9/07/2018",
        "Address": "92 TORARA VIEWS DRIVE, SILVERDALE",
        "Issue": "Rodney",
        "Installer": "SMOOTHEDGE LIFTING FROM CONCRETE - ROSS BOOKED THURSDAY 12/07/2018 3.30PM",
        "CustomerName": "CLIENT DIRECT GJ RODNEY",
        "CustomerPhone": "MATTHEW - 2013",
        "GBContact": "021-151 8708",
        "GB": "",
        "CustomerEmail": "MIKE",
        "GBStart": "021-151 8708",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/03/2016",
        "Address": "133 Hobsonville Pt Rd",
        "Issue": "Carpet loose on stairs",
        "Installer": "Ross",
        "CustomerName": "Clare Allen",
        "CustomerPhone": "027 617 9155",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/02/2018",
        "Address": "125 Matua Rd Huapai",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Claire Foley",
        "CustomerPhone": "027 357 1790",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/08/2016",
        "Address": "37 Headland Dr Long Bay",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "Claire Dowron",
        "CustomerPhone": "021 177 6326",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 22885,
        "Received": "6/05/2016",
        "Address": "16 Millbrae Place, Pokeno",
        "Issue": "Carpet coming away around kitchen and study nook",
        "Installer": "Kelvin",
        "CustomerName": "Claire",
        "CustomerPhone": "027 511 4856",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "TBF 14/05/2016",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/01/2017",
        "Address": "3 Modello Lane Waiuku",
        "Issue": "carpet lifting and small re-stretch",
        "Installer": "Ross",
        "CustomerName": "Christine Horscroft",
        "CustomerPhone": 21797510,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2018",
        "Address": "44 Bomb Pt Dr Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Christina",
        "CustomerPhone": 2102620381,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "18/04/2017",
        "Address": "15 Mataoho Rd Mangere",
        "Issue": "carpet lifting in places",
        "Installer": "Ross",
        "CustomerName": "Chris Gupta",
        "CustomerPhone": 210357493,
        "GBContact": "Mavis GJ",
        "GB": "OMAHA HOLDINGS LTD",
        "CustomerEmail": "",
        "GBStart": "Mavis GJ",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "8/11/2016",
        "Address": "lot 12 47 Yates Rd Mangere",
        "Issue": "Sprouting/Cropping issue",
        "Installer": "Ross",
        "CustomerName": "Chris Goyal",
        "CustomerPhone": 210357493,
        "GBContact": "Ryan Meynell",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Ryan Meynell",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "N/A",
        "Received": "19/04/2016",
        "Address": "122 Hobsonville Point Road",
        "Issue": "Wear through hallway and side rooms. NEC required",
        "Installer": "Richard & Andrew",
        "CustomerName": "Charlotte Glidden",
        "CustomerPhone": "412 9521",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "charlotte@bbp.co.nz",
        "GBStart": "",
        "Status": "pending",
        "Notes": "Colin and Carl visited 28/6/16 Advised for stress test.",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "8/09/2016",
        "Address": "122 Hobsonville Point Road",
        "Issue": "Fixed all rippling stairs",
        "Installer": "Ross",
        "CustomerName": "Charlotte Glidden",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "charlotte@bbp.co.nz",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/04/2017",
        "Address": "18 Tuatua Rd Hobsonville",
        "Issue": "lump under carpet in bedroom",
        "Installer": "Ross",
        "CustomerName": "Charlotte",
        "CustomerPhone": "027 777 6694",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "9/09/2017",
        "Address": "18 Tua Tua Rd Hobsonville",
        "Issue": "refit lifting carpet on stairs",
        "Installer": "Ross",
        "CustomerName": "Charlotte",
        "CustomerPhone": 277776694,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "4/04/2018",
        "Address": "13 Glory Way",
        "Issue": "carpet lifting at tiles & wall",
        "Installer": "Ross",
        "CustomerName": "Cezar",
        "CustomerPhone": 277890012,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "15/11/2016",
        "Address": "2 Huarahi Pai Rd Huapai",
        "Issue": "fraying and lifting round kitchen tiles",
        "Installer": "Ross",
        "CustomerName": "Cesar Romero",
        "CustomerPhone": 224140041,
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "12/08/2017",
        "Address": "78C Castledine Cres GI",
        "Issue": "refit lifting carpet",
        "Installer": "",
        "CustomerName": "Ceri John",
        "CustomerPhone": "022 391 1413",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/02/2018",
        "Address": "79 Valley Rd Puke",
        "Issue": "replace smoothedge and refit carpet",
        "Installer": "Ross",
        "CustomerName": "Carla",
        "CustomerPhone": 272822901,
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "27/09/2017",
        "Address": "21 Saltmarsh Rd Hobsonville",
        "Issue": "tuck in stairs",
        "Installer": "Ross",
        "CustomerName": "Carl",
        "CustomerPhone": 223134177,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "22/02/2018",
        "Address": "17 Fruitlands Rd Huapai",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Campbell Glennie",
        "CustomerPhone": 274724338,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "8/03/2018",
        "Address": "17 Fruitlands Rd Huapai",
        "Issue": "Replace Bar",
        "Installer": "Ross",
        "CustomerName": "Campbell Glennie",
        "CustomerPhone": 274724338,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/10/2016",
        "Address": "116 Harris Dr Millwater",
        "Issue": "Vinyl planking",
        "Installer": "Dave",
        "CustomerName": "Callum Davis",
        "CustomerPhone": "027 261 5334",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Dave",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "13/12/2017",
        "Address": "107 Hutchinson Rd Helensville",
        "Issue": "carpet lifting and clicking in underlay",
        "Installer": "Ross",
        "CustomerName": "Bryan Hodder",
        "CustomerPhone": 211434186,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 101314,
        "Received": "9/05/2016",
        "Address": "24 Walter Crescent, Millwater",
        "Issue": "Carpet is not right at top of stairs",
        "Installer": "Jared",
        "CustomerName": "Bryan & Sacha",
        "CustomerPhone": "021 076 6847",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "TBF 19/05/16",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "6/04/2017",
        "Address": "19 Lamborn Dr Papakura",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Brittany Johnson",
        "CustomerPhone": 276332526,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/03/2018",
        "Address": "9 Rangihina Rd Hobsonville",
        "Issue": "Repair holes in LG floor",
        "Installer": "Ross",
        "CustomerName": "Brendon",
        "CustomerPhone": "0217 280 18",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "4/07/2017",
        "Address": "9 Rangihina Rd Hobsonville",
        "Issue": "refit carpet lifted by toilet and on winders",
        "Installer": "",
        "CustomerName": "Brendan Holgate",
        "CustomerPhone": "021 055 0814",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "24/01/2017",
        "Address": "39 Outlook Tce Millwater",
        "Issue": "inspection Stonewood (just shading)",
        "Installer": "Ross",
        "CustomerName": "Brandt",
        "CustomerPhone": 2040092417,
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "24/01/2017",
        "Address": "149 Hobsonville Pt Rd",
        "Issue": "re fit carpet",
        "Installer": "Ross",
        "CustomerName": "Brandon",
        "CustomerPhone": 21750954,
        "GBContact": "Brandon Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brandon Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "21/09/2017",
        "Address": "12 Spotted Dove Rd",
        "Issue": "carpet lifting & gap at wall",
        "Installer": "Ross",
        "CustomerName": "Brandon",
        "CustomerPhone": "",
        "GBContact": "Brandon",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brandon",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/11/2017",
        "Address": "14 Spotted Dove Rd",
        "Issue": "carpet lifting",
        "Installer": "Ross",
        "CustomerName": "Brandon",
        "CustomerPhone": "",
        "GBContact": "Brandon",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brandon",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/03/2016",
        "Address": "61A Castledine Cres Glen Innes",
        "Issue": "Carpet loose on stairs",
        "Installer": "Kelvin",
        "CustomerName": "Blair",
        "CustomerPhone": "021 454 675",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "iand@universal.co.nz",
        "GBStart": "Ian Donachie",
        "Status": "Kelvin to do",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/04/2017",
        "Address": "8 Robert Might Rd Huapai",
        "Issue": "Refit carpet to new tiling",
        "Installer": "Ross",
        "CustomerName": "Bill & Linda Ensor",
        "CustomerPhone": 4125959,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "17/01/2017",
        "Address": "8 Robert Might Rd Huapai",
        "Issue": "inspection for GJ Rodney West",
        "Installer": "",
        "CustomerName": "Bill & Linda Ensor",
        "CustomerPhone": 4125959,
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sara Foley",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "11/03/2016",
        "Address": "128 Forestry Rd Kaukapakapa",
        "Issue": "carpet bubbled badly",
        "Installer": "Matt Bunn",
        "CustomerName": "Bev Hopper",
        "CustomerPhone": "027 271 4221",
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "",
        "Notes": "Ross &Johnny completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 665489,
        "Received": "11/05/2016",
        "Address": "25 Captain Mitchell Drive, Papakura",
        "Issue": "Tidy carpet edge near kitchen tiles",
        "Installer": "Kelvin",
        "CustomerName": "Beth",
        "CustomerPhone": "027 339 8567",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "TBF 13/05/16",
        "Notes": "Flooded the lounge and had to relay",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "7/06/2016",
        "Address": "7 Whares Court, Silverdale",
        "Issue": "Repair two carpet joins opening up",
        "Installer": "",
        "CustomerName": "Bernie",
        "CustomerPhone": "021 644 856",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "pauline.saunders@kinect.co.nz",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/04/2017",
        "Address": "5 Aro Mato Pl Huapai",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Barry McCracken",
        "CustomerPhone": 2102700588,
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/04/2017",
        "Address": "9 Woodridge Dr Stanmore Bay",
        "Issue": "Attend to joins and re nail smoothedge",
        "Installer": "Ross",
        "CustomerName": "Barry & Brenda Frost",
        "CustomerPhone": 272892327,
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "9/09/2017",
        "Address": "22 Tua Tua Rd Hobsonville",
        "Issue": "refit lifting carpet on stairs",
        "Installer": "Ross",
        "CustomerName": "Barry",
        "CustomerPhone": 21927552,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 323207,
        "Received": "21/04/2016",
        "Address": "Lot 6, 28 Te Oneroa Way, Long Bay",
        "Issue": "Refit loose carpet on stair treads",
        "Installer": "Richard & Andrew",
        "CustomerName": "Audree Davey",
        "CustomerPhone": "021 158 3621",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "daveynac@outlook.co.nz",
        "GBStart": "Dean Hodgson",
        "Status": "9/05/2016",
        "Notes": "Andrew contacting customer",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/02/2016",
        "Address": "145 Hobsonville Pt Rd",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Ash&Fiona Matthews",
        "CustomerPhone": "027 274 5391",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "17/01/2017",
        "Address": "24 Kingfisher Rd Millwater",
        "Issue": "gappy on stairs",
        "Installer": "Ross",
        "CustomerName": "Anna Stephenson",
        "CustomerPhone": 211258657,
        "GBContact": "Samantha Hyland",
        "GB": "GJG OREWA EAST",
        "CustomerEmail": "",
        "GBStart": "Samantha Hyland",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/11/2017",
        "Address": "37 McNally Rd Puke",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "Anita Parbhu",
        "CustomerPhone": 21316797,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/03/2016",
        "Address": "184 Hobsonville Pt Rd",
        "Issue": "carpet lifting in places",
        "Installer": "",
        "CustomerName": "Angela Smith",
        "CustomerPhone": 2102485259,
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/02/2017",
        "Address": "27 Liquidambar Dr Hobsonville",
        "Issue": "Re stretch all stairs",
        "Installer": "Ross",
        "CustomerName": "Andy & June Ranyard",
        "CustomerPhone": "021 810 468",
        "GBContact": "Gail Blair(Universal)",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Gail Blair(Universal)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 318339,
        "Received": "16/03/2016",
        "Address": "Lot 32, 10 Arakakara Ave, Huapai",
        "Issue": "Join opened up, hole underneath carpet in middle of room, and carpet bubbling",
        "Installer": "Johnny Nicholson",
        "CustomerName": "Andrew Colgan",
        "CustomerPhone": "021 0274 5704",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "ajcolgan79@gmail.com",
        "GBStart": "Dean Hodgson",
        "Status": "11/05/2016",
        "Notes": "Customer has some reservations about nature of issues and wants to talk with installer",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "5/05/2017",
        "Address": "139 Hobsonville Pt Rd",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "Andrew",
        "CustomerPhone": "021 877 256",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/11/2017",
        "Address": "76 Squadron Dr Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Andreson Chua",
        "CustomerPhone": "",
        "GBContact": "Jason Wech",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Jason Wech",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "15/11/2017",
        "Address": "13 Rangihina Rd Hobsonville",
        "Issue": "restretch one stair",
        "Installer": "Ross",
        "CustomerName": "Andrea",
        "CustomerPhone": 276332433,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "17/03/2016",
        "Address": "141 Hobsonville Pt Rd",
        "Issue": "carpet lifting on stairs",
        "Installer": "",
        "CustomerName": "Andre",
        "CustomerPhone": "021 183 5276",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/10/2017",
        "Address": "217 Wainui Rd",
        "Issue": "refit carpet after fixed squeaky floor",
        "Installer": "Kelvin",
        "CustomerName": "Anand",
        "CustomerPhone": "027 8019920",
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Kelvin",
        "Notes": "Kelvin completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "28/02/2016",
        "Address": "129 Hobsonville Point Rd",
        "Issue": "restretch stairs",
        "Installer": "Ross",
        "CustomerName": "Amy Worthington",
        "CustomerPhone": "021 042 4214",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "Universal",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "30/05/2017",
        "Address": "131 Hobsonville Pt Rd",
        "Issue": "carpet lifting in several areas",
        "Installer": "",
        "CustomerName": "Amanda Alley",
        "CustomerPhone": "021 373 080",
        "GBContact": "Kara Merryweather",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Merryweather",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "11/08/2017",
        "Address": "18 Merfield St GI",
        "Issue": "knock down all pins",
        "Installer": "Ross",
        "CustomerName": "Alison",
        "CustomerPhone": 212021592,
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "31/08/2017",
        "Address": "23 Liquidambar Dr Hobsonville",
        "Issue": "replace damaged winder",
        "Installer": "Ross",
        "CustomerName": "Alex",
        "CustomerPhone": 211147841,
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/02/2018",
        "Address": "16 Glennron Lane Waiuku",
        "Issue": "carpet lifting, and trim join",
        "Installer": "Ross",
        "CustomerName": "Alex",
        "CustomerPhone": "021 067 8799",
        "GBContact": "Meridith Smit",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Smit",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "7/06/2017",
        "Address": "23 Liquidambar Dr Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "",
        "CustomerName": "Alex",
        "CustomerPhone": "021 114 7841",
        "GBContact": "Kara Smith",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Kara Smith",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 318473,
        "Received": "18/03/2016",
        "Address": "41 Liquidambar Dr, Hob Pt",
        "Issue": "Refit loose carpet on stairs, kitchen and toilet area",
        "Installer": "Richard & Andrew",
        "CustomerName": "Alex",
        "CustomerPhone": "021 0819 8520",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "lexisingleton@hotmail.com",
        "GBStart": "Dean Hodgson",
        "Status": "TBF 16/06/16",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "9/09/2016",
        "Address": "10 Belgium Road, Pukekohe",
        "Issue": "Fixed hole in carpet",
        "Installer": "Ross",
        "CustomerName": "Adrienne",
        "CustomerPhone": 21572158,
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 420237,
        "Received": "17/05/2016",
        "Address": "10 Belgium Road, Pukekohe",
        "Issue": "Carpet lifting where ensuite tiles meet bedroom",
        "Installer": "Darryll",
        "CustomerName": "Adrienne",
        "CustomerPhone": "07-8470219",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "TBF 10/06/16",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "24/05/2017",
        "Address": "18C Martindale Lane Tuakau",
        "Issue": "carpet lifting in several areas",
        "Installer": "",
        "CustomerName": "Adriana",
        "CustomerPhone": "021 179 0242",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 325995,
        "Received": "12/05/2016",
        "Address": "32 Cape Cod Drive, Gulf Har.",
        "Issue": "Carpet lifting and fraying in places",
        "Installer": "",
        "CustomerName": "Abbey",
        "CustomerPhone": "021 460 077",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "TBF 19/05/16",
        "Notes": "Down the side, back ranch slider will be open",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "16/02/2018",
        "Address": "25 Onekiritea Rd Hobsonville",
        "Issue": "Knock down pins",
        "Installer": "Ross",
        "CustomerName": "Aaron",
        "CustomerPhone": 2108379888,
        "GBContact": "Joanne Baxter",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Joanne Baxter",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/02/2018",
        "Address": "14 Papa Orchard Drive Huapai",
        "Issue": "lift carpet for new tiles to be laid and then refit",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Sarah Foley",
        "GB": "GJG HOMES WEST",
        "CustomerEmail": "",
        "GBStart": "Sarah Foley",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "14/12/2016",
        "Address": "7 Kuawa Drive Huapai",
        "Issue": "refit carpet around ranchsliders and tile areas",
        "Installer": "Dave",
        "CustomerName": "",
        "CustomerPhone": "021 128 3110",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/02/2016",
        "Address": "4 Lally Haddon Matakana",
        "Issue": "re nail and fit carpet at ranchsliders",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Ross Murray",
        "GB": "MADISON PARK HOMES LTD",
        "CustomerEmail": "",
        "GBStart": "Ross Murray",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/06/2017",
        "Address": "21 Rangihina Rd Hobsonville",
        "Issue": "relay winder lifted",
        "Installer": "",
        "CustomerName": "",
        "CustomerPhone": 21472672,
        "GBContact": "Shane Currie Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Shane Currie Uni",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "1/02/2017",
        "Address": "Lot 3 78A Castledine Cres Glen Innes",
        "Issue": "lift room to resand and fix squeaky floor",
        "Installer": "Kelvin",
        "CustomerName": "",
        "CustomerPhone": 212482204,
        "GBContact": "Scott",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Scott (Universal)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "29/11/2016",
        "Address": "13 Kuawa Dr Huapai",
        "Issue": "Lump under carpet in hall",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "027 886 4813 Rob Lewis",
        "GBContact": "Rob Lewis",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Rob Lewis",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/11/2017",
        "Address": "44 Tonar St",
        "Issue": "trim tufts",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021 588 591",
        "GBContact": "Rhys Baker Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Rhys Baker Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "10/02/2016",
        "Address": "Lot 27 Saltmarsh Rd Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Rhys Baker Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Rhys Baker Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/12/2016",
        "Address": "Lot 6 Onekiritea Rd Hobsonville",
        "Issue": "Cut out carpet with paint spill & re-fitted",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021588591 Rhys Baker (Universal)",
        "GBContact": "Rhys",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Rhys",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "8/06/2017",
        "Address": "22 Tua Tua Rd Hobsonville",
        "Issue": "Irish (poor job) going back to do remedials (i lifted room",
        "Installer": "Mark Irish",
        "CustomerName": "",
        "CustomerPhone": "021 556 448 (Morne)",
        "GBContact": "Morne Botha Uni",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Morne Botha Uni",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/02/2016",
        "Address": "Lot 3/25 Onekiritea Rd Hobsonville",
        "Issue": "Re stretch all stairs",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Ian Donachie",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Ian Donachie",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/11/2017",
        "Address": "37 Mapou Rd Hobsonville",
        "Issue": "carpet lifting",
        "Installer": "Grant",
        "CustomerName": "",
        "CustomerPhone": 21750257,
        "GBContact": "Dan Young Universal",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Dan Young Universal",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "2/12/2016",
        "Address": "178 Hobsonville Pt Rd",
        "Issue": "Lay smoothedge and fit carpet to tiled areas",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021977916 Damon(Universal)",
        "GBContact": "Damon",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Damon",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "y"
      }, {
        "JobNumber": "",
        "Received": "2/12/2016",
        "Address": "14 Mapou Rd Hobsonville",
        "Issue": "lump under carpet",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021977916 Damon(Universal)",
        "GBContact": "Damon",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Damon",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "21/12/2016",
        "Address": "155 Hobsonville Point Rd",
        "Issue": "lift carpet for floor remedial& return to refit",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021 750 954 Brandon (Uni",
        "GBContact": "Brandon",
        "GB": "UNIVERSAL HOMES",
        "CustomerEmail": "",
        "GBStart": "Brandon",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "23/11/2016",
        "Address": "315 Harbourside Drive Karaka",
        "Issue": "lifting and need to staple where open at ends of joins",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Meridith Gilmour",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Meridith Gilmour",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/10/2016",
        "Address": "20 eric Farley Dr Huapai",
        "Issue": "noisy under carpet",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Steve Johnson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Steve Johnson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/10/2016",
        "Address": "18 Eric Farley Dr Huapai",
        "Issue": "Attend to join split and nap",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Steve Johnson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Steve Johnson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "19/10/2017",
        "Address": "1/66 Marua Rd Ellerslie",
        "Issue": "lump under carpet",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021 2470568",
        "GBContact": "Ryan Meynell",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Ryan Meynell",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "8/09/2016",
        "Address": "16 Captain Mitchell Dr Papakura",
        "Issue": "fraying and lifting round kitchen tiles sprouts",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Raymond",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Raymond",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "20/07/2017",
        "Address": "7 Weta Rd Hobsonville",
        "Issue": "knock down all pins",
        "Installer": "",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Mark",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Mark",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "11/05/2016",
        "Address": "16 Ruth Craig",
        "Issue": "In HWC there is a patch missing Vinyl",
        "Installer": "Dave",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Doug Stephenson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Doug Stephenson",
        "Status": "16/05/2016",
        "Notes": "",
        "Advised": "Y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "29/07/2016",
        "Address": "Lot 59, 6 malbec Pl Huapai",
        "Issue": "carpet lifting breakfast bar, and 2 glue spots to shave of",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "0273832674 Damon(tenant)",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "ross doing 3/8/16",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "10/04/2018",
        "Address": "14 Paetahi Lane",
        "Issue": "nylon thread coming out all over stairs",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "10/04/2018",
        "Address": "18 Paetahi Lane",
        "Issue": "GH Repaired holes in carpet",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dean Hodgson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dean Hodgson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": "Y"
      }, {
        "JobNumber": "",
        "Received": "14/12/2017",
        "Address": "20 Spotted Dove Rd",
        "Issue": "carpet lifting at tiles",
        "Installer": "Kelvin",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/12/2017",
        "Address": "22 Spotted Dove Rd",
        "Issue": "carpet lifting at tiles",
        "Installer": "Kelvin",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/12/2017",
        "Address": "24 Spotted Dove Rd",
        "Issue": "carpet lifting at tiles",
        "Installer": "Kelvin",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/12/2017",
        "Address": "19 Chaffinch Rd Hobsonville",
        "Issue": "carpet lifting at tiles",
        "Installer": "Kelvin",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "14/12/2017",
        "Address": "15 Chaffinch Rd Hobsonville",
        "Issue": "carpet lifting at tiles and hole in floor",
        "Installer": "Rommel & Robert",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "15/12/2017",
        "Address": "9 Sacred Kingfisher Dr Hobsonville",
        "Issue": "Tidy up at ranch sliders",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "Dan Jackson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Dan Jackson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "E9371",
        "Received": "27/07/2016",
        "Address": "Lot 3, 26 Aldon Lane Manurewa",
        "Issue": "Join in Lounge & hole in carpet at top of stairwell",
        "Installer": "Kelvin",
        "CustomerName": "",
        "CustomerPhone": "0275 899 364",
        "GBContact": "Christian Welham",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Christian Welham",
        "Status": "Inspection sent",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/03/2016",
        "Address": "7 Martingale Dr Kingseat",
        "Issue": "carpet lifting at transitions in hallway",
        "Installer": "Glenn W",
        "CustomerName": "",
        "CustomerPhone": 21918467,
        "GBContact": "Cam (GJ)",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Cam (GJ)",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "3/03/2016",
        "Address": "Lot 1 Merfield St Glen Innes",
        "Issue": "refit carpet at front door",
        "Installer": "",
        "CustomerName": "",
        "CustomerPhone": 21505493,
        "GBContact": "Brett McPherson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett McPherson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/10/2017",
        "Address": "11 Muirhill Plc Pokeno",
        "Issue": "lift carpet and matrix floor",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": 21505493,
        "GBContact": "Brett McPherson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett McPherson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "22/02/2016",
        "Address": "Lot 9 Merfield St Glenn Innes",
        "Issue": "re nail and fit carpet at ranchsliders",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "021 505 493",
        "GBContact": "Brett McPherson",
        "GB": "",
        "CustomerEmail": "Universal",
        "GBStart": "Brett McPherson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/08/2017",
        "Address": "12a Hurstwood Pl Glen Innes",
        "Issue": "inspect poorly laid vinyl. Craig sorting",
        "Installer": "Brian",
        "CustomerName": "",
        "CustomerPhone": "021 505 493",
        "GBContact": "Brett McPherson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett McPherson",
        "Status": "",
        "Notes": "",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "18/08/2017",
        "Address": "12b Hurstwood Pl Glen Innes",
        "Issue": "tap down pins",
        "Installer": "",
        "CustomerName": "",
        "CustomerPhone": "021 505 493",
        "GBContact": "Brett McPherson",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "Brett McPherson",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 41,
        "Received": "24/04/2018",
        "Address": "1 RAITHBURN TCE POKENO",
        "Issue": "",
        "Installer": "CARPET LIFTING",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "0278 127 980",
        "GB": "",
        "CustomerEmail": "HANNAH",
        "GBStart": "0278 127 980",
        "Status": "",
        "Notes": "MERIDITH",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 14,
        "Received": "17/04/2018",
        "Address": "LOT 150, 16 ERIC FARLEY DRIVE, HUAPAI",
        "Issue": "",
        "Installer": "LAMINATE FLOORING IS LIFTING IN KITCHEN - DAVE FIXING SATURDAY 21ST APRIL 9.00AM",
        "CustomerName": "",
        "CustomerPhone": "DAVE WALKER FIXED",
        "GBContact": "027-323 6802",
        "GB": "",
        "CustomerEmail": "PAUL",
        "GBStart": "027-323 6802",
        "Status": "",
        "Notes": "GJG WEST",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 8,
        "Received": "17/04/2018",
        "Address": "LOT 60, 23 HENLEY ROAD, KKK",
        "Issue": "",
        "Installer": "CARPET NEEDS TO BE RELAID (Grant doing 19/04/18, get his bill then charge GJ Rodney)",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "027-212 4484",
        "GB": "",
        "CustomerEmail": "GARETH",
        "GBStart": "027-212 4484",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 35,
        "Received": "19/04/2018",
        "Address": "11 RAHOPARA ST CASTOR BAY",
        "Issue": "",
        "Installer": "STAPLES IN FLOOR SHOULDNT BE ALSO ALL KNEE KICK MARKS POOR AT TRANSITIONS",
        "CustomerName": "",
        "CustomerPhone": "KELVIN TEAM",
        "GBContact": "021-773-560",
        "GB": "",
        "CustomerEmail": "DON SENIOR",
        "GBStart": "021-773-560",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 34,
        "Received": "19/04/2018",
        "Address": "CA 13, LOT 6, CHAFFINCH RD, HOB",
        "Issue": "",
        "Installer": "JOINS X 3  ROSS SIGHING / FIXING 4.00PM 19/04/2018 - ROSS TO CONFIRM",
        "CustomerName": "",
        "CustomerPhone": "WAYNE",
        "GBContact": "021-750 474",
        "GB": "",
        "CustomerEmail": "PAUL WESTWOOD",
        "GBStart": "021-750 474",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 5,
        "Received": "17/04/2018",
        "Address": "LOT 596, 11 MUIRHILL PLACE, POKENO",
        "Issue": "SOUTH",
        "Installer": "UNDERLAY LUMP UNDER CARPET -Ross fixed part. Kelvin grinding concrete 26/05/2018",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "021-465 848",
        "GB": "",
        "CustomerEmail": "ALLAN",
        "GBStart": "021-465 848",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 29,
        "Received": "17/04/2018",
        "Address": "36 PAMELA CHRISTINE RD, PATUMAHOE",
        "Issue": "",
        "Installer": "CARPET LIFTING",
        "CustomerName": "",
        "CustomerPhone": "ROSS INSPECTING 24/04/2018",
        "GBContact": "021-464 393",
        "GB": "",
        "CustomerEmail": "SCOTT",
        "GBStart": "021-464 393",
        "Status": "",
        "Notes": "MERIDITH",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 32,
        "Received": "17/04/2018",
        "Address": "83A, LOTS 1-9 HOBSONVILLE PT RD",
        "Issue": "",
        "Installer": "MEET AT SITE TO GO OVER CARPET",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "021-442 795 UNIVERSAL",
        "GB": "",
        "CustomerEmail": "JARED SIMM",
        "GBStart": "021-442 795 UNIVERSAL",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 4,
        "Received": "17/04/2018",
        "Address": "34 CAPRIANA DRIVE, KARAKA",
        "Issue": "",
        "Installer": "RE-STRETCH MOST OF HOUSE",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "021-396 303",
        "GB": "",
        "CustomerEmail": "BEN",
        "GBStart": "021-396 303",
        "Status": "",
        "Notes": "MERIDITH",
        "Advised": "",
        "Billed": "Ross to fix Saturday April 21 st",
        "Chargeable": ""
      }, {
        "JobNumber": 11,
        "Received": "17/04/2018",
        "Address": "LOT 44, 10 ASTRID LANE, WELLSFORD",
        "Issue": "",
        "Installer": "PLANK NEEDS TO BE REGLUED",
        "CustomerName": "",
        "CustomerPhone": "DAVE COMPLETED 04/05/2018",
        "GBContact": "021-257 9821",
        "GB": "",
        "CustomerEmail": "JORGE",
        "GBStart": "021-257 9821",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 31,
        "Received": "17/04/2018",
        "Address": "LOT 2, 14A DIDA PARK DR, HUAPAI",
        "Issue": "",
        "Installer": "JOIN COMING APART",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "021-130 2582",
        "GB": "",
        "CustomerEmail": "VANESSA",
        "GBStart": "021-130 2582",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 3,
        "Received": "17/04/2018",
        "Address": "LOT 1, 127 HOBSONVILLE PT RD, HOB",
        "Issue": "",
        "Installer": "FIX CARPET AT STAIRS",
        "CustomerName": "",
        "CustomerPhone": "ANDREW WALKER",
        "GBContact": "021-0822 6071",
        "GB": "",
        "CustomerEmail": "TRACEY",
        "GBStart": "021-0822 6071",
        "Status": "",
        "Notes": "KARA SMITH",
        "Advised": "",
        "Billed": "Ross to fix Saturday April 21 st",
        "Chargeable": ""
      }, {
        "JobNumber": 7,
        "Received": "17/04/2018",
        "Address": "LOT 20, 115 HOBSONVILLE PT RD, HOB",
        "Issue": "",
        "Installer": "SMOOTH EDGE TACKS COMING THROUGH",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "021-0819 9554",
        "GB": "",
        "CustomerEmail": "MATT",
        "GBStart": "021-0819 9554",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 16,
        "Received": "17/04/2018",
        "Address": "LOT 96, 14 ARO MATO PLACE, HUAPAI",
        "Issue": "",
        "Installer": "REFIX CARPET AT STAIRS",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "021-030 1793",
        "GB": "",
        "CustomerEmail": "OLIVIA",
        "GBStart": "021-030 1793",
        "Status": "",
        "Notes": "JO BAXTER",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 48,
        "Received": "24/04/2018",
        "Address": "Hull Rd Waitoki",
        "Issue": "",
        "Installer": "JOINS",
        "CustomerName": "",
        "CustomerPhone": "ROSS MADISON HOMES",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "027-270 5003",
        "GBStart": "",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 18,
        "Received": "17/04/2018",
        "Address": "LOT 8, 16 TONAR ST,",
        "Issue": "",
        "Installer": "JOIN - WAYNE SIGHTED AND FIXED 04/05/2018",
        "CustomerName": "",
        "CustomerPhone": "WAYNE TO CHECK",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "UNIVERSAL",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": "",
        "Received": "2/09/2017",
        "Address": "34 Bomb Pt Dr Hobsonville",
        "Issue": "remove lump under carpet in bedroom",
        "Installer": "Ross",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "Fixed by Ross",
        "Notes": "Ross completed",
        "Advised": "y",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 23,
        "Received": "17/04/2018",
        "Address": "LOT 10, 2 OLD MILL RD, MILLWATER",
        "Issue": "",
        "Installer": "VINYL LIFTING",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "CONTACT OFFICE",
        "GBStart": "",
        "Status": "",
        "Notes": "GJG RODNEY",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 36,
        "Received": "19/04/2018",
        "Address": "SHEARWATER POINT WELLS",
        "Issue": "",
        "Installer": "CARPET LIFTING AT RANCHSLIDER",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "ROSS MURRAY",
        "Advised": "",
        "Billed": "KANE FIXED",
        "Chargeable": ""
      }, {
        "JobNumber": 37,
        "Received": "20/04/2018",
        "Address": "2 OLD MILL ROAD, STANMORE BAY",
        "Issue": "",
        "Installer": "VINYL LIFTING  GJG SHOWHOME",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "SAMANTHA HYLAND",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }, {
        "JobNumber": 54,
        "Received": "3/05/2018",
        "Address": "LOT 4, 38 TONAR ST",
        "Issue": "",
        "Installer": "REPAIR VINYL JOIN",
        "CustomerName": "",
        "CustomerPhone": "",
        "GBContact": "",
        "GB": "",
        "CustomerEmail": "",
        "GBStart": "",
        "Status": "",
        "Notes": "",
        "Advised": "",
        "Billed": "",
        "Chargeable": ""
      }];

      sample.forEach(function (remedial) {
        _this.remedialCommands({ command: 'addExistingRemedial', remedial: remedial });
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['remedialCommands', 'setUpCompanyReferences']))
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addToHomeScreen', 'setCurrentLocation', 'setNotifications', 'unRegister'])),
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["addtohomescreen", "location", "fcmToken", "newversionavailable"])
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PWA",
  data: function data() {
    return {
      help: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["getHelpPage"]), {
    openHelp: function openHelp(path) {
      var _this = this;

      this.getHelpPage(path).then(function (content) {
        _this.help = content;
      });
    }
  })
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["getHelpPage"])),
  mounted: function mounted() {
    var _this = this;

    this.getHelpPage('wpp').then(function (content) {
      _this.help = content;
    });
  },

  data: function data() {
    return {
      help: null
    };
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["getHelpPage"])),
  mounted: function mounted() {
    var _this = this;

    this.getHelpPage('termsconditions').then(function (content) {
      _this.help = content;
    });
  },

  data: function data() {
    return {
      help: null
    };
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(4);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GoogleMap",
  data: function data() {
    return {
      msg: ""
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["business"]),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {}
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(4);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["business"])
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      businessrights: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    dialogActions: function dialogActions(e) {
      if (e.action === "canceldialog") {}
    },
    refresh: function refresh() {
      this.businessrights = this.alladminrights;
    },
    actionremovebusiness: function actionremovebusiness(e, business) {
      if (e.action) {
        this.$refs.businessdialogmenulayout.cancelDialog();
        this.businesscommands({ command: 'removeBusiness', business: business });
      }
    },
    createBusiness: function createBusiness(business) {
      var command = 'createBusiness'; //default

      if (business.id) command = 'cloneBusiness';

      this.businesscommands({ command: command, business: business });

      this.$refs.addbusinessialog.cancelDialog();
    },
    newBusiness: function newBusiness(id, name) {
      this.$refs.addbusinessialog.show({});
    },
    cloneBusiness: function cloneBusiness() {
      var clone = {
        id: this.business.id,
        existingname: this.business.name
      };

      this.$refs.addbusinessialog.show(clone);
    },
    getFullBusinesssListing: function getFullBusinesssListing() {
      var _this = this;

      this.fullbusiness().then(function (fs) {
        var businessslist = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(fs).reduce(function (accum, key) {
          var business = fs[key];
          accum[key] = { name: business.name };
          return accum;
        }, {});
        _this.businessrights = businessslist;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['changeBusiness', 'businesscommands', 'fullbusiness', 'selfgroupcommands'])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["adminrights", "alladminrights", "sysadmin", "business"])),
  created: function created() {
    this.businessrights = this.alladminrights;
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      email: null,
      msg: "Sign in with your provider."
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logUserInGoogle", "logUserInEmail"])),
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  // computed: mapGetters(["business"]),
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["person"]),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {}
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Profile",
  data: function data() {
    return {
      msg: ""
    };
  },

  methods: {},
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["person", "profile"]),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {}
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//


// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["business"]))

});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminBusinessProjects_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6908258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminBusinessProjects_vue__ = __webpack_require__(492);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminBusinessProjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6908258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminBusinessProjects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      positions: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    addPosition: function addPosition() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newkey, temppos;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newkey = void 0;
                _context.next = 3;
                return _this.createGuidKey().then(function (key) {
                  newkey = key;
                });

              case 3:
                temppos = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.business.positions.items);

                temppos[newkey] = {};
                _this.business.positions.items = temppos;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    removePosition: function removePosition(key) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var temppos;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(key);
                temppos = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.business.positions);

                delete temppos.items[key];
                _this2.business.positions = temppos;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    saveBusiness: function saveBusiness() {
      this.businesscommands({ command: 'saveBusinessStandardAdmin', business: this.business });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["createGuidKey", "businesscommands"])),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["business"])),
  created: function created() {},

  mounted: function mounted() {
    // this.mounted = true;
  }
});

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      linkedbusinesses: null,
      lodgebusinesses: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    refresh: function refresh() {
      this.getlinkedlist();
    },
    addLinkToBusiness: function addLinkToBusiness(linkedbusiness) {
      linkedbusiness.allowcreateremedial = true;
      this.businesslinkcommands({ linkedbusiness: linkedbusiness, command: 'addLinkToBusiness' });
    },
    togglecreateremedial: function togglecreateremedial(linkedbusiness) {
      console.log(linkedbusiness);
      var toggle = linkedbusiness.allowcreateremedial === undefined ? true : !linkedbusiness.allowcreateremedial;
      linkedbusiness.allowcreateremedial = toggle;
      this.businesslinkcommands({ linkedbusiness: linkedbusiness, command: 'toggleDirectRemedialCreation' });
      this.$refs.businessdialog.cancelDialog();
    },
    actionremovebusiness: function actionremovebusiness(args, linkedbusiness) {
      if (args.action) {
        this.businesslinkcommands({ linkedbusiness: linkedbusiness, command: 'removeLinkedBusiness' });
      }
      this.$refs.businessdialog.cancelDialog();
    },
    getlinkedlist: function getlinkedlist() {
      var _this = this;

      this.linkedbusiness({ business: this.business }).then(function (businessslist) {
        _this.linkedbusinesses = businessslist;
      });
    },
    getLodgelist: function getLodgelist() {
      var _this2 = this;

      this.lodgewithbusinesses({ business: this.business }).then(function (lodgebusinesses) {
        _this2.lodgebusinesses = lodgebusinesses;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeBusiness', 'lodgewithbusinesses', 'businesscommands', 'businesslinkcommands', 'fullbusiness', 'linkedbusiness', 'selfgroupcommands'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["adminrights", "alladminrights", "sysadmin", "business"])),
  created: function created() {
    this.getlinkedlist();
    this.getLodgelist();
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminBusinessProjects__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdminCommonConfig__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      metaconfig: {}
    };
  },
  components: {
    'business-projects': __WEBPACK_IMPORTED_MODULE_1__AdminBusinessProjects__["a" /* default */],
    'admin-common-config': __WEBPACK_IMPORTED_MODULE_2__AdminCommonConfig__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    saveBusiness: function saveBusiness() {
      this.businesscommands({ command: 'saveBusinessStandardAdmin', business: this.business });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["updateBusinessLocation", "businesscommands", "enableBusinesssAccount", "enableBusinessPositions"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["business", "sysadmin"]))
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["business"],
  data: function data() {
    return {
      tempbusiness: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    saveBusinessConfig: function saveBusinessConfig() {
      this.businesscommands({ command: 'saveBusinessConfig', business: this.tempbusiness });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["businesscommands", "enableBusinesssAccount", "enableBusinessPositions"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["sysadmin"])),
  created: function created() {
    this.tempbusiness = _.cloneDeep(this.business);
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// var mounted=true;
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      enableqrcode: false,
      selectedstaffmember: null,
      businessstaff: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onDecode: function onDecode(decodedString) {
      this.enableqrcode = false;
      if (decodedString) this.selectedstaffmember.token = decodedString;
      // console.log(decodedString)       
    },
    dialogActions: function dialogActions(e) {
      if (e.action === "canceldialog") {
        this.selectedstaffmember = null;
        this.enableqrcode = false;
      }
    },
    closedialog: function closedialog() {
      this.$refs.staffdialog.cancelDialog();
    },
    openStaffDialog: function openStaffDialog(id, staffmember) {
      this.selectedstaffmember = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, staffmember);
      this.$refs.staffdialog.show();
    },
    openAddStaffDialog: function openAddStaffDialog() {
      this.selectedstaffmember = { id: null, knownAs: null, rights: {} };
      this.$refs.staffdialog.show();
    },
    removeStaffMember: function removeStaffMember() {
      this.groupCommands(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ command: 'removeUser' }, this.selectedstaffmember));
    },
    saveStaffDetails: function saveStaffDetails() {
      if (this.selectedstaffmember.id) this.groupCommands(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ command: 'updateUser' }, this.selectedstaffmember));else this.groupCommands(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ command: 'addUser' }, this.selectedstaffmember));
    },
    refresh: function refresh() {
      var _this = this;

      if (!this.business) return;

      this.getBusinessStaff(this.business.id).then(function (staff) {
        _this.businessstaff = staff;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["groupCommands", "createGuidKey", "getBusinessStaff"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["business"])),
  created: function created() {
    this.refresh();
  },

  mounted: function mounted() {}
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_authsMixin__ = __webpack_require__(144);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_authsMixin__["a" /* default */]],
  data: function data() {
    return {
      tempremedial: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["remedialCommands", "fullremedial"]), {
    tabsActions: function tabsActions(_ref) {
      var action = _ref.action,
          data = _ref.data;

      if (action === 'saveImage') {
        this.remedialCommands({ command: 'saveRemedialImageMeta', remedial: this.tempremedial, business: this.tempremedial.business, meta: { image: data.image } });
      }
    },
    noteadded: function noteadded(_ref2) {
      var data = _ref2.data;

      this.remedialCommands({ command: 'addNoteToExistingRemedial', remedial: this.tempremedial, business: this.tempremedial.business, meta: { comment: data.note } });
    },
    saveRemedial: function saveRemedial() {
      this.remedialCommands({ command: 'saveExistingRemedial', business: this.tempremedial.business, remedial: this.tempremedial });
    },
    refresh: function refresh(_ref3) {
      var _this = this;

      var data = _ref3.data;

      this.fullremedial({ id: data.remedial.id, business: data.business }).then(function (res) {
        if (res) {
          _this.tempremedial = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: data.remedial.id }, res); // || remedial            
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["business", "alladminrights"]))

});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["alladminrights"])),
    methods: {
        AuthsRemedialRights: function AuthsRemedialRights(_ref) {
            var remedial = _ref.remedial,
                check = _ref.check;

            if (!remedial) return false;

            var business = remedial.business;

            if (this.alladminrights[business.id] && this.alladminrights[business.id][check]) return true;
            return false;
        },
        AuthsAllBusinessRightCheck: function AuthsAllBusinessRightCheck(check) {
            var _this = this;

            if (!this.alladminrights) return false;
            var found = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.alladminrights).find(function (key) {
                var right = _this.alladminrights[key];
                if (right[check]) return true;
            });
            return found;
        }
    }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["combinedremedials"]))
});

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["config"],
  data: function data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photo'
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["addImageToEntityReduceSize", "setToastMessage"]), {
    reset: function reset() {
      // reset form to initial state      
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save: function save(formData) {
      var _this = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      var myReader = new FileReader();
      var file = window.event.target.files[0];
      if (file.size > this.config.maxsize * 1000000) {
        this.setToastMessage({ type: 'error', message: "Image size is to large, reduce the image size to less then " + this.config.maxsize + "MB or use an existing edited image rather then your camera.", title: 'Warning' });
        this.reset();
        return false;
      }

      this.addImageToEntityReduceSize({ id: this.config.id, business_id: this.config.business_id, location: this.config.location, linkedbusinesslocation: this.config.linkedbusinesslocation, push: this.config.push || false, file: file }).then(function () {
        _this.reset();
      }, function (error) {
        _this.currentStatus = STATUS_FAILED;
      });
    },
    filesChange: function filesChange(fieldName, fileList) {
      // handle file changes
      var formData = new FormData();
      if (!fileList.length) return;
      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.save(formData);
    }
  }),
  computed: {
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.reset();
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["rating"],

  data: function data() {
    return {
      currentrating: this.rating
    };
  },
  methods: {
    ratingclicked: function ratingclicked(rate) {
      if (this.currentrating === rate) this.currentrating -= 1;else this.currentrating = rate;

      this.$emit("ratingclicked", {
        data: { rating: this.currentrating }
      });
    }
  }

});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "max", "maxlength", "placeholder"],
  computed: {
    fieldModelValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["label", "favourites", "id"],
  data: function data() {
    return {
      favrating: null
    };
  },
  methods: {
    favclicked: function favclicked() {
      this.favrating += 1;
      if (this.favrating > 3) this.favrating = null;

      this.$emit("favclicked", {
        data: { rating: this.favrating }
      });
    }
  },
  created: function created() {
    this.favrating = this.favourites && this.favourites[this.id] ? this.favourites[this.id].rating : 0;
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "statuses", "type"],
  data: function data() {
    return {};
  },
  computed: {
    fieldModelValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    statusfull: function statusfull(index, status) {
      var s = {};
      s[index] = status;
      return s;
    },
    actionClick: function actionClick($event) {
      this.$emit("statusselected", {
        action: $event.srcElement.value
      });
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  props: {

    value: {
      default: 0,
      type: Number
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 1,
      type: Number
    }
  },

  methods: {
    changevalue: function changevalue(number) {
      var newcompare = this.fieldModelValue + number;
      if (newcompare <= this.max && newcompare >= this.min) this.fieldModelValue = newcompare;
    }
  },
  created: function created() {

    this.fieldModelValue = this.fieldModelValue === 0 && this.min > 0 ? this.min : this.fieldModelValue;
  },

  computed: {
    fieldModelValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      business: null,
      meta: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fullbusiness']), {
    show: function show(_ref) {
      var _this = this;

      var business = _ref.business,
          meta = _ref.meta;

      //let clients know about      
      this.fullbusiness(business.id).then(function (fs) {
        if (fs) {
          _this.business = fs; // || business
          _this.business.id = business.id;
          _this.$emit('dialogActions', { action: 'businessfound', data: { fs: fs } });
        } else _this.$emit('dialogActions', { action: 'businessnotfound', data: { business: business } });

        _this.meta = meta;
        _this.$refs.businessDialog.show();
      });
    },
    cancelDialog: function cancelDialog() {
      this.$refs.businessDialog.cancelDialog(this);
    },
    dialogActions: function dialogActions(e) {
      if (e.action === 'canceldialog') {
        this.business = null;
        this.meta = null;
      }
    }
  })
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      remedial: null,
      meta: null,
      business: null,
      template: "<div>{{remedial}}</div>"
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["templateconfig"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    c: function c(event) {
      console.dir(event);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fullremedial', 'remedialCommands', 'location']), {
    add: function add(args) {
      this.meta = args && args.meta || null;
      this.remedial = { createAs: 'linkedremedial' };
      this.$refs.remedialDailog.show();
    },
    lodge: function lodge(args) {
      this.meta = args && args.meta || null;
      this.remedial = { createAs: 'lodgedremedial' };
      this.$refs.remedialDailog.show();
    },
    addRemedial: function addRemedial() {
      var createdfrombusiness = this.remedial.createdfrombusiness;
      delete this.remedial.createdfrombusiness;

      this.remedialCommands({ command: 'addNewRemedial', remedial: this.remedial, business: createdfrombusiness });
      this.$refs.remedialDailog.cancelDialog(this);
    },
    cancelDialog: function cancelDialog() {
      this.$refs.remedialDailog.cancelDialog(this);
    },
    dialogActions: function dialogActions(e) {
      if (e.action === 'canceldialog') {
        this.remedial = null;
        this.meta = null;
      }
    }
  })
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      businesses: null,
      meta: null
    };
  },
  props: ["selectedBusinesses"],
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fullbusiness']), {
    show: function show(args) {
      var _this = this;

      //let clients know about      
      this.fullbusiness().then(function (fs) {
        var test = _this.selectedBusinesses || {};
        var unselectedbusiness = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(fs).reduce(function (accum, key) {
          if (!test[key]) accum[key] = fs[key];
          return accum;
        }, {});

        _this.businesses = unselectedbusiness; // || business  
        _this.meta = args ? meta || null : null;
        _this.$refs.businessesDialog.show();
      });
    },
    cancelDialog: function cancelDialog() {
      this.$refs.businessesDialog.cancelDialog(this);
    },
    dialogActions: function dialogActions(e) {
      if (e.action === 'canceldialog') {
        this.business = null;
        this.meta = null;
      }
    }
  })
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "type"],
  data: function data() {
    return {
      businessestemps: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["business", "alladminrights"]), {
    fieldModelValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    constructbusinesslink: function constructbusinesslink(business, id) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, business, { id: id });
    },
    getBusinessess: function getBusinessess() {
      var _this = this;

      if (this.type === 'linked') {
        this.linkedbusiness({ business: this.business }).then(function (businessslist) {
          _this.businessestemps = businessslist;
        });
      }

      if (this.type === 'lodge') {
        this.lodgewithbusinesses({ business: this.business }).then(function (lodgebusinesses) {
          _this.businessestemps = lodgebusinesses;
        });
      }

      if (this.type === 'rights') {
        this.businessestemps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.alladminrights).reduce(function (accum, key) {
          accum[key] = _this.alladminrights[key];
          return accum;
        }, {});
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['lodgewithbusinesses', 'linkedbusiness'])),
  created: function created() {
    this.getBusinessess();
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      default: 'AddNoteDialog'
    },
    headertext: {
      type: String,
      default: "Add Note"
    },
    oktext: {
      type: String,
      default: "Yes"
    },
    usedefaultbutton: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      meta: null,
      tempnote: null
    };
  },
  methods: {
    dialogActions: function dialogActions(e) {
      if (e.action === "canceldialog") {
        this.meta = null;
        this.tempnote = null;
      }
    },
    show: function show(meta) {
      this.meta = meta || null;
      this.$refs.addNoteDialog.show();
    },
    cancelDialog: function cancelDialog() {
      this.$refs.addNoteDialog.cancelDialog();
    },
    ok: function ok() {
      this.$emit("noteadded", { data: { meta: this.meta, note: this.tempnote } });
      this.cancelDialog();
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      image: null
    };
  },
  methods: {
    show: function show(image) {
      this.image = image;
      this.$refs.imageDialog.show();
    },
    dialogActions: function dialogActions(e) {
      if (e.action === "canceldialog") {
        this.image = null;
      }
    },
    cancelDialog: function cancelDialog() {
      this.$refs.imageDialog.cancelDialog();
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "home"],
  data: function data() {
    return {
      selected: 'currentlocation',
      original: null
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setToastMessage"]), {
    OpenGoogleMaps: function OpenGoogleMaps() {
      window.open("https://www.google.com/maps/?q=" + this.latitude + "," + this.longitude);
    },
    changed: function changed(e) {
      var newval = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value);
      switch (this.selected) {
        case 'currentlocation':
          if (!this.original) {
            this.setToastMessage({ type: 'error', message: "Sorry no original location found", title: 'Locaton Error' });
            break;
          }
          newval.latitude = this.original.latitude;
          newval.longitude = this.original.longitude;
          this.fieldModelValue = newval;
          break;
        case 'mylocation':
          if (!this.location) {
            this.setToastMessage({ type: 'error', message: "Sorry your location is not set. Set this using the icon to the bottom right", title: 'Locaton Error' });
            break;
          }
          newval.latitude = this.location.latitude;
          newval.longitude = this.location.longitude;
          this.fieldModelValue = newval;
          break;
        case 'shoplocaton':
          if (!this.home) {
            this.setToastMessage({ type: 'error', message: "Sorry your home location is not set, this will need to be configured at the admin common page by an administrator.", title: 'Locaton Error' });
            break;
          }
          newval.latitude = this.home.latitude;
          newval.longitude = this.home.longitude;
          this.fieldModelValue = newval;
          break;
        default:
          break;
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["location"]), {
    fieldModelValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.setToastMessage({ type: 'info', message: "Location changed don't forget to save", title: 'Locaton' });
        this.$emit('input', newValue);
      }
    }
  }),
  created: function created() {
    this.original = { latitude: this.value.latitude, longitude: this.value.longitude };
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        id: {
            type: String
        },
        show: {
            type: Boolean,
            default: true
        }
    },

    data: function data() {
        return {
            tempshow: true //set a default
        };
    },
    methods: {
        toggle: function toggle() {
            this.tempshow = !this.tempshow;
            this.$emit('change', this.tempshow);
        }
    },
    created: function created() {
        this.tempshow = this.show;
        this.$emit('change', this.tempshow);
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["business"],
  data: function data() {
    return {
      groupusers: null
    };
  },
  computed: {
    fieldModelValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    constructfulluser: function constructfulluser(index, user) {
      var installer = {
        id: index,
        knownAs: user.knownAs
      };

      return installer;
    },
    getUsers: function getUsers() {
      var _this = this;

      this.getbusinessgroupusers({ business: this.business }).then(function (groupusers) {
        // let installers = Object.keys(groupusers).reduce((accum,key)=>{
        //     let gu = groupusers[key]
        //     if(gu.installer)
        //         accum[key] = {knownAs:gu.knownAs}
        //     return accum
        // },{})                                        
        _this.groupusers = groupusers;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getbusinessgroupusers'])),
  created: function created() {
    this.getUsers();
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["latitude", "longitude"],
  methods: {
    OpenGoogleMaps: function OpenGoogleMaps() {
      window.open("https://www.google.com/maps/?q=" + this.latitude + "," + this.longitude);
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      default: 'ConfirmDialogModal'
    },
    buttontext: {
      type: String,
      default: "Yes/No"
    },
    oktext: {
      type: String,
      default: "Yes"
    },
    usedefaultbutton: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'warning'
    }
  },
  data: function data() {
    return {
      meta: null
    };
  },
  methods: {
    dialogActions: function dialogActions(e) {
      if (e.action === "canceldialog") {}
    },
    openDialog: function openDialog(meta) {
      if (meta) {
        this.meta = meta; //pass through the meta
      }

      this.$refs.confirmDialog.show();
    },
    cancelDialog: function cancelDialog() {
      this.$refs.confirmDialog.cancelDialog();
    },
    yesno: function yesno(yes) {
      this.$emit("click", { action: yes, data: this.meta });
      this.cancelDialog();
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      meta: null,
      help: null,
      mapping: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["config"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["getHelpPage"]), {
    show: function show() {
      var _this = this;

      //let clients know about      
      var path = this.$route.path;
      path = path.split("/").join("_").substr(1);

      this.getHelpPage(path).then(function (content) {
        _this.help = content;
        _this.$refs.helpDialog.show();
      });
    },
    dialogActions: function dialogActions(e) {
      if (e.action === 'canceldialog') {
        this.meta = null;
      }
    }
  })
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["business"]
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["type"],
    data: function data() {
        return {
            meta: null
        };
    },
    methods: {
        show: function show(meta) {
            this.meta = meta || null;
            this.$emit('click', { action: 'showdialog', data: { meta: meta } });
            document.getElementById(this.$el.id).style.display = "block";
        },
        cancelDialog: function cancelDialog(e) {
            this.$emit('click', { action: 'canceldialog', data: { event: e } });
            document.getElementById(this.$el.id).style.display = "none";
            this.meta = null;
        }
    }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["show"],
    methods: {
        opentabfromlayout: function opentabfromlayout(event) {
            // console.log(event.currentTarget)
            // console.log(event.target)
            // console.log(event)
            // console.log(event.srcElement.attributes['tab'].value)
            var tab = event.target.id + '_tab';
            if (event.srcElement.attributes['tab']) tab = event.srcElement.attributes['tab'].value;

            var i = void 0;
            var tabs_display = document.getElementsByClassName("tabs_display");
            for (i = 0; i < tabs_display.length; i++) {
                tabs_display[i].style.display = "none";
            }

            var tablinks = document.getElementsByClassName("tablink");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" w3-red", "");
            }

            document.getElementById(tab).style.display = "block";
            event.target.className += " w3-red";
        }
    },
    mounted: function mounted() {
        if (this.show) {
            var tablink = document.getElementById('' + this.show);
            tablink.className += " w3-red";
            var displaytab = tablink.attributes['tab'] ? tablink.attributes['tab'].value : this.show + '_tab';
            document.getElementById(displaytab).style.display = "block";
        }
    }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["alladminrights"],
  name: 'RemedialsTableLayout',
  data: function data() {
    return {
      tempremedialslisting: {}
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["businessremedials"]), {
    refreshlist: function refreshlist(e, businessindex) {
      var _this = this;

      var temp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.tempremedialslisting);
      temp[businessindex] = 'loading';
      this.tempremedialslisting = temp;

      this.businessremedials({ id: businessindex }).then(function (remedials) {
        temp[businessindex] = remedials;
        _this.tempremedialslisting = temp;
      });
    },
    toggleMenu: function toggleMenu(e, businessindex) {
      var menu = document.getElementById(businessindex + "menu");
      if (menu) menu.style.display = e ? "block" : "none";
      if (e) this.refreshlist(e, businessindex);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["templateconfig"]))

});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_authsMixin__ = __webpack_require__(144);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var AsyncComponent = function(resolve) {
//     // console.log(store)
//     let temp = "<div>{{remedial}}</div>"
//         resolve({
//             store,
//             template: temp,
//             props:["remedial"],
//         });      
// };

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["remedial"],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_authsMixin__["a" /* default */]],
  methods: {
    openfullscreen: function openfullscreen(url) {
      window.open(url);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["templateconfig", "alladminrights"]))
  // data: function() {
  //   return {          
  //       // AsyncComponent : function(resolve) {

  //       //     let temp = "<div>{{remedial}}</div>"
  //       //         resolve({
  //       //             template: temp,
  //       //             props:["remedial"],
  //       //         });

  //       // }
  //   }
  // },
  // components:{
  //     'asy-test':AsyncComponent
  //     // 'test-template':function(resolve){

  //     //     let temp = "<div>{{remedial}}</div>"
  //     //     console.log(this.remedial)
  //     //     setTimeout(function() {
  //     //       resolve({
  //     //           props:["remedial"],
  //     //           template:temp
  //     //       })  
  //     //     }, 2000);

  //     // }
  // }

});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["remedial", "mode", "statuses"]
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["remedial"]
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["businesses"],
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_w3_css_w3_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_w3_css_w3_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_w3_css_w3_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_router_sync__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_analytics__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_font_awesome_css_font_awesome_css__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_qrcode_reader__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_qrcode_reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_shared_ImageEditor__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_shared_RatingSelector__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_shared_PageNotesEditor__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_shared_FavSelection__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_shared_StatusSelector__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_shared_QuantitySelector__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_shared_BusinessDialog__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_shared_RemedialDialog__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_shared_BusinessesLinksDialog__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_shared_BusinessesLinksList__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_shared_controls_AddNoteDialog__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_shared_controls_ImageDialog__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_shared_controls_buttons_CancelDialogButton__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_shared_controls_buttons_BackButton__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_shared_controls_buttons_CancelButton__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_shared_controls_buttons_RefreshButton__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_shared_controls_buttons_SaveButton__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_shared_controls_buttons_AddButton__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_shared_controls_buttons_AddCartButton__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_shared_controls_buttons_BuyNowButton__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_shared_controls_buttons_TabLinkButton__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_shared_controls_buttons_CloneButton__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_shared_controls_buttons_SetLocationButton__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_shared_controls_OpenClose__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_shared_controls_Installers__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_shared_controls_buttons_NewButton__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_shared_controls_buttons_DeleteButton__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_shared_controls_buttons_UpdateButton__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_shared_controls_buttons_OpenGoogleMaps__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_shared_controls_buttons_LargeButton__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_shared_controls_buttons_LargeButtonWide__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_shared_controls_ConfirmDialog__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_shared_controls_HelpDialog__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_shared_controls_layouts_CommonPageLayout__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_shared_controls_layouts_ULLayout__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_shared_controls_layouts_BusinessInfoLayout__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_shared_controls_layouts_BusinessInfoLayoutItem__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_shared_controls_layouts_DialogLayout__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_shared_controls_layouts_TabLinkLayout__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_shared_controls_layouts_RemedialsTableLayout__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_shared_controls_layouts_RemedialTabsLayout__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_shared_controls_layouts_RemedialLayout__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_shared_controls_layouts_RemedialNewLayout__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_shared_controls_layouts_TabLayout__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_shared_controls_layouts_BusinessesLayout__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_lodash__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_vue_lodash__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__deveodk_vue_toastr__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;





var unsync = Object(__WEBPACK_IMPORTED_MODULE_10_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_qrcode_reader___default.a);

//import components globaly


























































__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('pagenotes-editor', __WEBPACK_IMPORTED_MODULE_17__components_shared_PageNotesEditor__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('image-editor', __WEBPACK_IMPORTED_MODULE_15__components_shared_ImageEditor__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('rating-selector', __WEBPACK_IMPORTED_MODULE_16__components_shared_RatingSelector__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('fav-selector', __WEBPACK_IMPORTED_MODULE_18__components_shared_FavSelection__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('status-selector', __WEBPACK_IMPORTED_MODULE_19__components_shared_StatusSelector__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('quantity-selector', __WEBPACK_IMPORTED_MODULE_20__components_shared_QuantitySelector__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('remedial-tabs-layout', __WEBPACK_IMPORTED_MODULE_55__components_shared_controls_layouts_RemedialTabsLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('remedial-layout', __WEBPACK_IMPORTED_MODULE_56__components_shared_controls_layouts_RemedialLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('remedial-new-layout', __WEBPACK_IMPORTED_MODULE_57__components_shared_controls_layouts_RemedialNewLayout__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('help-dialog', __WEBPACK_IMPORTED_MODULE_47__components_shared_controls_HelpDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('business-dialog', __WEBPACK_IMPORTED_MODULE_21__components_shared_BusinessDialog__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('remedial-dialog', __WEBPACK_IMPORTED_MODULE_22__components_shared_RemedialDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('businesses-links-dialog', __WEBPACK_IMPORTED_MODULE_23__components_shared_BusinessesLinksDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('businesses-links-list', __WEBPACK_IMPORTED_MODULE_24__components_shared_BusinessesLinksList__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('add-note-dialog', __WEBPACK_IMPORTED_MODULE_25__components_shared_controls_AddNoteDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('image-dialog', __WEBPACK_IMPORTED_MODULE_26__components_shared_controls_ImageDialog__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('cancel-dialog-button', __WEBPACK_IMPORTED_MODULE_27__components_shared_controls_buttons_CancelDialogButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('back-button', __WEBPACK_IMPORTED_MODULE_28__components_shared_controls_buttons_BackButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('cancel-button', __WEBPACK_IMPORTED_MODULE_29__components_shared_controls_buttons_CancelButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('refresh-button', __WEBPACK_IMPORTED_MODULE_30__components_shared_controls_buttons_RefreshButton__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('save-button', __WEBPACK_IMPORTED_MODULE_31__components_shared_controls_buttons_SaveButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('update-button', __WEBPACK_IMPORTED_MODULE_42__components_shared_controls_buttons_UpdateButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('open-gooogle-maps', __WEBPACK_IMPORTED_MODULE_43__components_shared_controls_buttons_OpenGoogleMaps__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('set-location-button', __WEBPACK_IMPORTED_MODULE_37__components_shared_controls_buttons_SetLocationButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('open-close', __WEBPACK_IMPORTED_MODULE_38__components_shared_controls_OpenClose__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('installers-group', __WEBPACK_IMPORTED_MODULE_39__components_shared_controls_Installers__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('add-button', __WEBPACK_IMPORTED_MODULE_32__components_shared_controls_buttons_AddButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('add-cart-button', __WEBPACK_IMPORTED_MODULE_33__components_shared_controls_buttons_AddCartButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('buy-now-button', __WEBPACK_IMPORTED_MODULE_34__components_shared_controls_buttons_BuyNowButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('tab-link-button', __WEBPACK_IMPORTED_MODULE_35__components_shared_controls_buttons_TabLinkButton__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('delete-button', __WEBPACK_IMPORTED_MODULE_41__components_shared_controls_buttons_DeleteButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('clone-button', __WEBPACK_IMPORTED_MODULE_36__components_shared_controls_buttons_CloneButton__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('new-button', __WEBPACK_IMPORTED_MODULE_40__components_shared_controls_buttons_NewButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('large-button', __WEBPACK_IMPORTED_MODULE_44__components_shared_controls_buttons_LargeButton__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('large-button-wide', __WEBPACK_IMPORTED_MODULE_45__components_shared_controls_buttons_LargeButtonWide__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('confirm-dialog', __WEBPACK_IMPORTED_MODULE_46__components_shared_controls_ConfirmDialog__["a" /* default */]);

//layouts
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('common-page-layout', __WEBPACK_IMPORTED_MODULE_48__components_shared_controls_layouts_CommonPageLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('business-info-layout', __WEBPACK_IMPORTED_MODULE_50__components_shared_controls_layouts_BusinessInfoLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('businesses-layout', __WEBPACK_IMPORTED_MODULE_59__components_shared_controls_layouts_BusinessesLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('businesses-layout-item', __WEBPACK_IMPORTED_MODULE_51__components_shared_controls_layouts_BusinessInfoLayoutItem__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('ul-layout', __WEBPACK_IMPORTED_MODULE_49__components_shared_controls_layouts_ULLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('dialog-layout', __WEBPACK_IMPORTED_MODULE_52__components_shared_controls_layouts_DialogLayout__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('remedials-table-layout', __WEBPACK_IMPORTED_MODULE_54__components_shared_controls_layouts_RemedialsTableLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('tablink-layout', __WEBPACK_IMPORTED_MODULE_53__components_shared_controls_layouts_TabLinkLayout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('tab-layout', __WEBPACK_IMPORTED_MODULE_58__components_shared_controls_layouts_TabLayout__["a" /* default */]);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_61_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_60_lodash___default.a); //registers the use of _.


// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_62__deveodk_vue_toastr___default.a, {
  defaultPosition: 'toast-top-full-width', //'toast-top-center',//'toast-bottom-left',
  defaultType: 'info',
  defaultTimeout: 3000,
  preventDuplicates: true

});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_analytics___default.a, {
  id: 'UA-121804857-1'
});

/* eslint-disable no-new */
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('currency', function (value) {
  if (value) {
    if (value < 0) {
      return '-$' + Math.abs(parseFloat(value)).toFixed(2);
    } else return '$' + parseFloat(value).toFixed(2);
  } else {
    return "$0";
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('statustype', function (status, type) {

  if (!status || status === undefined) return { colour: '', name: 'To be Actioned' }[type];

  var s = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(status)[0];
  return status[s][type];

  //     // return statuses && status && statuses[status]?statuses[status]:{}
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('remedialtype', function (value) {
  switch (value) {
    case 'createdto':
      return 'Created for';
    case 'createdby':
      return 'Created by';
    case 'lodgedto':
      return 'Logged with';
    case 'lodgedby':
      return 'Logged by';
    default:
      'Unknown';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('toUpperCase', function (value) {
  return value.toUpperCase();
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_12_moment___default()(value).calendar(); //format('LLL')
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('locationdisplay', function (value) {
  if (value) {
    var n = Number(value);
    var symbol = "m";
    if (n > 1000) {
      symbol = "km";
      n = n / 1000;
      n = n.toFixed(1);
    } else {
      n = n.toFixed(0);
    }

    return '' + n + symbol;
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#vue-app',
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store: __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] },
  methods: Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['setLocation', 'setfcmToken', 'setBusiness', 'setupUser', 'initiateDealsWatcher', 'initiateFIBIPublicDeals', 'setUpServiceWorker', 'setBannerMessage', 'setConfig', 'setBusinessReferences', 'setToastMessage', 'setNewVersionAvailable']),
  created: function created() {
    var _this = this;

    // Vue.http.options.root = '/';
    __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.initializeApp(Object({"apiKey":"AIzaSyAosJgwAyQ3L6Pc-CRAEetzetGB5itKwA8","authDomain":"remedials-work.firebaseapp.com","databaseURL":"https://remedials-work.firebaseio.com","projectId":"remedials-work","storageBucket":"remedials-work.appspot.com","messagingSenderId":"870044795724"}));

    //The state here is post mutation. 
    __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */].subscribe(function (action, state) {
      // console.log(action)

      // if (action.type === "setToastMessage" && state.toastmessage) {
      //   var tm = state.toastmessage;
      //   this.$toastr(tm.type, tm.message, tm.title)  
      // }

      switch (action.type) {
        case 'setHelp':
        case 'updateOrder':
        case 'clearOrder':
        case 'last10AccountTransactions':
        case 'setProfile':

          ga('send', 'event', 'Mutation', action.type);
          _this.$ga.event({
            eventCategory: 'Mutation',
            eventAction: action.type
          });

          break;
        case 'route/ROUTE_CHANGED':
          _this.$ga.page({
            page: action.payload.to.name,
            title: action.payload.to.name,
            location: window.location.href
          });
          // ga('send', 'event', 'Mutation', action.type,action.payload.to.name); 
          break;
        default:
          break;
      }
    });

    this.setConfig(window.globals).then(function () {
      _this.setUpServiceWorker();
    });
    // if(window.globals.newversionfound)
    // {
    //     this.setNewVersionAvailable(true)
    // }
    // commit('setNewVersionAvailable',true)

    // console.log("about to run service worker")

    // console.log("after service worker")

    this.setBusiness(window.globals.id).then(function (business) {
      // if(business.name === 'FIBI')      
      //     router.push('fibitiles')  //go to tiles                  
      // else      
      //     this.initiateFIBIPublicDeals()      

      _this.setBusinessReferences(business.id); //we need the business before loading user details.

      //set up the application first before logging user in.
      __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.auth().onAuthStateChanged(function (user) {
        _this.setupUser(user);
      });
    });
  }
});

// During app/Vue teardown (e.g., you only use Vue.js in a portion of your app and you 
// navigate away from that portion and want to release/destroy Vue components/resources)
// unsync() // Unsyncs store from router

/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d36f4164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(431);
function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d36f4164_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderLayout_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01354e7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderLayout_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01354e7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.business)?_c('span',[_c('header',{staticClass:"w3-top w3-bar w3-theme w3-hide-large",staticStyle:{"height":"60px"}},[_c('large-button',{on:{"click":function($event){_vm.click('opensidebar')}}},[_vm._v("☰")]),_vm._v(" "+_vm._s(_vm.business.name)+":"+_vm._s(_vm.business.declineorders)+"      \n    "),_c('h3',{staticClass:"w3-bar-item w3-display-topmiddle"},[(_vm.business.hidehelp)?_c('span',{staticClass:"w3-button w3-large w3-circle w3-hover-theme"},[(_vm.routetitle)?_c('label',[_vm._v(_vm._s(_vm.routetitle))]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.business.hidehelp)?_c('span',{staticClass:"w3-button w3-large w3-circle w3-hover-theme",on:{"click":function($event){_vm.click('openhelppage')}}},[(_vm.routetitle)?_c('label',[_vm._v(_vm._s(_vm.routetitle))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-question-circle"})]):_vm._e()])],1),_vm._v(" "),_c('header',{staticClass:"w3-bar w3-display-container w3-theme w3-hide-small w3-hide-medium large-header-top"},[_c('span',{staticClass:"w3-bar-item w3-display-topleft"},[_c('span',{staticClass:"header-shop-name"},[_vm._v(_vm._s(_vm.business.name))])]),_vm._v(" "),_c('h3',{staticClass:"w3-bar-item w3-display-topmiddle"},[(_vm.business.hidehelp)?_c('span',{staticClass:"w3-button w3-large w3-circle w3-hover-theme"},[(_vm.routetitle)?_c('label',[_vm._v(_vm._s(_vm.routetitle))]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.business.hidehelp)?_c('span',{staticClass:"w3-button w3-large w3-circle w3-hover-theme",on:{"click":function($event){_vm.click('openhelppage')}}},[(_vm.routetitle)?_c('label',[_vm._v(_vm._s(_vm.routetitle))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-question-circle"})]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"w3-display-bottomleft"},[(_vm.adminrights)?_c('router-link',{staticClass:"w3-bar-item",attrs:{"to":"/admin/customerremedials/processing"}},[_vm._v("Remedials")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w3-dropdown-hover"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"w3-dropdown-content w3-bar-block w3-theme-action"},[(_vm.business.pwa)?_c('router-link',{staticClass:"w3-bar-item",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.business.pwa.menus.home))]):_vm._e(),_vm._v(" "),(_vm.business.pwa)?_c('router-link',{staticClass:"w3-bar-item",attrs:{"to":"/about"}},[_vm._v(_vm._s(_vm.business.pwa.menus.about))]):_vm._e(),_vm._v(" "),(_vm.sysadmin || (_vm.alladminrights && Object.keys(_vm.alladminrights).length>=1))?_c('router-link',{staticClass:"w3-bar-item",attrs:{"to":"/businessselect"}},[_vm._v("My Businesses")]):_vm._e()],1)]),_vm._v(" "),(_vm.adminrights && (_vm.adminrights.read || _vm.adminrights.write))?_c('div',{staticClass:"w3-dropdown-hover"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"w3-dropdown-content w3-bar-block w3-theme-action"},[_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/admin/common"}},[_vm._v("Common Configuration")]),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/admin/businesslinks"}},[_vm._v("Links")]),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/admin/staff"}},[_vm._v("Staff")]),_vm._v(" "),(_vm.adminrights && _vm.adminrights.custorderprocess)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/admin/customerorders/home"}},[_vm._v("Cust Orders")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w3-dropdown-hover"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"w3-dropdown-content w3-bar-block w3-theme-action"},[(_vm.business && !_vm.business.hidehelp)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/how"}},[_vm._v("How To")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/wpp"}},[_vm._v("Privacy")]),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/termsconditions"}},[_vm._v("Terms")]),_vm._v(" "),_c('a',{staticClass:"w3-bar-item w3-button",attrs:{"href":"#"},on:{"click":function($event){_vm.click('unregister')}}},[_vm._v("Refresh")])],1)])],1),_vm._v(" "),_c('span',{staticClass:"w3-display-bottomright"},[(!_vm.person)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/login"}},[_vm._v("Login")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w3-dropdown-hover"},[(_vm.person)?_c('span',{staticClass:"w3-bar-item w3-button"},[_vm._v("\n          "+_vm._s(_vm.person.displayName || 'Profile')+" "),_c('i',{staticClass:"fa fa-caret-down"})]):_vm._e(),_vm._v(" "),(_vm.person)?_c('div',{staticClass:"w3-dropdown-content w3-bar-block w3-theme-action"},[(_vm.profile)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/profile"}},[_vm._v("Profile")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"w3-bar-item w3-button",attrs:{"href":"#"},on:{"click":function($event){_vm.click('logout');_vm.$router.push('home')}}},[_vm._v("Logout")])],1):_vm._e()])],1)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w3-bar-item"},[_vm._v("\n          Home "),_c('i',{staticClass:"fa fa-caret-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w3-bar-item"},[_vm._v("\n          Administration "),_c('i',{staticClass:"fa fa-caret-down"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w3-bar-item"},[_vm._v("\n          Help "),_c('i',{staticClass:"fa fa-caret-down"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNavLayout_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_998bb588_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNavLayout_vue__ = __webpack_require__(424);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNavLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_998bb588_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNavLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.business)?_c('nav',{staticClass:"w3-sidebar w3-bar-block w3-card w3-hide-large",staticStyle:{"display":"none","z-index":"999"},attrs:{"id":"mySidebar"}},[_c('div',{staticClass:"w3-container w3-theme-d2"},[_c('large-button',{staticClass:"w3-display-topright",on:{"click":function($event){_vm.click('closesidebar')}}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"w3-padding w3-center"},[_c('img',{staticClass:"w3-circle",staticStyle:{"width":"60px"},attrs:{"src":_vm.business.favi,"alt":"logo"}})]),_vm._v(" "),(_vm.person)?_c('div',{staticClass:"w3-padding w3-center"},[_vm._v("\n       "+_vm._s(_vm.person.displayName)+"\n     ")]):_vm._e()],1),_vm._v(" "),(_vm.business)?_c('div',{on:{"click":function($event){_vm.click('closesidebar')}}},[_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/admin/customerremedials/processing"}},[_vm._v("Remedials")]),_vm._v(" "),(_vm.alladminrights && Object.keys(_vm.alladminrights).length>=1)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/businessselect"}},[_vm._v("Shops")]):_vm._e(),_vm._v(" "),(_vm.business.pwa)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.business.pwa.menus.home))]):_vm._e(),_vm._v(" "),(_vm.business.pwa)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/about"}},[_vm._v(_vm._s(_vm.business.pwa.menus.about))]):_vm._e(),_vm._v(" "),(_vm.adminrights && (_vm.adminrights.read || _vm.adminrights.write))?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/admin/home"}},[_vm._v("Admin")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.profile)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/profile"}},[_vm._v("Profile")]):_vm._e(),_vm._v(" "),(!_vm.person)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/login"}},[_vm._v("Login")]):_c('a',{staticClass:"w3-bar-item w3-button",attrs:{"href":"#"},on:{"click":function($event){_vm.click('logout');_vm.$router.push('home')}}},[_vm._v("Logout")]),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/wpp"}},[_vm._v("Privacy")]),_vm._v(" "),_c('a',{staticClass:"w3-bar-item w3-button",attrs:{"href":"#"},on:{"click":function($event){_vm.click('unregister')}}},[_vm._v("Refresh")])],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageCentreLayout_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476edb07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageCentreLayout_vue__ = __webpack_require__(427);
function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageCentreLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476edb07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageCentreLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.showmessagebar)?_c('span',{staticClass:"w3-bottom w3-bar w3-theme-l4 bottommenubarmessages",on:{"click":function($event){_vm.showmessagebar=false}}},[_c('span',{staticClass:"w3-button w3-large w3-display-topright"},[_vm._v("X")]),_vm._v(" "),_c('span',{staticClass:"w3-button w3-large w3-display-topleft"},[_vm._v("Logs")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',{staticClass:"w3-ul w3-small"},_vm._l((_vm.last10messages),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(index+1)+".             \n            "),_c('font',{attrs:{"color":[item.type==='error'? 'red' : item.type==='warning'? 'orange' : 'green' ]}},[_vm._v(_vm._s(item.message))])],1)}))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"w3-bottom w3-bar w3-theme-l2 bottommenubar"},[(_vm.last10messages)?_c('i',{staticClass:"fa fa-exclamation-circle w3-left",on:{"click":function($event){_vm.showmessagebar=!_vm.showmessagebar;_vm.setBannerMessage(null)}}},[_vm._v(" ("+_vm._s(_vm.last10messages.length)+")")]):_vm._e(),_vm._v(" "),(!_vm.fcmToken || _vm.fcmToken==='errornotoken')?_c('span',{staticClass:"w3-display-middle",on:{"click":function($event){_vm.setNotifications()}}},[_vm._v("Notices?")]):_vm._e(),_vm._v(" "),(!_vm.location)?_c('span',{staticClass:"w3-right",on:{"click":function($event){_vm.setCurrentLocation()}}},[_vm._v("Set Location "),_c('i',{staticClass:"fa fa-map-marker"})]):_vm._e(),_vm._v(" "),(_vm.location)?_c('i',{staticClass:"fa fa-map-marker w3-right w3-green"}):_vm._e()]),_vm._v(" "),(_vm.bannermessage)?_c('span',{staticClass:"w3-bottom w3-bar w3-theme-l2 bannermessage",class:[_vm.bannermessage.type==='error'? 'w3-red' : _vm.bannermessage.type==='warning'? 'w3-orange' : 'w3-green' ],on:{"click":function($event){_vm.setBannerMessage(null)}}},[_c('span',{staticClass:"w3-button w3-large w3-right",class:[_vm.bannermessage.type==='error'? 'w3-red' : _vm.bannermessage.type==='warning'? 'w3-orange' : 'w3-green' ]},[_vm._v("×")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.bannermessage.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afced53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterLayout_vue__ = __webpack_require__(430);
function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afced53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w3-container w3-center footer"},[_vm._v("            \n    Built on the FIBI.Works platform. For details see "),_c('a',{attrs:{"target":"_blank","href":"https://fibi.works"}},[_vm._v("FIBI")]),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/termsconditions"}},[_vm._v("Terms")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-layout',{on:{"click":_vm.commonactions}}),_vm._v(" "),_c('sidenav-layout',{on:{"click":_vm.commonactions}}),_vm._v(" "),_c('message-centre-layout'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"60px"},on:{"click":function($event){_vm.closeSidebar()}}},[(_vm.newversionavailable)?_c('div',{staticClass:"w3-panel w3-display-container w3-green",staticStyle:{"z-index":"900"},on:{"click":function($event){_vm.unRegister()}}},[_c('span',{staticClass:"w3-button w3-large w3-display-topright w3-green"},[_vm._v("×")]),_vm._v(" "),_c('p',[_vm._v("Updates available, click here to quickly refresh")])]):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"routerview"})],1),_vm._v(" "),_c('footer-layout'),_vm._v(" "),_c('help-dialog',{ref:"helpdialog"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */,
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dc38d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(446);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dc38d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sysadmin || _vm.adminrights)?_c('common-page-layout',[_c('large-button-wide',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('/admin/customerremedials/processing')}}},[_vm._v("Current Remedials")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerRemedialsTile_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cea4f6c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerRemedialsTile_vue__ = __webpack_require__(436);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerRemedialsTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cea4f6c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerRemedialsTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.adminrights)?_c('div',{staticClass:"w3-card-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px"}},[(_vm.adminrights)?_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('/admin/customerremedials/processing')}}},[_vm._v("Current Remedials")]):_vm._e(),_vm._v(" "),_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('/admin/customerremedials/declined')}}},[_vm._v("Declined Remedials")])],1),_vm._v(" "),_vm._m(1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w3-container w3-theme-d2"},[_c('h3',[_vm._v("Customer Remedials")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_c('b',[_vm._v("Here you can process customer remedials or view declined remedials.  When processing remedials notifications are sent to customers instantly.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessImageBasicTile_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d751c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessImageBasicTile_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessImageBasicTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d751c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessImageBasicTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"src":_vm.business.image}},[_c('header',{staticClass:"w3-container w3-theme-d2 w3-hide-small"},[_c('h3',[_vm._v(_vm._s(_vm.business.name))])]),_vm._v(" "),_c('div',{staticClass:"w3-row"},[_c('div',{staticClass:"w3-half ",staticStyle:{"padding":"10px","text-align":"center"}},[_c('img',{staticClass:"businessimage",attrs:{"src":_vm.business.image}})]),_vm._v(" "),_c('div',{staticClass:"w3-half",staticStyle:{"padding":"10px","text-align":"center"}},[_c('business-info-layout',{attrs:{"business":_vm.business}}),_vm._v(" "),_c('p',[_c('open-gooogle-maps',{attrs:{"latitude":_vm.business.latitude,"longitude":_vm.business.longitude}})],1)],1)]),_vm._v(" "),(_vm.business.pwa)?_c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_c('b',[_vm._v(_vm._s(_vm.business.pwa.homeabout))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeAboutTile_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a89b32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeAboutTile_vue__ = __webpack_require__(441);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeAboutTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a89b32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeAboutTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.business)?_c('div',{staticClass:"w3-card-4"},[_c('header',{staticClass:"w3-container w3-theme-d2"},[_c('h3',[_vm._v("About "+_vm._s(_vm.business.name))])]),_vm._v(" "),_c('p',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(_vm.business.pwa.about))]),_vm._v(" "),_c('p',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(_vm.business.pwa.howto))]),_vm._v(" "),_c('p',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(_vm.business.pwa.instructions))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyRemedialsTile_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067d242d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyRemedialsTile_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyRemedialsTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067d242d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyRemedialsTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-card-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px"}},[_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('myremedials')}}},[_vm._v("Remedials")])],1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w3-container w3-theme-d2"},[_c('h3',[_vm._v("My Remedials")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_c('b',[_vm._v("Go to the Remedials page to make create/manage your remedials.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OptionsTile_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369f9b67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OptionsTile_vue__ = __webpack_require__(445);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OptionsTile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369f9b67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OptionsTile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newversionavailable || _vm.addtohomescreen || !_vm.location || !_vm.fcmToken || _vm.fcmToken==='errornotoken')?_c('div',{staticClass:"w3-card-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px"}},[(_vm.addtohomescreen)?_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.addToHomeScreen()}}},[_vm._v("Add To Home")]):_vm._e(),_vm._v(" "),(!_vm.location)?_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.setCurrentLocation()}}},[_vm._v("Set Location "),_c('i',{staticClass:"fa fa-map-marker"})]):_vm._e(),_vm._v(" "),(!_vm.fcmToken || _vm.fcmToken==='errornotoken')?_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.setNotifications()}}},[_vm._v("Set Notifications")]):_vm._e(),_vm._v(" "),(_vm.newversionavailable)?_c('large-button',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.unRegister()}}},[_vm._v("Updates available")]):_vm._e()],1),_vm._v(" "),(_vm.addtohomescreen)?_c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v("Click add to Home to create a short cut on your home screen. This provides a nicer experience like a normal mobile or PC app without installing anything at all.")]):_vm._e(),_vm._v(" "),(!_vm.location)?_c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v("Click to set your location, this helps with letting the vendor know where your remedial work is located.")]):_vm._e(),_vm._v(" "),(!_vm.fcmToken || _vm.fcmToken==='errornotoken')?_c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v("Turn on notifications, this allows direct notices about your orders to be sent to you, handy if you phone is locked or application window is not visible.")]):_vm._e(),_vm._v(" "),(_vm.newversionavailable)?_c('footer',{staticClass:"w3-small",staticStyle:{"padding":"10px"}},[_vm._v("A new version is available that offers more enhancements and bug fixes. Click to get these changes.")]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w3-container w3-theme-d2"},[_c('h3',[_vm._v("Your Options")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.business)?_c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('large-button',{on:{"click":function($event){_vm.$router.push('/admin/customerremedials/processing')}}},[_vm._v("Remedials")]),_vm._v(" "),(_vm.addtohomescreen)?_c('large-button',{on:{"click":function($event){_vm.addToHomeScreen()}}},[_vm._v("Add To Home")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"w3-row",attrs:{"slot":"smallscreen"},slot:"smallscreen"},[(_vm.addtohomescreen)?_c('h5',[_c('font',{attrs:{"color":"green"}},[_vm._v("Click add to Home to create a short cut on your home screen. This provides a nicer experience like a normal mobile or PC app without installing anything at all.")])],1):_vm._e(),_vm._v(" "),_c('business-image-basic-tile',{attrs:{"business":_vm.business}})],1),_vm._v(" "),_c('div',{staticClass:"w3-row",attrs:{"slot":"largescreen"},slot:"largescreen"},[_c('div',{staticClass:"w3-quarter w3-container"},[_c('options-tile')],1),_vm._v(" "),_c('div',{staticClass:"w3-half w3-container"},[_c('business-image-basic-tile',{staticClass:"w3-card-4",attrs:{"business":_vm.business}}),_c('br'),_vm._v(" "),_c('home-about-tile',{attrs:{"business":_vm.business}})],1),_vm._v(" "),_c('div',{staticClass:"w3-quarter w3-container"},[_c('customer-remedials-tile',{attrs:{"adminrights":_vm.adminrights}}),_c('br')],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_How_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb343ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_How_vue__ = __webpack_require__(448);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_How_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb343ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_How_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[(_vm.help)?_c('back-button',{on:{"click":function($event){_vm.openHelp(null)}}}):_vm._e()],1),_vm._v(" "),(!_vm.help)?_c('span',[_c('large-button-wide',{on:{"click":function($event){_vm.openHelp('howtoorder')}}},[_vm._v("\n      How to Create Remedial Request \n    ")]),_c('br'),_vm._v(" "),_c('large-button-wide',{on:{"click":function($event){_vm.openHelp('cart')}}},[_vm._v("\n      Manage My Remedial\n    ")]),_c('br'),_vm._v(" "),_c('large-button-wide',{on:{"click":function($event){_vm.openHelp('orders')}}},[_vm._v("\n      Remedials\n    ")]),_c('br'),_vm._v(" "),_c('large-button-wide',{on:{"click":function($event){_vm.openHelp('what_are_pwa')}}},[_vm._v("\n      PWA\n    ")]),_c('br')],1):_vm._e(),_vm._v(" "),(_vm.help)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.help.htmlcontent)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WPP_vue__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d6feda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WPP_vue__ = __webpack_require__(450);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WPP_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d6feda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WPP_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('large-button',{on:{"click":function($event){_vm.$router.push('home')}}},[_vm._v("Home")])],1),_vm._v(" "),(_vm.help)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.help.htmlcontent)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TANDCS_vue__ = __webpack_require__(115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7547b74f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TANDCS_vue__ = __webpack_require__(452);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TANDCS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7547b74f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TANDCS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('large-button',{on:{"click":function($event){_vm.$router.push('home')}}},[_vm._v("\n      Home\n    ")])],1),_vm._v(" "),(_vm.help)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.help.htmlcontent)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ddaf53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ddaf53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',{staticClass:"googlelayout"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"600","height":"450","frameborder":"0","src":"https://www.google.com/maps/?q=-15.623037,18.388672","allowfullscreen":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fb3dae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(457);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fb3dae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[(_vm.business.pwa)?_c('p',[_vm._v(_vm._s(_vm.business.pwa.about))]):_vm._e(),_vm._v(" "),(_vm.business && _vm.business.pwa && _vm.business.pwa.howto)?_c('p',[_vm._v(_vm._s(_vm.business.pwa.howto))]):_vm._e(),_vm._v(" "),(_vm.business && _vm.business.pwa && _vm.business.pwa.instructions)?_c('p',[_vm._v(_vm._s(_vm.business.pwa.instructions))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessSelect_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf05f69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessSelect_vue__ = __webpack_require__(459);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf05f69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[(_vm.sysadmin)?_c('new-button',{on:{"click":function($event){_vm.newBusiness()}}}):_vm._e(),_vm._v(" "),(_vm.sysadmin)?_c('large-button',{on:{"click":function($event){_vm.getFullBusinesssListing()}}},[_vm._v("All..")]):_vm._e(),_vm._v(" "),_c('large-button',{on:{"click":_vm.refresh}},[_vm._v("Refresh")])],1),_vm._v(" "),_vm._l((_vm.businessrights),function(alladminright,index){return _c('p',{key:index},[_c('large-button-wide',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$refs.businessdialogmenulayout.show({business:{id:index},meta:index})}}},[_c('b',[_vm._v(_vm._s(alladminright.name))]),_vm._v(" (about)  \n      ")])],1)}),_vm._v(" "),_c('dialog-layout',{ref:"addbusinessialog",attrs:{"id":"addbusinessialog"},on:{"click":_vm.dialogActions},scopedSlots:_vm._u([{key:"headercontent",fn:function(slotScope){return _c('h3',{},[_vm._v(_vm._s(slotScope.meta && slotScope.meta.id?'Clone ' +slotScope.meta.existingname :'New Business'))])}},{key:"default",fn:function(slotScope){return (slotScope && slotScope.meta)?_c('span',{},[_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Name (required)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.name),expression:"slotScope.meta.name"}],staticClass:"w3-input w3-border",attrs:{"placeholder":"This is required","max":"75","maxlength":"75"},domProps:{"value":(slotScope.meta.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "name", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"red"}},[_vm._v("Name is required.")])],1),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Name2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.name2),expression:"slotScope.meta.name2"}],staticClass:"w3-input w3-border",attrs:{"max":"75","maxlength":"75"},domProps:{"value":(slotScope.meta.name2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "name2", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Short Name (required)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.shortname),expression:"slotScope.meta.shortname"}],staticClass:"w3-input w3-border",attrs:{"placeholder":"This is required","max":"75","maxlength":"75"},domProps:{"value":(slotScope.meta.shortname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "shortname", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"red"}},[_vm._v("Used to display short name for display and PWA name.")])],1),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Cellphone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.phone),expression:"slotScope.meta.phone"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel"},domProps:{"value":(slotScope.meta.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "phone", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.phone2),expression:"slotScope.meta.phone2"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel"},domProps:{"value":(slotScope.meta.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "phone2", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Contact Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.email),expression:"slotScope.meta.email"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(slotScope.meta.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "email", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(slotScope.meta.website),expression:"slotScope.meta.website"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(slotScope.meta.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(slotScope.meta, "website", $event.target.value)}}})]),_vm._v(" "),(slotScope.meta.name)?_c('large-button',{on:{"click":function($event){_vm.createBusiness(slotScope.meta)}}},[_vm._v("Create")]):_vm._e()],1):_vm._e()}}])}),_vm._v(" "),_c('business-dialog',{ref:"businessdialogmenulayout",scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [(slotProps.business && (_vm.business.id !== slotProps.business.id))?_c('large-button',{on:{"click":function($event){_vm.changeBusiness(slotProps.business.id);_vm.$refs.businessdialogmenulayout.cancelDialog()}}},[_vm._v("Change to "+_vm._s(slotProps.business.name)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.sysadmin && slotProps.business && slotProps.business.name!=='FIBI' && (_vm.business.id !== slotProps.business.id))?_c('confirm-dialog',{attrs:{"usedefaultbutton":"","buttontext":"Remove Business","id":"removebusiness","oktext":"Yes Remove"},on:{"click":function($event){_vm.actionremovebusiness($event,slotProps.business)}}},[_vm._v("        \n            Warning removing \""+_vm._s(slotProps.business.name)+"\" this cannot be undone, please double check.\n          ")]):_vm._e(),_vm._v(" "),(!slotProps.business)?_c('large-button',{on:{"click":function($event){_vm.selfgroupcommands({command:'removeMyselfFromGroup',business:{id:slotProps.meta}});_vm.$refs.businessdialogmenulayout.cancelDialog()}}},[_vm._v("Remove from list\n          ")]):_vm._e()]}}])},[_c('span',{attrs:{"slot":"general"},slot:"general"},[_c('p',[_c('font',{attrs:{"color":"red"}},[_vm._v("WARNING!!! Here you have access to change, clone or remove Businesses, this is a one way process and cannot be undone. If in doubt contact your FIBI administrator.")])],1)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9a906e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(462);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9a906e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',{staticClass:"loginLayout"},[(!_vm.person)?_c('div',[_c('button',{staticClass:"loginBtn loginBtn--google",on:{"click":function($event){_vm.logUserInGoogle()}}},[_vm._v("\n          Login with Google\n        ")])]):_vm._e(),_vm._v(" "),(_vm.person)?_c('div',[_c('span',[_vm._v("Welcome "+_vm._s(_vm.person.displayName)+" ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c23e23c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(465);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c23e23c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',{staticClass:"profilelayout"},[(_vm.profile)?_c('div',[(_vm.profile.token)?_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("My Token")]),_vm._v(" : "),_c('b',[_vm._v(_vm._s(_vm.profile.token))])]):_vm._e(),_vm._v(" "),(_vm.profile.qr)?_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.profile.qr)}})]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f609c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__(467);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f609c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('large-button-wide',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('common')}}},[_vm._v("Edit Common")]),_vm._v(" "),_c('large-button-wide',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('businesslinks')}}},[_vm._v("Links")]),_vm._v(" "),_c('large-button-wide',{staticClass:"w3-theme-dark",on:{"click":function($event){_vm.$router.push('staff')}}},[_vm._v("Manage Staff")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.business && _vm.business.pwa)?_c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('back-button',{on:{"click":function($event){_vm.$router.push('/admin/home')}}}),_vm._v(" "),_c('large-button',{on:{"click":function($event){_vm.saveBusiness()}}},[_vm._v("Save")])],1),_vm._v(" "),_c('h4',[_vm._v("Edit Store Positions")]),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"red"}},[_c('b',[_vm._v("Here you can add Table positions to allow customers to let staff know where they are sitting. Don't add to many as it becomes hard for customers to select.")])])],1),_vm._v(" "),(_vm.business.positions)?_c('span',[_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Position Label")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.positions.title),expression:"business.positions.title"}],staticClass:"w3-input w3-border",attrs:{"placeholder":"Label customers see for location","type":"text"},domProps:{"value":(_vm.business.positions.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.positions, "title", $event.target.value)}}})]),_vm._v(" "),_vm._l((_vm.business.positions.items),function(position,positionindex){return _c('div',{key:positionindex,staticClass:"w3-cell-row"},[_c('div',{staticClass:"w3-cell w3-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(position.label),expression:"position.label"}],staticClass:"w3-input w3-border",attrs:{"type":"text","max":"25","maxlength":"25"},domProps:{"value":(position.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(position, "label", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"w3-cell w3-container"},[_c('delete-button',{on:{"click":function($event){_vm.removePosition(positionindex)}}})],1)])}),_vm._v(" "),_c('footer',{staticClass:"w3-container footer"},[_c('add-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.addPosition()}}},[_vm._v("Position")])],1)],2):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminBusinessLinks_vue__ = __webpack_require__(139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15341894_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminBusinessLinks_vue__ = __webpack_require__(495);
function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminBusinessLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15341894_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminBusinessLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('add-button',{on:{"click":function($event){_vm.$refs.businessesdialog.show()}}},[_vm._v("Business")]),_vm._v(" "),_c('large-button',{on:{"click":function($event){_vm.refresh()}}},[_vm._v("Refresh")])],1),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"green"}},[_vm._v("\n      Here you can view all your linked businesses that will be used in the creation of remedial's related to you.  Clicking the details of a business will allow you to manage rights for that business.\n      ")])],1),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"green"}},[_c('b',[_vm._v("On any changes please refresh the page using the Refresh button to ensure the latest changes are shown.")])])],1),_vm._v(" "),_c('h3',[_vm._v("Linked Businesses")]),_vm._v(" "),_c('ul',{staticClass:"ul-layout"},_vm._l((_vm.linkedbusinesses),function(linkedbusiness,index){return _c('li',{key:index,staticClass:"li-layout ",on:{"click":function($event){_vm.$refs.businessdialog.show({business:{id:index},meta:{linkedbusiness:{id:index,allowcreateremedial:linkedbusiness.allowcreateremedial}}})}}},[_c('business-info-layout',{attrs:{"business":{name:linkedbusiness.name}}},[(linkedbusiness.allowcreateremedial)?_c('businesses-layout-item',[_c('b',[_vm._v("Create Remedials")])]):_vm._e(),_vm._v(" "),_c('businesses-layout-item',[_c('large-button',[_vm._v("Details")])],1)],1)],1)})),_vm._v(" "),_c('h3',[_vm._v("Lodge Businesses")]),_vm._v(" "),_c('ul',{staticClass:"ul-layout"},_vm._l((_vm.lodgebusinesses),function(lodgebusiness,index){return _c('li',{key:index,staticClass:"li-layout "},[_c('business-info-layout',{attrs:{"business":{name:lodgebusiness.name,address:lodgebusiness.address}}})],1)})),_vm._v(" "),_c('businesses-links-dialog',{ref:"businessesdialog",attrs:{"selectedBusinesses":_vm.linkedbusinesses},on:{"link":_vm.addLinkToBusiness}}),_vm._v(" "),_c('business-dialog',{ref:"businessdialog",scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return slotProps && slotProps.meta?[_c('span',[_c('p',[_c('font',{attrs:{"color":"green"}},[_vm._v("Here you can update rights for a business or simple remove the business from your reference list.")])],1)]),_vm._v(" "),_c('p',[_c('large-button',{on:{"click":function($event){_vm.togglecreateremedial(slotProps.meta.linkedbusiness)}}},[_vm._v(_vm._s(slotProps.meta.linkedbusiness.allowcreateremedial?"Disable ":"Enable")+" Create Remedial")])],1),_vm._v(" "),_c('confirm-dialog',{attrs:{"usedefaultbutton":"","buttontext":"Remove Link","id":"removebusiness","oktext":"Yes Remove"},on:{"click":function($event){_vm.actionremovebusiness($event,slotProps.business)}}},[_vm._v("        \n            Warning this cannot be undone, please double check.\n          ")])]:undefined}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCommon_vue__ = __webpack_require__(140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a76264c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCommon_vue__ = __webpack_require__(501);
function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCommon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a76264c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCommon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCommonConfig_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a31df70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCommonConfig_vue__ = __webpack_require__(500);
function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCommonConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a31df70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCommonConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tempbusiness)?_c('span',[(_vm.tempbusiness.name)?_c('large-button',{on:{"click":_vm.saveBusinessConfig}},[_vm._v("Save Config")]):_vm._e(),_vm._v(" "),_c('p',[_c('label',{attrs:{"for":"open"}},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.name),expression:"tempbusiness.name"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness, "name", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"red"}},[_vm._v("Required. Warning changing the name will affect layouts in menus.")])],1),_vm._v(" "),_c('p',[_c('label',{attrs:{"for":"open"}},[_vm._v("Assets")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.assets),expression:"tempbusiness.assets"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.assets)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness, "assets", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"red"}},[_vm._v("Required. Warning affects the main styling.")])],1),_vm._v(" "),_c('p',[_c('label',{attrs:{"for":"open"}},[_vm._v("Subdomain  (Optional)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.subdomain),expression:"tempbusiness.subdomain"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.subdomain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness, "subdomain", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"green"}},[_vm._v("Used for subdomains, i.e fibi.works/businessname or businessname.fibi.works, the later requires dns setup")])],1),_vm._v(" "),_c('p',[_c('label',{attrs:{"for":"open"}},[_vm._v("Domain  (Optional)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.domain),expression:"tempbusiness.domain"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.domain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness, "domain", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"green"}},[_vm._v("Use full domain when not using FIBI.works domain. i.e. www.business.co.nz requires dns setup")])],1),_vm._v(" "),_c('p',[_c('label',{attrs:{"for":"open"}},[_vm._v("Short Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.shortname),expression:"tempbusiness.shortname"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.shortname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness, "shortname", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"green"}},[_vm._v("Used to display short name for display only.")])],1),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("SMS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.phonesms),expression:"tempbusiness.phonesms"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel"},domProps:{"value":(_vm.tempbusiness.phonesms)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness, "phonesms", $event.target.value)}}}),_vm._v(" "),_c('font',{attrs:{"color":"green"}},[_vm._v("Under development.")])],1),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Resolve Remedials\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.resolveremedials),expression:"tempbusiness.resolveremedials"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.tempbusiness.resolveremedials)?_vm._i(_vm.tempbusiness.resolveremedials,null)>-1:(_vm.tempbusiness.resolveremedials)},on:{"change":function($event){var $$a=_vm.tempbusiness.resolveremedials,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.tempbusiness, "resolveremedials", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.tempbusiness, "resolveremedials", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.tempbusiness, "resolveremedials", $$c)}}}})])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Create Remedials\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.createremedials),expression:"tempbusiness.createremedials"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.tempbusiness.createremedials)?_vm._i(_vm.tempbusiness.createremedials,null)>-1:(_vm.tempbusiness.createremedials)},on:{"change":function($event){var $$a=_vm.tempbusiness.createremedials,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.tempbusiness, "createremedials", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.tempbusiness, "createremedials", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.tempbusiness, "createremedials", $$c)}}}})])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Hide Help\n            "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.hidehelp),expression:"tempbusiness.hidehelp"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.tempbusiness.hidehelp)?_vm._i(_vm.tempbusiness.hidehelp,null)>-1:(_vm.tempbusiness.hidehelp)},on:{"change":function($event){var $$a=_vm.tempbusiness.hidehelp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.tempbusiness, "hidehelp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.tempbusiness, "hidehelp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.tempbusiness, "hidehelp", $$c)}}}})])]),_vm._v(" "),(_vm.tempbusiness.pwa)?_c('span',[_c('h3',[_vm._v("Navigation/Labels")]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Label Cart/Time")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.pwa.labels.cart.pickuptime),expression:"tempbusiness.pwa.labels.cart.pickuptime"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.pwa.labels.cart.pickuptime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness.pwa.labels.cart, "pickuptime", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Navigation/About")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.pwa.menus.about),expression:"tempbusiness.pwa.menus.about"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.pwa.menus.about)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness.pwa.menus, "about", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Navigation/Home")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.pwa.menus.home),expression:"tempbusiness.pwa.menus.home"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.pwa.menus.home)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness.pwa.menus, "home", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Navigation/Menu")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempbusiness.pwa.menus.menu),expression:"tempbusiness.pwa.menus.menu"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.tempbusiness.pwa.menus.menu)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tempbusiness.pwa.menus, "menu", $event.target.value)}}})])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.business)?_c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('back-button',{on:{"click":function($event){_vm.$router.push('/admin/home')}}}),_vm._v(" "),(_vm.business.name)?_c('large-button',{on:{"click":function($event){_vm.saveBusiness(_vm.business)}}},[_vm._v("Save")]):_vm._e()],1),_vm._v(" "),_c('tablink-layout',{staticStyle:{"margin-top":"10px"},attrs:{"show":"home"}},[_c('tab-link-button',{attrs:{"id":"home"}},[_vm._v("Home")]),_vm._v(" "),(_vm.business.pwa)?_c('tab-link-button',{attrs:{"id":"about"}},[_vm._v("About")]):_vm._e(),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"status"}},[_vm._v("Status")]),_vm._v(" "),(_vm.sysadmin)?_c('tab-link-button',{attrs:{"id":"config"}},[_vm._v("Config")]):_vm._e(),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"location"}},[_vm._v("GPS")]),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"image"}},[_vm._v("Image")]),_vm._v(" "),(_vm.sysadmin)?_c('tab-link-button',{attrs:{"id":"theme"}},[_vm._v("Themes")]):_vm._e(),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"linkedbusinesses"}},[_vm._v("Business Links")])],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"linkedbusinesses_tab"}},[_c('p',[_c('b',[_c('font',{attrs:{"color":"green"}},[_vm._v("Here you can view all linked businesses, you can add or remove links.")])],1)]),_vm._v(" "),_c('ul-layout',_vm._l((_vm.business.franchisees),function(franchisee,index){return _c('li',{key:index},[_vm._v("* "+_vm._s(franchisee.name))])}))],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"home_tab"}},[_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Main Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.address),expression:"business.address"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},domProps:{"value":(_vm.business.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "address", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Cellphone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.phone),expression:"business.phone"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel"},domProps:{"value":(_vm.business.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "phone", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.phone2),expression:"business.phone2"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel"},domProps:{"value":(_vm.business.phone2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "phone2", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Contact Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.email),expression:"business.email"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.business.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "email", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Website")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.website),expression:"business.website"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.business.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business, "website", $event.target.value)}}})]),_vm._v(" "),(_vm.business.pwa)?_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.pwa.openhours),expression:"business.pwa.openhours"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.business.pwa.openhours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.pwa, "openhours", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.business.pwa)?_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.pwa.homeabout),expression:"business.pwa.homeabout"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"15"},domProps:{"value":(_vm.business.pwa.homeabout)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.pwa, "homeabout", $event.target.value)}}})]):_vm._e()]),_vm._v(" "),(_vm.business.pwa)?_c('tab-layout',{attrs:{"id":"about_tab"}},[_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.pwa.about),expression:"business.pwa.about"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"2"},domProps:{"value":(_vm.business.pwa.about)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.pwa, "about", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.pwa.howto),expression:"business.pwa.howto"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"2"},domProps:{"value":(_vm.business.pwa.howto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.pwa, "howto", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.pwa.instructions),expression:"business.pwa.instructions"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"3"},domProps:{"value":(_vm.business.pwa.instructions)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.pwa, "instructions", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('tab-layout',{attrs:{"id":"theme_tab"}},[_c('h3',[_vm._v("Available Themes")]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"black"},domProps:{"value":{sitetheme:'w3-theme-black.css',pwa:'#000000'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-black.css',pwa:'#000000'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-black.css',pwa:'#000000'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#000000"},attrs:{"for":"black"}},[_vm._v("black")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"bluegrey"},domProps:{"value":{sitetheme:'w3-theme-blue-grey.css',pwa:'#607d8b'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-blue-grey.css',pwa:'#607d8b'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-blue-grey.css',pwa:'#607d8b'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#607d8b"},attrs:{"for":"bluegrey"}},[_vm._v("blue-grey")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"blue"},domProps:{"value":{sitetheme:'w3-theme-blue.css',pwa:'#2196f3'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-blue.css',pwa:'#2196f3'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-blue.css',pwa:'#2196f3'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#2196f3"},attrs:{"for":"blue"}},[_vm._v("blue")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"indigo"},domProps:{"value":{sitetheme:'w3-theme-indigo.css',pwa:'#3f51b5'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-indigo.css',pwa:'#3f51b5'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-indigo.css',pwa:'#3f51b5'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#3f51b5"},attrs:{"for":"indigo"}},[_vm._v("indigo")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"lightblue"},domProps:{"value":{sitetheme:'w3-theme-light-blue.css',pwa:'#87ceeb'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-light-blue.css',pwa:'#87ceeb'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-light-blue.css',pwa:'#87ceeb'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#87ceeb"},attrs:{"for":"lightblue"}},[_vm._v("light-blue")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"cyan"},domProps:{"value":{sitetheme:'w3-theme-cyan.css',pwa:'#00bcd4'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-cyan.css',pwa:'#00bcd4'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-cyan.css',pwa:'#00bcd4'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#00bcd4"},attrs:{"for":"cyan"}},[_vm._v("cyan")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"teal"},domProps:{"value":{sitetheme:'w3-theme-teal.css',pwa:'#009688'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-teal.css',pwa:'#009688'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-teal.css',pwa:'#009688'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#009688"},attrs:{"for":"teal"}},[_vm._v("teal")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"brown"},domProps:{"value":{sitetheme:'w3-theme-brown.css',pwa:'#795548'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-brown.css',pwa:'#795548'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-brown.css',pwa:'#795548'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#795548"},attrs:{"for":"brown"}},[_vm._v("brown")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"darkgrey"},domProps:{"value":{sitetheme:'w3-theme-dark-grey.css',pwa:'#616161'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-dark-grey.css',pwa:'#616161'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-dark-grey.css',pwa:'#616161'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#616161"},attrs:{"for":"darkgrey"}},[_vm._v("dark-grey")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"grey"},domProps:{"value":{sitetheme:'w3-theme-grey.css',pwa:'#9e9e9e'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-grey.css',pwa:'#9e9e9e'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-grey.css',pwa:'#9e9e9e'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#9e9e9e"},attrs:{"for":"grey"}},[_vm._v("grey")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"red"},domProps:{"value":{sitetheme:'w3-theme-red.css',pwa:'#f44336'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-red.css',pwa:'#f44336'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-red.css',pwa:'#f44336'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#f44336"},attrs:{"for":"red"}},[_vm._v("red")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"deeporange"},domProps:{"value":{sitetheme:'w3-theme-deep-orange.css',pwa:'#ff5722'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-deep-orange.css',pwa:'#ff5722'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-deep-orange.css',pwa:'#ff5722'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#ff5722"},attrs:{"for":"deeporange"}},[_vm._v("deep-orange")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"orange"},domProps:{"value":{sitetheme:'w3-theme-orange.css',pwa:'#ff9800'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-orange.css',pwa:'#ff9800'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-orange.css',pwa:'#ff9800'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#ff9800"},attrs:{"for":"orange"}},[_vm._v("orange")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"pink"},domProps:{"value":{sitetheme:'w3-theme-pink.css',pwa:'#e91e63'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-pink.css',pwa:'#e91e63'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-pink.css',pwa:'#e91e63'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#e91e63"},attrs:{"for":"pink"}},[_vm._v("pink")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"deeppurple"},domProps:{"value":{sitetheme:'w3-theme-deep-purple.css',pwa:'#673ab7'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-deep-purple.css',pwa:'#673ab7'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-deep-purple.css',pwa:'#673ab7'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#673ab7"},attrs:{"for":"deeppurple"}},[_vm._v("deep-purple")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"purple"},domProps:{"value":{sitetheme:'w3-theme-purple.css',pwa:'#9c27b0'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-purple.css',pwa:'#9c27b0'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-purple.css',pwa:'#9c27b0'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#9c27b0"},attrs:{"for":"purple"}},[_vm._v("purple")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"green"},domProps:{"value":{sitetheme:'w3-theme-green.css',pwa:'#4caf50'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-green.css',pwa:'#4caf50'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-green.css',pwa:'#4caf50'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#4caf50"},attrs:{"for":"green"}},[_vm._v("green")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"lightgreen"},domProps:{"value":{sitetheme:'w3-theme-light-green.css',pwa:'#8bc34a'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-light-green.css',pwa:'#8bc34a'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-light-green.css',pwa:'#8bc34a'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#8bc34a"},attrs:{"for":"lightgreen"}},[_vm._v("light-green")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"lime"},domProps:{"value":{sitetheme:'w3-theme-lime.css',pwa:'#cddc39'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-lime.css',pwa:'#cddc39'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-lime.css',pwa:'#cddc39'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#cddc39"},attrs:{"for":"lime"}},[_vm._v("lime")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"amber"},domProps:{"value":{sitetheme:'w3-theme-amber.css',pwa:'#ffc107'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-amber.css',pwa:'#ffc107'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-amber.css',pwa:'#ffc107'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#ffc107"},attrs:{"for":"amber"}},[_vm._v("amber")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"yellow"},domProps:{"value":{sitetheme:'w3-theme-yellow.css',pwa:'#ffeb3b'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-yellow.css',pwa:'#ffeb3b'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-yellow.css',pwa:'#ffeb3b'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#ffeb3b"},attrs:{"for":"yellow"}},[_vm._v("yellow")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme),expression:"business.theme"}],attrs:{"type":"radio","id":"khaki"},domProps:{"value":{sitetheme:'w3-theme-khaki.css',pwa:'#f0e68c'},"checked":_vm._q(_vm.business.theme,{sitetheme:'w3-theme-khaki.css',pwa:'#f0e68c'})},on:{"change":function($event){_vm.$set(_vm.business, "theme", {sitetheme:'w3-theme-khaki.css',pwa:'#f0e68c'})}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#f0e68c"},attrs:{"for":"khaki"}},[_vm._v("khaki")])]),_vm._v(" "),(_vm.business.theme)?_c('p',[_c('label',{attrs:{"for":"black"}},[_vm._v("Custom PWA")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme.pwa),expression:"business.theme.pwa"}],staticClass:"w3-input w3-border",attrs:{"type":"input","id":"custom"},domProps:{"value":(_vm.business.theme.pwa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.theme, "pwa", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"black"}},[_vm._v("Custom Site Theme")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.business.theme.sitetheme),expression:"business.theme.sitetheme"}],staticClass:"w3-input w3-border w3",attrs:{"type":"input","id":"custom"},domProps:{"value":(_vm.business.theme.sitetheme)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.business.theme, "sitetheme", $event.target.value)}}})]):_vm._e()]),_vm._v(" "),_c('tab-layout',{attrs:{"id":"status_tab"}},[_c('h3',[_vm._v("Ordering Status")]),_vm._v(" "),_c('p',[_c('b',[_c('font',{attrs:{"color":"green"}},[_vm._v("NOTE!! When changing the status you do not need to save as this happens in the background and in the cloud it will automatically change when ready, this allows us to configure your TILES and deals automatically.")])],1)]),_vm._v(" "),_c('status-selector',{attrs:{"value":_vm.business.status},on:{"statusselected":function($event){_vm.businesscommands({command:'changeBusinessStatus',business: _vm.business,meta:{status:$event.action}})}}})],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"config_tab"}},[_c('admin-common-config',{attrs:{"business":_vm.business}})],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"location_tab"}},[_c('p',[_c('label',{staticClass:"w3-text-green"},[_vm._v("Actual Shop Location")]),_c('br'),_vm._v(" "),_c('font',{attrs:{"color":"green"}},[_vm._v("This sets the location of your home shop/store or business, this location is used to let customers know where your business is, it is also used as the default location for your TILES.")])],1),_vm._v(" "),_c('p',[_c('b',[_c('font',{attrs:{"color":"red"}},[_vm._v("NOTE!! When changing selection the location will change immediately.")])],1)]),_vm._v(" "),_c('p',[(_vm.business)?_c('set-location-button',{attrs:{"value":{latitude:_vm.business.latitude,longitude:_vm.business.longitude}},on:{"input":function($event){_vm.updateBusinessLocation({foundlocation:$event,id:_vm.business.id})}}}):_vm._e()],1)]),_vm._v(" "),_c('tab-layout',{attrs:{"id":"image_tab"}},[(_vm.business.image)?_c('p',{staticClass:"w3-container w3-center"},[_c('img',{staticClass:"w3-image",attrs:{"src":_vm.business.image,"height":"100px","alt":"home image"}})]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_c('font',{attrs:{"color":"green"}},[_vm._v("NOTE!! When changing an image you do not need to save as this happens in the background and in the cloud it will automatically refresh when ready.")])],1)]),_vm._v(" "),_c('image-editor',{attrs:{"config":{id:_vm.business.id,location:'web/businesses',maxsize:10}}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminStoreStaffGroups_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac3c106_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminStoreStaffGroups_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminStoreStaffGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac3c106_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminStoreStaffGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('back-button',{on:{"click":function($event){_vm.$router.push('/admin/home')}}}),_vm._v(" "),_c('large-button',{on:{"click":function($event){_vm.openAddStaffDialog()}}},[_vm._v("Add Person")]),_vm._v(" "),_c('large-button',{on:{"click":function($event){_vm.refresh()}}},[_vm._v("Refresh")])],1),_vm._v(" "),_c('h4',[_vm._v("Edit Staff rights")]),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"green"}},[_c('b',[_vm._v("Here you can Add/Change Staff access rights..")])])],1),_vm._v(" "),_c('ul',{staticClass:"w3-ul w3-panel w3-border w3-round-large"},_vm._l((_vm.businessstaff),function(staffmember,id){return _c('li',{key:id,on:{"click":function($event){_vm.openStaffDialog(id,staffmember)}}},[_c('font',{attrs:{"color":"green"}},[_c('i',{staticClass:"fa fa-user",staticStyle:{"font-size":"48px"}})]),_vm._v(" "+_vm._s(staffmember.knownAs || staffmember.token)+"\n        ")],1)})),_vm._v(" "),_c('dialog-layout',{ref:"staffdialog",attrs:{"id":"staffdialog"},on:{"click":_vm.dialogActions}},[_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v("Manage User")]),_vm._v(" "),(_vm.selectedstaffmember)?_c('span',[(!_vm.selectedstaffmember.id && !_vm.enableqrcode)?_c('span',[_c('p',[_c('font',{attrs:{"color":"red"}},[_c('b',[_vm._v("Enter in users token exactly, for security reasons you cannot search for a user. A user will appear in your list if you have rights to add this user and the token is correct. The token can be found in their profile page.")])])],1),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.token),expression:"selectedstaffmember.token"}],staticClass:"w3-input w3-border w3-round-xxlarge",attrs:{"type":"text","placeholder":"enter in users token exactly"},domProps:{"value":(_vm.selectedstaffmember.token)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedstaffmember, "token", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.selectedstaffmember && !_vm.selectedstaffmember.id)?_c('large-button-wide',{on:{"click":function($event){_vm.enableqrcode = !_vm.enableqrcode}}},[_vm._v("QR Reader ("+_vm._s(_vm.enableqrcode?'Hide':'Show')+")")]):_vm._e(),_vm._v(" "),(_vm.enableqrcode)?_c('qrcode-reader',{on:{"decode":_vm.onDecode}}):_vm._e(),_vm._v(" "),(_vm.selectedstaffmember && _vm.selectedstaffmember.id && _vm.selectedstaffmember.token)?_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Code")]),_c('label',[_vm._v(" : "),_c('b',[_vm._v(_vm._s(_vm.selectedstaffmember.token))])])]):_vm._e(),_vm._v(" "),_c('font',{attrs:{"color":"green"}},[_c('b',[_vm._v("Enter in user friendly name.")])]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.knownAs),expression:"selectedstaffmember.knownAs"}],staticClass:"w3-input w3-border",attrs:{"placeholder":"I know this person as...","type":"text"},domProps:{"value":(_vm.selectedstaffmember.knownAs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedstaffmember, "knownAs", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Installer\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.rights.installer),expression:"selectedstaffmember.rights.installer"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedstaffmember.rights.installer)?_vm._i(_vm.selectedstaffmember.rights.installer,null)>-1:(_vm.selectedstaffmember.rights.installer)},on:{"change":function($event){var $$a=_vm.selectedstaffmember.rights.installer,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedstaffmember.rights, "installer", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedstaffmember.rights, "installer", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedstaffmember.rights, "installer", $$c)}}}})])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Manage Remedials\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.rights.createremedials),expression:"selectedstaffmember.rights.createremedials"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedstaffmember.rights.createremedials)?_vm._i(_vm.selectedstaffmember.rights.createremedials,null)>-1:(_vm.selectedstaffmember.rights.createremedials)},on:{"change":function($event){var $$a=_vm.selectedstaffmember.rights.createremedials,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedstaffmember.rights, "createremedials", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedstaffmember.rights, "createremedials", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedstaffmember.rights, "createremedials", $$c)}}}})])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Read Admin rights\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.rights.read),expression:"selectedstaffmember.rights.read"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedstaffmember.rights.read)?_vm._i(_vm.selectedstaffmember.rights.read,null)>-1:(_vm.selectedstaffmember.rights.read)},on:{"change":function($event){var $$a=_vm.selectedstaffmember.rights.read,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedstaffmember.rights, "read", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedstaffmember.rights, "read", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedstaffmember.rights, "read", $$c)}}}})])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Edit Admin rights\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.rights.write),expression:"selectedstaffmember.rights.write"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedstaffmember.rights.write)?_vm._i(_vm.selectedstaffmember.rights.write,null)>-1:(_vm.selectedstaffmember.rights.write)},on:{"change":function($event){var $$a=_vm.selectedstaffmember.rights.write,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedstaffmember.rights, "write", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedstaffmember.rights, "write", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedstaffmember.rights, "write", $$c)}}}})])]),_vm._v(" "),_c('p',[_c('label',{staticClass:"w3-text-grey"},[_vm._v("Allow Image Uploads\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedstaffmember.rights.allowimageupload),expression:"selectedstaffmember.rights.allowimageupload"}],staticClass:"w3-check",attrs:{"id":"default","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedstaffmember.rights.allowimageupload)?_vm._i(_vm.selectedstaffmember.rights.allowimageupload,null)>-1:(_vm.selectedstaffmember.rights.allowimageupload)},on:{"change":function($event){var $$a=_vm.selectedstaffmember.rights.allowimageupload,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedstaffmember.rights, "allowimageupload", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedstaffmember.rights, "allowimageupload", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedstaffmember.rights, "allowimageupload", $$c)}}}})])]),_vm._v(" "),(_vm.selectedstaffmember)?_c('p',[(!_vm.selectedstaffmember.id && _vm.selectedstaffmember.token)?_c('large-button',{on:{"click":function($event){_vm.saveStaffDetails();_vm.closedialog()}}},[_vm._v("Add")]):_vm._e(),_vm._v(" "),(_vm.selectedstaffmember.id)?_c('large-button',{on:{"click":function($event){_vm.saveStaffDetails();_vm.closedialog()}}},[_vm._v("Save")]):_vm._e(),_vm._v("      \n          "),(_vm.selectedstaffmember.id)?_c('large-button',{on:{"click":function($event){_vm.removeStaffMember();_vm.closedialog()}}},[_vm._v("Remove")]):_vm._e()],1):_vm._e()],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCustomersRemedialsProcessing_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_202e178c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCustomersRemedialsProcessing_vue__ = __webpack_require__(507);
function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCustomersRemedialsProcessing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_202e178c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCustomersRemedialsProcessing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[(!_vm.tempremedial)?_c('back-button',{on:{"click":function($event){_vm.$router.push('/admin/customerremedials/home')}}}):_vm._e(),_vm._v(" "),(_vm.tempremedial)?_c('back-button',{on:{"click":function($event){_vm.tempremedial=null}}}):_vm._e(),_vm._v(" "),(_vm.tempremedial && _vm.AuthsRemedialRights({remedial:_vm.tempremedial,check:'createremedials'}))?_c('save-button',{on:{"click":_vm.saveRemedial}}):_vm._e(),_vm._v(" "),(!_vm.tempremedial && _vm.AuthsAllBusinessRightCheck('createremedials'))?_c('add-button',{on:{"click":function($event){_vm.$refs.remedialdialog.add()}}}):_vm._e(),_vm._v(" "),(!_vm.tempremedial && _vm.AuthsAllBusinessRightCheck('createremedials'))?_c('add-button',{on:{"click":function($event){_vm.$refs.remedialdialog.lodge()}}},[_vm._v("Lodge")]):_vm._e(),_vm._v(" "),(_vm.tempremedial)?_c('add-button',{on:{"click":function($event){_vm.$refs.addnewnote.show()}}},[_vm._v("Note")]):_vm._e(),_vm._v(" "),(_vm.tempremedial)?_c('refresh-button',{on:{"click":function($event){_vm.refresh({data:{remedial:_vm.tempremedial,business:_vm.tempremedial.business}})}}}):_vm._e()],1),_vm._v(" "),(!_vm.tempremedial)?_c('p',{staticClass:"w3-hide-small"},[_c('font',{attrs:{"color":"green"}},[_c('b',[_vm._v("Here you can view listings of business remedials, Use the arrow Up/Down to show hide. Click the refresh button to load background changes.")])])],1):_vm._e(),_vm._v(" "),_c('remedials-table-layout',{class:{'w3-hide':_vm.tempremedial},attrs:{"alladminrights":_vm.alladminrights},on:{"remedialclick":_vm.refresh}}),_vm._v(" "),(_vm.tempremedial)?_c('remedial-tabs-layout',{ref:"remediallayout",attrs:{"remedial":_vm.tempremedial,"business":_vm.business},on:{"tabsActions":_vm.tabsActions}}):_vm._e(),_vm._v(" "),_c('remedial-dialog',{ref:"remedialdialog"}),_vm._v(" "),_c('add-note-dialog',{ref:"addnewnote",attrs:{"id":"addnewnote","headertext":"Add Note"},on:{"noteadded":_vm.noteadded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCustomersRemedialsDeclined_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef63650_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCustomersRemedialsDeclined_vue__ = __webpack_require__(509);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminCustomersRemedialsDeclined_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef63650_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminCustomersRemedialsDeclined_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(104);





var _this2 = this;




// import { mapGetters, stateAfter } from 'vuex'

// import { objectsToArrays, haversine } from './../services/selectors';
// import * as R from 'ramda';

// import Rx from 'rxjs/Rx'
// import { Observable } from 'rxjs/Observable'
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);

// import axios from 'axios';

var logger = __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default()({
    collapsed: false, // auto-expand logged mutations
    filter: function filter(mutation, stateBefore, stateAfter) {
        // returns `true` if a mutation should be logged
        // `mutation` is a `{ type, payload }`
        return mutation.type !== "aBlacklistedMutation";
    },
    transformer: function transformer(state) {
        // transform the state before logging it.
        // for example return only a specific sub-tree
        return state.subTree;
    },
    mutationTransformer: function mutationTransformer(mutation) {
        // mutations are logged in the format of `{ type, payload }`
        // we can format it any way we want.
        return mutation.type;
    },

    logger: console // implementation of the `console` API, default `console`
});

var state = {

    person: null,
    profile: null,
    location: null,
    business: null,
    companies: null,
    templateconfig: null,
    toastmessage: null,
    fcmToken: "",
    sysadmin: false,
    adminrights: null,
    alladminrights: null,
    customeraccounts: null,
    last5soldremedials: null,
    tx: null,
    bannermessage: null,
    newversionavailable: false,
    config: null,
    addtohomescreen: null,
    last10messages: null,
    serversidemessages: null
};

var getters = {
    bannermessage: function bannermessage(state) {
        return state.bannermessage;
    },
    newversionavailable: function newversionavailable(state) {
        return state.newversionavailable;
    },
    routetitle: function routetitle(state) {
        return state.route.meta ? state.route.meta.title : "";
    },
    route: function route(state) {
        return state.route;
    },
    business: function business(state) {
        return state.business;
    },
    companies: function companies(state) {
        return state.companies;
    },
    templateconfig: function templateconfig(state) {
        return state.templateconfig;
    },

    person: function person(state) {
        return state.person;
    },
    profile: function profile(state) {
        return state.profile;
    },

    remedialtemplate: function remedialtemplate(state) {
        return '<div>{{remedial}}</div>';
    },
    sysadmin: function sysadmin(state) {
        return state.sysadmin;
    },
    adminrights: function adminrights(state) {
        return state.adminrights;
    },
    alladminrights: function alladminrights(state) {
        return state.alladminrights;
    },
    location: function location(state) {
        return state.location;
    },
    fcmToken: function fcmToken(state) {
        return state.fcmToken;
    },

    customeraccounts: function customeraccounts(state) {
        return state.customeraccounts;
    },
    tx: function tx(state) {
        return state.tx;
    },
    last5soldremedials: function last5soldremedials(state) {
        return state.last5soldremedials;
    },
    config: function config(state) {
        return state.config;
    },
    addtohomescreen: function addtohomescreen(state) {
        return state.addtohomescreen;
    },
    last10messages: function last10messages(state) {
        return state.last10messages;
    },
    serversidemessages: function serversidemessages(state) {
        return state.serversidemessages;
    }
};

var mutations = {
    //reducers 

    setConfig: function setConfig(state, config) {
        state.config = config;
    },
    setNewVersionAvailable: function setNewVersionAvailable(state, newversionavailable) {
        state.newversionavailable = newversionavailable;
    },
    addToLast10Messages: function addToLast10Messages(state, message) {
        state.last10messages = state.last10messages || [];
        if (state.last10messages.length == 10) state.last10messages.pop();

        state.last10messages.unshift(message);
    },
    setBannerMessage: function setBannerMessage(state, bannermessage) {
        state.bannermessage = bannermessage;
    },
    setfcmToken: function setfcmToken(state, fcmToken) {
        state.fcmToken = fcmToken;
    },
    setToastMessage: function setToastMessage(state, toastmessage) {
        state.toastmessage = toastmessage;
    },
    setPerson: function setPerson(state, person) {
        state.person = person;
    },
    setProfile: function setProfile(state, profile) {
        state.profile = profile;
    },
    setServerSideMessages: function setServerSideMessages(state, serversidemessages) {
        state.serversidemessages = serversidemessages;
    },
    setSysAdmin: function setSysAdmin(state, sysadmin) {
        state.sysadmin = sysadmin;
    },
    setAllBusinessRights: function setAllBusinessRights(state, alladminrights) {
        state.alladminrights = alladminrights;
    },
    setRights: function setRights(state, adminrights) {
        state.adminrights = adminrights;
    },
    last10AccountTransactions: function last10AccountTransactions(state, tx) {
        state.tx = tx;
    },
    searchForCustomerAccounts: function searchForCustomerAccounts(state, customeraccounts) {
        state.customeraccounts = customeraccounts;
    },
    clearbasedeals: function clearbasedeals(state) {
        state.basedeals = [];
    },
    setLocation: function setLocation(state, location) {
        state.location = location;
    },
    enableBusinessPositions: function enableBusinessPositions(state) {
        var p = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.business, { positions: { items: {}, title: "" } });
        state.business = p;
    },
    setBusiness: function setBusiness(state, business) {
        state.business = business;
    },
    setCompanies: function setCompanies(state, companies) {
        state.companies = companies;
    },
    setTemplateConfig: function setTemplateConfig(state, templateconfig) {
        state.templateconfig = templateconfig;
    },
    logOut: function logOut(state) {
        state.person = null;
        state.profile = null;

        state.sysadmin = false;
        state.adminrights = null;
        state.alladminrights = null;
        state.last5soldremedials = null;
        state.addtohomescreen = null;
        state.last10messages = null;
        state.serversidemessages = null;
    },
    setLast5SoldRemedials: function setLast5SoldRemedials(state, last5soldremedials) {
        state.last5soldremedials = last5soldremedials;
    },
    enableAddToHomeScreen: function enableAddToHomeScreen(state, addtohomescreen) {
        state.addtohomescreen = addtohomescreen;
    }
};

var dealsWatcher = void 0;
var customerRemedialsWatcher = void 0;
var customersRemedialsWatcher = void 0;
var businessWatcher = void 0;
var deferredPrompt = void 0; //add to home screen prompt
var timer = void 0;

var actions = {
    //context is the store  
    // route({commit,state},route){
    //     this.$router.push({name: route.name, params: { id: route.id }})
    // },   

    setBannerMessage: function setBannerMessage(_ref, bannermessage) {
        var commit = _ref.commit,
            state = _ref.state,
            dispatch = _ref.dispatch;


        //dispatch('setBannerMessage',{type:'error',message:"Payment window could not be created."})  
        //dispatch('setToastMessage', {type: 'info', message: `Adding to home screen.`, title: 'Add Home' })
        if (timer) clearInterval(timer);

        commit('setBannerMessage', bannermessage);
        timer = setTimeout(function () {
            commit('setBannerMessage', null);
        }, 5000);

        if (bannermessage) commit('addToLast10Messages', bannermessage);
    },
    setToastMessage: function setToastMessage(_ref2, toastmessage) {
        var commit = _ref2.commit,
            state = _ref2.state,
            dispatch = _ref2.dispatch;

        // commit('setToastMessage', toastmessage)
        dispatch('setBannerMessage', toastmessage);
        // if(toastmessage && toastmessage.message)
        //     commit('addToLast10Messages',toastmessage.message)
    },
    addToHomeScreen: function addToHomeScreen(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state,
            dispatch = _ref3.dispatch;

        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then(function (choiceResult) {
            if (choiceResult.outcome === 'accepted') {
                dispatch('setToastMessage', { type: 'info', message: 'Adding to home screen.', title: 'Add Home' });
                console.log('User accepted the A2HS prompt');
            } else {
                dispatch('setToastMessage', { type: 'warning', message: 'Not adding to home', title: 'Add Home' });
            }
            deferredPrompt = null;
            commit('enableAddToHomeScreen', null);
        });
    },
    enableBusinessPositions: function enableBusinessPositions(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state,
            dispatch = _ref4.dispatch;

        commit('enableBusinessPositions');
    },
    getHelpPage: function getHelpPage(_ref5, helppage) {
        var commit = _ref5.commit,
            state = _ref5.state,
            dispatch = _ref5.dispatch;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            if (!helppage) resolve(null);

            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/help/pages/' + helppage).on('value', function (snapshot) {
                var page = snapshot.val();
                if (page) {
                    resolve(page);
                } else {
                    resolve(null);
                }
            });
        });
    },
    createGuidKey: function createGuidKey() {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var key = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref().push().key;
            if (key) resolve(key);else reject("No Key");
        });
    },
    setupUser: function setupUser(_ref6, user) {
        var _this = this;

        var commit = _ref6.commit,
            state = _ref6.state,
            dispatch = _ref6.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var mapUser;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!user) {
                                _context.next = 15;
                                break;
                            }

                            dispatch('setToastMessage', { type: 'info', message: 'Your login details.', title: 'Page refreshed' });
                            // User is signed in.            
                            mapUser = {
                                uid: user.uid, // << Just the bits we need
                                id: user.uid,
                                email: user.email || "",
                                displayName: user.displayName || "",
                                name: user.displayName || "",
                                token: user.qa || "",
                                photo: user.photoURL
                            };

                            commit('setPerson', mapUser);

                            //only do this once but monitor all the time.
                            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/users/profile/' + mapUser.uid).on('value', function (snapshot) {
                                var profile = snapshot.val();
                                if (profile) {
                                    commit('setProfile', profile);
                                }
                            });

                            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/notifications/standardserverside/' + mapUser.uid).set(null).then(function () {
                                //only do this once but monitor all the time.
                                __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/notifications/standardserverside/' + mapUser.uid).on('value', function (snapshot) {
                                    var sm = snapshot.val();
                                    if (sm) {
                                        dispatch('setToastMessage', { type: sm.type, message: sm.message, title: sm.from });
                                    }
                                });
                            });

                            commit('setAllBusinessRights', null);
                            commit('setSysAdmin', null);

                            _context.next = 10;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/groups/pers/' + mapUser.uid + '/administration/referencedata/businesses').on('value', function (snapshot) {
                                var adminrights = snapshot.val();
                                if (adminrights) {
                                    commit('setAllBusinessRights', adminrights);
                                }
                            });

                        case 10:
                            _context.next = 12;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/groups/systemadmin/pers/' + mapUser.uid).once('value', function (snapshot) {
                                var sysadmin = snapshot.val();
                                if (sysadmin) commit('setSysAdmin', true);
                            });

                        case 12:

                            dispatch('setLoggedInAuths');

                            _context.next = 16;
                            break;

                        case 15:
                            // No user is signed in.
                            dispatch('setToastMessage', { type: 'info', message: 'Login at any time.', title: 'Currently logged Out' });

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    //setup the logged in users Auths for the application.      
    setLoggedInAuths: function setLoggedInAuths(_ref7) {
        var commit = _ref7.commit,
            state = _ref7.state,
            dispatch = _ref7.dispatch;


        if (!state.person && !state.business) return;

        commit('setRights', null);
        var ad = state.alladminrights ? state.alladminrights[state.business.id] : null;
        commit('setRights', ad);

        if (state.sysadmin) commit('setRights', { allbusinessremedials: true, default: false, name: state.business.name, read: true, write: true });
    },
    addImageToEntityReduceSize: function addImageToEntityReduceSize(_ref8, upload) {
        var commit = _ref8.commit,
            state = _ref8.state,
            dispatch = _ref8.dispatch;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (!upload.id) {
                dispatch('setToastMessage', { type: 'error', message: 'Missing Entity Identifier', title: upload.location });
                reject("Missing Entity Identifier");
            }

            if (!upload.location) {
                dispatch('setToastMessage', { type: 'error', message: 'Missing Entity Location', title: 'Image upload' });
                reject("Missing Entity Location");
            }

            // Create a reference to the file whose metadata we want to change
            var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref();
            // Create a reference to 'mountains.jpg' need business id to prevent writes if not authored.            
            var newimage = storageRef.child('safetodelete/tempimages/converttothumbnail/business/' + upload.business_id + '/' + upload.file.name);
            var newMetadata = {
                customMetadata: {
                    'id': upload.id,
                    'business_id': upload.business_id, //needed as this is checked against the users rights access.
                    'location': upload.location,
                    'linkedbusinesslocation': upload.linkedbusinesslocation,
                    'push': upload.push
                }
            };
            var uploadtask = newimage.put(upload.file, newMetadata);

            // Register three observers:
            // 1. 'state_changed' observer, called any time the state changes
            // 2. Error observer, called on failure
            // 3. Completion observer, called on successful completion
            uploadtask.on('state_changed', function (snapshot) {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                console.log('Upload is ' + progress + '% done');
                dispatch('setBannerMessage', { message: 'Upload is ' + progress + '% done' });
                switch (snapshot.state) {
                    case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.PAUSED:
                        // or 'paused'
                        console.log('Upload is paused');
                        break;
                    case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.RUNNING:
                        // or 'running'
                        console.log('Upload is running');
                        break;
                }
            }, function (error) {
                // Handle unsuccessful uploads
                console.log(error);
                dispatch('setToastMessage', { type: 'error', message: 'Error ' + error.code + '. Please ensure you are uploading images only or try logging on again, if the problem persists contact your admin.', title: 'Image Storage' });
                reject(error);
            }, function () {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                // console.log('Upload is done, here is your url');
                //cannont use this url as it is the full sized image not the processed image.
                // var downloadURL = uploadtask.snapshot.downloadURL;
                // console.log(downloadURL)                                
                dispatch('setBannerMessage', { message: 'Complete! please press the refresh button at the top, you may need to do this a few times.' });
                resolve(true);
            });
        });
    },
    setfcmToken: function setfcmToken(context, fcmToken) {
        context.commit('setfcmToken', fcmToken);
    },


    //get the staff for the business selected
    getBusinessStaff: function getBusinessStaff(_ref9, businessid) {
        var commit = _ref9.commit,
            state = _ref9.state,
            dispatch = _ref9.dispatch;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/groups/businesses/' + businessid + '/staff').on('value', function (snapshot) {
                var businessestaff = snapshot.val();
                resolve(businessestaff);
            });
        });
    },

    //get a simple fullbusiness but do not save to state.
    fullbusiness: function fullbusiness(_ref10, id) {
        var commit = _ref10.commit,
            state = _ref10.state,
            dispatch = _ref10.dispatch;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            dispatch('setBannerMessage', { type: 'info', message: 'Getting Businesses details please wait' });
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref(id !== undefined ? 'web/businesses/' + id : 'web/businesses').once('value').then(function (snapshot) {
                resolve(snapshot.val());
            });
        });
    },
    businessremedials: function businessremedials(_ref11, _ref12) {
        var commit = _ref11.commit,
            state = _ref11.state,
            dispatch = _ref11.dispatch;
        var id = _ref12.id,
            assigned = _ref12.assigned;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            dispatch('setBannerMessage', { type: 'info', message: 'Getting Businesses remedials please wait' });
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/remedials/businesses/' + id + '/processingremedials').once('value', function (snapshot) {
                dispatch('setBannerMessage', { type: 'info', message: 'Businesses remedials Loaded....' });
                var businessremedials = snapshot.val();
                resolve(businessremedials);
            });
        });
    },
    fullremedial: function fullremedial(_ref13, _ref14) {
        var commit = _ref13.commit,
            state = _ref13.state,
            dispatch = _ref13.dispatch;
        var id = _ref14.id,
            business = _ref14.business;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            dispatch('setBannerMessage', { type: 'info', message: 'Getting remedial details please wait...' });
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('remedials/businesses/' + business.id + '/processingremedials/' + id).once('value').then(function (snapshot) {
                var remedial = snapshot.val();
                resolve(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ business: business }, remedial));
                dispatch('setBannerMessage', { type: 'info', message: 'Remedial loaded...' });
            });
        });
    },


    //get businesses I can lodge remedials with.
    lodgewithbusinesses: function lodgewithbusinesses(_ref15, _ref16) {
        var commit = _ref15.commit,
            state = _ref15.state,
            dispatch = _ref15.dispatch;
        var business = _ref16.business;

        if (!business) return;
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            dispatch('setBannerMessage', { type: 'info', message: 'Getting lodged Businesses please wait' });
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('web/references/businesses/' + business.id + '/lodgebusinesses').once('value').then(function (snapshot) {
                resolve(snapshot.val());
            });
        });
    },
    linkedbusiness: function linkedbusiness(_ref17, _ref18) {
        var commit = _ref17.commit,
            state = _ref17.state,
            dispatch = _ref17.dispatch;
        var business = _ref18.business;

        if (!business) return;
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            dispatch('setBannerMessage', { type: 'info', message: 'Getting Linked Businesses please wait' });
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('web/references/businesses/' + business.id + '/linkedbusinesses').once('value').then(function (snapshot) {
                resolve(snapshot.val());
            });
        });
    },
    getbusinessgroupusers: function getbusinessgroupusers(_ref19, _ref20) {
        var commit = _ref19.commit,
            state = _ref19.state,
            dispatch = _ref19.dispatch;
        var business = _ref20.business;

        if (!business) return;
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            dispatch('setBannerMessage', { type: 'info', message: 'Getting users' });
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('groups/businesses/' + business.id + '/staff').once('value').then(function (snapshot) {
                resolve(snapshot.val());
            });
        });
    },
    remedialCommands: function remedialCommands(_ref21, _ref22) {
        var commit = _ref21.commit,
            state = _ref21.state,
            dispatch = _ref21.dispatch;
        var command = _ref22.command,
            remedial = _ref22.remedial,
            meta = _ref22.meta,
            business = _ref22.business;


        // var remedialdirectcommands = firebase.functions().httpsCallable('remedialdirectcommands');
        // remedialdirectcommands({text: "hey this is cooooooo"}).then(function(result) {
        //         // Read result of the Cloud Function.
        //         console.log(result)        
        // }).catch(function(error) {
        //     // Getting the Error details.
        //     var code = error.code;
        //     var message = error.message;
        //     var details = error.details;
        //     console.log(error)
        // });


        //let key = firebase.database().ref().push().key
        /*
            "jobnumber": 323247,
            "Received": 42482,
            "Address": "Lot 53, 18 Malbec Place, Huapai",
            "issue": "Remove object under carpet in main bedroom",
            "Installer": "George",
            "CustomerName": "Sharon Walton",
            "CustomerPhone": "021 356 009",
            "CustomerEmail": "",
            "GBContact": "Dean Hodgson",
            "Status": "unknown",
            "Notes": "",
            "Advised": "",
            "Billed": "",
            "Chargeable": ""
        */

        remedial.customer = {
            name: remedial.CustomerName || null,
            phone1: remedial.CustomerPhone || null,
            email: remedial.CustomerEmail || null
        };

        dispatch('setToastMessage', { type: 'info', message: "Sending request to update remedial in the cloud", title: 'PROCESSING' });
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/remedialcommands/').push({ command: command, remedial: remedial, business: business, meta: meta || null }).then(function () {});
    },
    alertBusinessAboutRemedial: function alertBusinessAboutRemedial(_ref23, customerremedial) {
        var commit = _ref23.commit,
            state = _ref23.state,
            dispatch = _ref23.dispatch;


        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/commands/' + __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid).push({
            command: 'alertBusinessAboutRemedial',
            remedial: { id: customerremedial.id, business: customerremedial.remedial.business },
            person: { id: state.person.id, name: state.person.name }
        }).then(function () {
            dispatch('setToastMessage', { type: 'info', message: 'Sending alert please be considerate about sending to many alerts', title: 'Alert' });
        }).catch(function (ex) {
            console.log(ex);
        });
    },
    alertBusinessAboutYourLocation: function alertBusinessAboutYourLocation(_ref24, customerremedial) {
        var commit = _ref24.commit,
            state = _ref24.state,
            dispatch = _ref24.dispatch;


        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/commands/' + __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid).push({
            command: 'alertBusinessAboutYourLocation',
            remedial: { id: customerremedial.id, business: customerremedial.remedial.business },
            person: { id: state.person.id, name: state.person.name },
            location: state.location
        }).then(function () {
            dispatch('setToastMessage', { type: 'info', message: 'Sending alert about your location', title: 'Alert' });
        }).catch(function (ex) {
            console.log(ex);
        });
    },
    setBusiness: function setBusiness(_ref25, id) {
        var commit = _ref25.commit,
            state = _ref25.state,
            dispatch = _ref25.dispatch;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
            if (businessWatcher) businessWatcher.off();

            businessWatcher = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('web/businesses/' + id);
            businessWatcher.on('value', function (snapshot) {
                var obBusiness = snapshot.val();
                if (obBusiness) {

                    var business = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ id: id }, obBusiness); //remap business. 
                    business.favi = '' + state.config.globals.publicPath + business.assets + '/img/icons/android-chrome-256x256.png';
                    commit('setBusiness', business);
                    dispatch('setBannerMessage', { type: 'info', message: 'Shop has been set to ' + business.name });
                    resolve(business);
                }
            }, function (error) {
                resolve(null);
                dispatch('setBannerMessage', { type: 'error', message: 'Cannot set business, possibly Incorrect Locator used, please correct.' });
            });
        });
    },


    changeBusiness: function () {
        var _ref26 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref27, id) {
            var commit = _ref27.commit,
                state = _ref27.state,
                dispatch = _ref27.dispatch;
            var result, business;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(!id || id === undefined)) {
                                _context2.next = 3;
                                break;
                            }

                            dispatch('setBannerMessage', { type: 'error', message: 'Missing the business id.' });
                            return _context2.abrupt('return');

                        case 3:

                            dispatch('setBannerMessage', { type: 'info', message: 'Attempting to change business, clearing your tokens.' });
                            _context2.next = 6;
                            return dispatch('clearFCMTokens');

                        case 6:
                            result = _context2.sent;


                            dispatch('setBannerMessage', { type: 'info', message: 'Attempting to now set the business, tokens cleared.' });

                            _context2.next = 10;
                            return dispatch('setBusiness', id);

                        case 10:
                            business = _context2.sent;


                            dispatch('setBannerMessage', { type: 'info', message: 'Dispatching deals watcher for the business.' });
                            // dispatch('initiateDealsWatcher', business.id) 

                            dispatch('setBannerMessage', { type: 'info', message: 'Setting items relevant to the business and the person.' });
                            dispatch('setLoggedInAuths');

                        case 14:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function changeBusiness(_x, _x2) {
            return _ref26.apply(this, arguments);
        };
    }(),

    setBusinessReferences: function setBusinessReferences(_ref28, id) {
        var _this3 = this;

        var commit = _ref28.commit,
            state = _ref28.state,
            dispatch = _ref28.dispatch;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var statusessnapshot, newremedialtemplate, templateConfig;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/web/references/businesses/' + id + '/companies').once('value', function (snapshot) {
                                var companies = snapshot.val();
                                commit('setCompanies', companies);
                            });

                        case 2:
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/web/templates/remedial/statuscodes/common').once('value', function (snapshot) {
                                var sn = snapshot.val();
                                return sn;
                            });

                        case 4:
                            statusessnapshot = _context3.sent;
                            _context3.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/web/templates/remedial/newremedial').once('value').then(function (snapshot) {
                                return snapshot.val();
                            });

                        case 7:
                            newremedialtemplate = _context3.sent;
                            templateConfig = {};

                            templateConfig['statuses'] = statusessnapshot.val();
                            templateConfig['newremedialtemplate'] = newremedialtemplate;

                            commit('setTemplateConfig', templateConfig);

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    setConfig: function setConfig(_ref29, globals) {
        var commit = _ref29.commit,
            state = _ref29.state,
            dispatch = _ref29.dispatch;

        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {

            // return firebase.database().ref(`/web/config/default`)
            // .once('value', (snapshot) => {
            //     var config = snapshot.val()
            var config = {};
            config.globals = globals;
            if (config) {
                commit('setConfig', config);
            }
            // resolve(config)
            resolve(true);
            // }).catch(()=>{
            //     resolve(null)
            // })        
        });
    },
    setLocation: function setLocation(_ref30, location) {
        var commit = _ref30.commit,
            state = _ref30.state;

        commit('setLocation', location);
    },
    selfgroupcommands: function selfgroupcommands(_ref31, request) {
        var dispatch = _ref31.dispatch;


        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/selfgroupcommands').push({
            command: request.command,
            business: { id: request.business.id }
        }).then(function () {
            dispatch('setToastMessage', { type: 'info', message: 'Requested made to change your rights.', title: 'Rights' });
        }).catch(function (ex) {});
    },
    groupCommands: function groupCommands(_ref32, request) {
        var commit = _ref32.commit,
            state = _ref32.state,
            dispatch = _ref32.dispatch;


        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/groupcommands').push({
            command: request.command,
            business: { id: state.business.id, name: state.business.name },
            rights: request.rights || null,
            person: {
                token: request.token || null,
                id: request.id || null,
                knownAs: request.knownAs
            }
        }).then(function () {
            dispatch('setToastMessage', { type: 'info', message: 'Add/Change or Remove user', title: 'Rights' });
        }).catch(function (ex) {});
    },
    businesslinkcommands: function businesslinkcommands(_ref33, _ref34) {
        var commit = _ref33.commit,
            state = _ref33.state,
            dispatch = _ref33.dispatch;
        var command = _ref34.command,
            linkedbusiness = _ref34.linkedbusiness,
            business = _ref34.business,
            meta = _ref34.meta;


        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/businesslinkcommands').push({
            command: command,
            linkedbusiness: linkedbusiness,
            business: business || {
                id: state.business.id
            },
            meta: meta || null
        }).then(function () {
            var c = command;
            switch (command) {
                case 'removeLinkedBusiness':
                    c = 'Removing Business Link';
                    break;
                case 'toggleDirectRemedialCreation':
                    c = 'Changing Direct Remedial rights';
                    break;
                case 'addLinkToBusiness':
                    c = 'Linking business';
                    break;
                default:
                    break;
            }
            dispatch('setToastMessage', { type: 'info', message: 'Business Link "' + c + '" command sent', title: 'Business Links' });
            return;
        });
    },
    businesscommands: function businesscommands(_ref35, request) {
        var commit = _ref35.commit,
            state = _ref35.state,
            dispatch = _ref35.dispatch;


        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('/businesscommands').push({
            command: request.command,
            business: request.business || {
                id: state.business.id,
                image: state.business.image || null,
                latitude: state.business.latitude || null,
                longitude: state.business.longitude || null,
                name: state.business.name || null,
                assets: state.business.assets || null,
                shortname: state.business.shortname || null,
                subdomain: state.business.subdomain || null,
                email: state.business.email || null,
                website: state.business.website || null,
                phone: state.business.phone || null,
                phone2: state.business.phone2 || null
            },
            meta: request.meta || null
        }).then(function () {
            var c = request.command;
            switch (request.command) {

                case 'changeBusinessStatus':
                    c = 'Changing Status';
                    break;
                case 'createBusiness':
                    c = 'Creating new Business';
                    break;
                case 'removeBusiness':
                    c = 'Removing Business';
                    break;
                case 'saveBusinessConfig':
                    c = 'Saving Sysadmin Config settings';
                    break;
                case 'saveBusinessStandardAdmin':
                    c = 'Saving Business common details';
                    break;
                default:
                    break;
            }
            dispatch('setToastMessage', { type: 'info', message: 'Business "' + c + '" command sent', title: 'Business' });
            return;
        });
    },
    updateBusinessLocation: function updateBusinessLocation(_ref36, _ref37) {
        var commit = _ref36.commit,
            state = _ref36.state,
            dispatch = _ref36.dispatch;
        var id = _ref37.id;

        navigator.geolocation.getCurrentPosition(function (position) {
            var coords = { latitude: position.coords.latitude, longitude: position.coords.longitude };
            commit('setLocation', { coords: coords, latitude: position.coords.latitude, longitude: position.coords.longitude });

            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('web/businesses').child(id).update({
                longitude: coords.longitude,
                latitude: coords.latitude
            }, function (result) {
                var business = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.business);
                business.latitude = coords.latitude;
                business.longitude = coords.longitude;
                commit('setBusiness', business);
            }).then(function () {
                dispatch('setToastMessage', { type: 'info', message: 'Saving business Location, you will need to refresh.', title: 'Location' });
            });
        }, function (error) {
            dispatch('setToastMessage', { type: 'error', message: 'Location not available', title: 'Location' });
        }, {
            enableHighAccuracy: false,
            useSignificantChanges: true,
            timeout: 3600000,
            maximumAge: 1800000,
            desiredAccuracy: 0, frequency: 1
        });
    },
    logUserInFacebook: function logUserInFacebook(_ref38) {
        var commit = _ref38.commit,
            state = _ref38.state,
            dispatch = _ref38.dispatch;

        var provider = new __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth.FacebookAuthProvider();
        provider.addScope("email");
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
            dispatch('setToastMessage', { type: 'info', message: result.user.displayName + ' you are logged in with your Facebook account', title: 'Facebook Login' });
        });
    },
    logUserInEmail: function logUserInEmail(_ref39, email) {
        var commit = _ref39.commit,
            state = _ref39.state,
            dispatch = _ref39.dispatch;


        var actionCodeSettings = {
            // URL you want to redirect back to. The domain (www.example.com) for this
            // URL must be whitelisted in the Firebase Console.
            url: 'http://remedials.fibi.localhost:8080',
            // This must be true.
            handleCodeInApp: true
        };

        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().sendSignInLinkToEmail(email, actionCodeSettings).then(function () {
            // The link was successfully sent. Inform the user.
            // Save the email locally so you don't need to ask the user for it again
            // if they open the link on the same device.
            dispatch('setToastMessage', { type: 'info', message: 'Please check your email to login' });
            // window.localStorage.setItem('emailForSignIn', email);
        }).catch(function (error) {
            dispatch('setToastMessage', { type: 'error', message: error });
        });

        // var provider = new firebase.auth.GoogleAuthProvider();
        // provider.addScope("profile");
        // provider.addScope("email");
        // firebase.auth().signInWithPopup(provider).then(result => {
        //     dispatch('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Google account`, title: 'Google Login' })
        // },(error)=>{
        //     dispatch('setBannerMessage',{type:'error',message:error}) 
        // });
    },
    logUserInGoogle: function logUserInGoogle(_ref40) {
        var commit = _ref40.commit,
            state = _ref40.state,
            dispatch = _ref40.dispatch;

        var provider = new __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth.GoogleAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
            dispatch('setToastMessage', { type: 'info', message: result.user.displayName + ' you are logged in with your Google account', title: 'Google Login' });
        }, function (error) {
            dispatch('setBannerMessage', { type: 'error', message: error });
        });
    },

    logout: function logout(_ref41) {
        var commit = _ref41.commit,
            state = _ref41.state,
            dispatch = _ref41.dispatch;


        dispatch('clearFCMTokens').then(function () {
            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signOut().then(function () {
                commit('logOut');
            });
        });
    },
    clearFCMTokens: function () {
        var _ref42 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref43) {
            var commit = _ref43.commit,
                state = _ref43.state;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!(state.adminrights && state.adminrights.write)) {
                                _context4.next = 3;
                                break;
                            }

                            _context4.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('businesses/' + state.business.id + '/fcmTokens/app/' + state.fcmToken).set(null).then(function () {
                                console.log('cleared fcm token from business ' + state.business.name);
                                return 'cleared fcm token from business ' + state.business.name;
                            });

                        case 3:
                            if (state.person) {
                                _context4.next = 5;
                                break;
                            }

                            return _context4.abrupt('return');

                        case 5:
                            _context4.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('customers/' + state.person.uid + '/fcmTokens/pwa/businesses/' + state.business.id + '/' + state.fcmToken).set(null).then(function () {
                                console.log('cleared fcm token from person for business ' + state.business.name);
                                return 'cleared fcm token from person for business ' + state.business.name;
                            });

                        case 7:
                            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

                        case 8:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this2);
        }));

        return function clearFCMTokens(_x3) {
            return _ref42.apply(this, arguments);
        };
    }(),

    unRegister: function unRegister(_ref44) {
        var commit = _ref44.commit,
            state = _ref44.state;

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                registrations.forEach(function (registration) {
                    registration.unregister();
                    console.log("Unregistered.");
                }, this);
            }).then(function () {
                //clear any business tokens
                __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('businesses/' + state.business.id + '/fcmTokens/app/' + state.fcmToken).set(null).then(function () {
                    console.log("businesses fcm token cleare");
                    return "token sent to server";
                });
            }).then(function () {
                if (state.person) {
                    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('customers/' + state.person.uid + '/fcmTokens/pwa/businesses/' + state.business.id + '/' + state.fcmToken).set(null).then(function () {
                        console.log("token cleared from user");
                    }).then(function () {
                        return;
                    });
                }
                return;
            }).then(function () {
                window.location.reload(true); //reload after token cleared.
            });
        } else {
            window.location.reload(true); //reload after token cleared.
        }
    },
    setNotifications: function setNotifications(_ref45) {
        var commit = _ref45.commit,
            state = _ref45.state,
            dispatch = _ref45.dispatch;

        dispatch('setToastMessage', { type: 'info', message: 'Requesting to enable notifications.', title: 'Notifications' });
        var messaging = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.messaging();
        messaging.requestPermission().then(function () {
            // TODO(developer): Retrieve an Instance ID token for use with FCM.
            // ...          
            return messaging.getToken();
        }).then(function (token) {

            dispatch('setToastMessage', { type: 'info', message: 'Excellent we have a token for you.', title: 'Notifications' });

            __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('customers/' + state.person.uid + '/fcmTokens/pwa/businesses/' + state.business.id + '/' + token).set(__WEBPACK_IMPORTED_MODULE_8_moment___default.a.utc().unix()).then(function () {
                dispatch('setfcmToken', token);
                dispatch('setToastMessage', { type: 'info', message: 'Now we ask the message center to send you notices only about your current remedials', title: 'Notifications' });
            }).catch(function (ex) {
                dispatch('setToastMessage', { type: 'error', message: 'Oh no something went wrong, don\'t worry just check your remedial manually we just can\'t message you...', title: 'Notifications' });
            });

            if (state.adminrights && state.adminrights.custremedialprocess) {
                //set the token
                __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database().ref('businesses/' + state.business.id + '/fcmTokens/app/' + token).set(state.person.id).then(function () {
                    dispatch('setToastMessage', { type: 'info', message: 'Great as a staff member you will receive notifications about person remedials', title: 'Notifications' });
                });
            }

            messaging.onTokenRefresh(function () {
                messaging.getToken().then(function (refreshedToken) {
                    dispatch('setToastMessage', { type: 'info', message: 'Notices have been updated with new token.', title: 'Notifications' });
                    dispatch('setfcmToken', refreshedToken);
                }).catch(function (err) {
                    dispatch('setToastMessage', { type: 'error', message: 'Oh no unable to refresh your notices token.', title: 'Notifications' });
                });
            });
            // [END refresh_token]

            messaging.onMessage(function (payload) {
                console.log(payload.notification);
                dispatch('setToastMessage', { type: 'info', message: payload.notification.body });
                // type: 'READY',
                // type: 'STARTED',
                // type: 'SUBMITTED',
                // type: 'DECLINED',
                // type: 'ACCEPTED',      
                // if(['READY','STARTED','SUBMITTED','DECLINED','ACCEPTED'].indexOf(payload.tag) >=0)
                // {
                // dispatch('setToastMessage',{ type: 'info', message:payload.notification.body})            
                // }      
                // this.$toastr("info", payload.notification.body, payload.notification.title);
            });
        }).catch(function (err) {
            if (err.code === 'messaging/failed-serviceworker-registration') {
                dispatch('setToastMessage', { type: 'error', message: 'Could not enable notifications most likely unable to register.', title: 'Notifications' });
            }

            if (err.code === 'messaging/permission-blocked') {
                dispatch('setToastMessage', { type: 'error', message: 'Oh no you blocked notifications, you will need to reset your browser to allow this in the future, see help on how to do this.', title: 'Notifications' });
            }

            console.log(err);
            dispatch('setfcmToken', "errornotoken");
        });
    },
    setCurrentLocation: function setCurrentLocation(_ref46) {
        var commit = _ref46.commit,
            state = _ref46.state,
            dispatch = _ref46.dispatch;

        dispatch('setToastMessage', { type: 'info', message: 'Great attempting to set location, if ok we will manage things better for you.', title: 'Locaton' });
        navigator.geolocation.watchPosition(function (position) {
            var coords = { latitude: position.coords.latitude, longitude: position.coords.longitude };
            commit('setLocation', { coords: coords, latitude: position.coords.latitude, longitude: position.coords.longitude });
        }, function (error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    dispatch('setToastMessage', { type: 'error', message: 'Cannot sort tiles by location, you denied location request, please remove block from your device to enable it.', title: 'Locaton Error' });
                    break;
                case error.POSITION_UNAVAILABLE:
                    dispatch('setToastMessage', { type: 'error', message: 'Location not available.', title: 'Locaton Error' });
                    break;
                case error.TIMEOUT:
                    dispatch('setToastMessage', { type: 'error', message: 'Location request timed out.', title: 'Locaton Error' });
                    break;
                case error.UNKNOWN_ERROR:
                    dispatch('setToastMessage', { type: 'error', message: 'Unknown Error.', title: 'Locaton Error' });
                    break;
            }
        }, {
            enableHighAccuracy: false,
            useSignificantChanges: true,
            timeout: 3600000,
            maximumAge: 1800000,
            desiredAccuracy: 0, frequency: 1
        });
    },
    setUpServiceWorker: function setUpServiceWorker(_ref47) {
        var commit = _ref47.commit,
            state = _ref47.state;


        window.addEventListener('beforeinstallprompt', function (e) {
            e.preventDefault();
            deferredPrompt = e;
            commit('enableAddToHomeScreen', true);
            // Update UI notify the user they can add to home screen            
        });

        var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
        // console.log("adding service worker")
        if ('serviceWorker' in navigator && (window.location.protocol === 'https:' || isLocalhost)) {
            navigator.serviceWorker.register('service-worker.js').then(function (registration) {
                // updatefound is fired if service-worker.js changes.
                registration.onupdatefound = function () {
                    // updatefound is also fired the very first time the SW is installed,
                    // and there's no need to prompt for a reload at that point.
                    // So check here to see if the page is already controlled,
                    // i.e. whether there's an existing service worker.
                    if (navigator.serviceWorker.controller) {
                        // The updatefound event implies that registration.installing is set
                        var installingWorker = registration.installing;

                        installingWorker.onstatechange = function () {
                            switch (installingWorker.state) {
                                case 'installed':
                                    // At this point, the old content will have been purged and the
                                    // fresh content will have been added to the cache.
                                    // It's the perfect time to display a "New content is
                                    // available; please refresh." message in the page's interface.
                                    commit('setNewVersionAvailable', true);
                                    console.log("new version found");
                                    break;

                                case 'redundant':
                                    throw new Error('Installing the service worker is redundant.');

                                default:
                                // Ignore
                            }
                        };
                    }
                };
            }).catch(function (e) {
                console.error('Error during service worker registration:', e);
            });
        }
    }

    // var setLocalStorage = (user) => {
    //     if (window.localStorage) {
    //         localStorage.setItem('uid', user.uid);
    //         localStorage.setItem('id', user.id);
    //         localStorage.setItem('email', user.email);
    //         localStorage.setItem('displayName', user.displayName);
    //         localStorage.setItem('name', user.name);
    //         localStorage.setItem('token', user.token);
    //         localStorage.setItem('photo', user.photo);
    //     }
    // }


};/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */].Store({
    // strict: true,    
    modules: {
        // specialsModule:specialsModule
        // ,
        // foo: {
        //     namespaced: true,

        //     actions: {
        //       someAction: {
        //         root: true,
        //         handler (namespacedContext, payload) { 

        //         } // -> 'someAction'
        //       }
        //     }
        //   }
    },
    plugins: [__WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default()()],
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}));

/***/ }),
/* 523 */,
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 148,
	"./af.js": 148,
	"./ar": 149,
	"./ar-dz": 150,
	"./ar-dz.js": 150,
	"./ar-kw": 151,
	"./ar-kw.js": 151,
	"./ar-ly": 152,
	"./ar-ly.js": 152,
	"./ar-ma": 153,
	"./ar-ma.js": 153,
	"./ar-sa": 154,
	"./ar-sa.js": 154,
	"./ar-tn": 155,
	"./ar-tn.js": 155,
	"./ar.js": 149,
	"./az": 156,
	"./az.js": 156,
	"./be": 157,
	"./be.js": 157,
	"./bg": 158,
	"./bg.js": 158,
	"./bm": 159,
	"./bm.js": 159,
	"./bn": 160,
	"./bn.js": 160,
	"./bo": 161,
	"./bo.js": 161,
	"./br": 162,
	"./br.js": 162,
	"./bs": 163,
	"./bs.js": 163,
	"./ca": 164,
	"./ca.js": 164,
	"./cs": 165,
	"./cs.js": 165,
	"./cv": 166,
	"./cv.js": 166,
	"./cy": 167,
	"./cy.js": 167,
	"./da": 168,
	"./da.js": 168,
	"./de": 169,
	"./de-at": 170,
	"./de-at.js": 170,
	"./de-ch": 171,
	"./de-ch.js": 171,
	"./de.js": 169,
	"./dv": 172,
	"./dv.js": 172,
	"./el": 173,
	"./el.js": 173,
	"./en-au": 174,
	"./en-au.js": 174,
	"./en-ca": 175,
	"./en-ca.js": 175,
	"./en-gb": 176,
	"./en-gb.js": 176,
	"./en-ie": 177,
	"./en-ie.js": 177,
	"./en-il": 178,
	"./en-il.js": 178,
	"./en-nz": 179,
	"./en-nz.js": 179,
	"./eo": 180,
	"./eo.js": 180,
	"./es": 181,
	"./es-do": 182,
	"./es-do.js": 182,
	"./es-us": 183,
	"./es-us.js": 183,
	"./es.js": 181,
	"./et": 184,
	"./et.js": 184,
	"./eu": 185,
	"./eu.js": 185,
	"./fa": 186,
	"./fa.js": 186,
	"./fi": 187,
	"./fi.js": 187,
	"./fo": 188,
	"./fo.js": 188,
	"./fr": 189,
	"./fr-ca": 190,
	"./fr-ca.js": 190,
	"./fr-ch": 191,
	"./fr-ch.js": 191,
	"./fr.js": 189,
	"./fy": 192,
	"./fy.js": 192,
	"./gd": 193,
	"./gd.js": 193,
	"./gl": 194,
	"./gl.js": 194,
	"./gom-latn": 195,
	"./gom-latn.js": 195,
	"./gu": 196,
	"./gu.js": 196,
	"./he": 197,
	"./he.js": 197,
	"./hi": 198,
	"./hi.js": 198,
	"./hr": 199,
	"./hr.js": 199,
	"./hu": 200,
	"./hu.js": 200,
	"./hy-am": 201,
	"./hy-am.js": 201,
	"./id": 202,
	"./id.js": 202,
	"./is": 203,
	"./is.js": 203,
	"./it": 204,
	"./it.js": 204,
	"./ja": 205,
	"./ja.js": 205,
	"./jv": 206,
	"./jv.js": 206,
	"./ka": 207,
	"./ka.js": 207,
	"./kk": 208,
	"./kk.js": 208,
	"./km": 209,
	"./km.js": 209,
	"./kn": 210,
	"./kn.js": 210,
	"./ko": 211,
	"./ko.js": 211,
	"./ky": 212,
	"./ky.js": 212,
	"./lb": 213,
	"./lb.js": 213,
	"./lo": 214,
	"./lo.js": 214,
	"./lt": 215,
	"./lt.js": 215,
	"./lv": 216,
	"./lv.js": 216,
	"./me": 217,
	"./me.js": 217,
	"./mi": 218,
	"./mi.js": 218,
	"./mk": 219,
	"./mk.js": 219,
	"./ml": 220,
	"./ml.js": 220,
	"./mn": 221,
	"./mn.js": 221,
	"./mr": 222,
	"./mr.js": 222,
	"./ms": 223,
	"./ms-my": 224,
	"./ms-my.js": 224,
	"./ms.js": 223,
	"./mt": 225,
	"./mt.js": 225,
	"./my": 226,
	"./my.js": 226,
	"./nb": 227,
	"./nb.js": 227,
	"./ne": 228,
	"./ne.js": 228,
	"./nl": 229,
	"./nl-be": 230,
	"./nl-be.js": 230,
	"./nl.js": 229,
	"./nn": 231,
	"./nn.js": 231,
	"./pa-in": 232,
	"./pa-in.js": 232,
	"./pl": 233,
	"./pl.js": 233,
	"./pt": 234,
	"./pt-br": 235,
	"./pt-br.js": 235,
	"./pt.js": 234,
	"./ro": 236,
	"./ro.js": 236,
	"./ru": 237,
	"./ru.js": 237,
	"./sd": 238,
	"./sd.js": 238,
	"./se": 239,
	"./se.js": 239,
	"./si": 240,
	"./si.js": 240,
	"./sk": 241,
	"./sk.js": 241,
	"./sl": 242,
	"./sl.js": 242,
	"./sq": 243,
	"./sq.js": 243,
	"./sr": 244,
	"./sr-cyrl": 245,
	"./sr-cyrl.js": 245,
	"./sr.js": 244,
	"./ss": 246,
	"./ss.js": 246,
	"./sv": 247,
	"./sv.js": 247,
	"./sw": 248,
	"./sw.js": 248,
	"./ta": 249,
	"./ta.js": 249,
	"./te": 250,
	"./te.js": 250,
	"./tet": 251,
	"./tet.js": 251,
	"./tg": 252,
	"./tg.js": 252,
	"./th": 253,
	"./th.js": 253,
	"./tl-ph": 254,
	"./tl-ph.js": 254,
	"./tlh": 255,
	"./tlh.js": 255,
	"./tr": 256,
	"./tr.js": 256,
	"./tzl": 257,
	"./tzl.js": 257,
	"./tzm": 258,
	"./tzm-latn": 259,
	"./tzm-latn.js": 259,
	"./tzm.js": 258,
	"./ug-cn": 260,
	"./ug-cn.js": 260,
	"./uk": 261,
	"./uk.js": 261,
	"./ur": 262,
	"./ur.js": 262,
	"./uz": 263,
	"./uz-latn": 264,
	"./uz-latn.js": 264,
	"./uz.js": 263,
	"./vi": 265,
	"./vi.js": 265,
	"./x-pseudo": 266,
	"./x-pseudo.js": 266,
	"./yo": 267,
	"./yo.js": 267,
	"./zh-cn": 268,
	"./zh-cn.js": 268,
	"./zh-hk": 269,
	"./zh-hk.js": 269,
	"./zh-tw": 270,
	"./zh-tw.js": 270
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 524;

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_config__ = __webpack_require__(526);
/* unused harmony reexport namespace */


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Rx__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(48);





// import { http } from 'vue-resource';

var AppConfig = function () {
    function AppConfig() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppConfig);

        this.config = null;
        this.env = null;
    }

    /**
     * Use to get the data found in the second file (config file)
     */


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppConfig, [{
        key: 'getConfig',
        value: function getConfig(key) {
            return this.config[key];
        }

        /**
         * Use to get the data found in the first file (env file)
         */

    }, {
        key: 'getEnv',
        value: function getEnv(key) {
            return this.env[key];
        }

        /**
         * This method:
         *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
         *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
         */

    }, {
        key: 'load',
        value: function load() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                // Vue.http.get('test.html').then((res)=>{
                //     console.log(res);
                // })

                // Vue.http.get('/assets/env.json').map( res => res.json() ).catch((error) => {
                //     console.log('Configuration file "env.json" could not be read');
                //     resolve(true);
                //     return Observable.throw(error.json().error || 'Server error');
                // }).subscribe( (envResponse) => {
                //     env = envResponse;
                //     let req = null;

                //     switch (envResponse.env) {
                //         case 'production': {
                //             req = request.get('/assets/config.' + envResponse.env + '.json');
                //         } break;

                //         case 'development': {
                //             req = request.get('/assets/config.' + envResponse.env + '.json');
                //         } break;

                //         case 'default': {
                //             console.error('Environment file is not set or invalid');
                //             resolve(true);
                //         } break;
                //     }

                //     if (req) {
                //         req
                //             .map( (res) => res.json() )
                //             .catch((error) => {
                //                 console.error('Error reading ' + envResponse.env + ' configuration file');
                //                 resolve(error);
                //                 return Observable.throw(error.json().error || 'Server error');
                //             })
                //             .subscribe((responseData) => {
                //                 this.config = responseData;
                //                 resolve(true);
                //             });
                //     } else {
                //         console.error('Env config file "env.json" is not valid');
                //         resolve(true);
                //     }
                // });

            });
        }
    }]);

    return AppConfig;
}();

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */,
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageEditor_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_149e78e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageEditor_vue__ = __webpack_require__(836);
function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_149e78e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.isInitial || _vm.isSaving)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('div',{staticClass:"dropbox"},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}}),_vm._v(" "),(_vm.isInitial)?_c('p',[_vm._v("              \n          Drag your file here to begin"),_c('br'),_vm._v(" or click to browse"),_c('br'),_vm._v("\n          Image less then "+_vm._s(_vm.config.maxsize)+"Mb\n        ")]):_vm._e(),_vm._v(" "),(_vm.isSaving)?_c('p',[_vm._v("\n          Uploading "+_vm._s(_vm.fileCount)+" files...\n        ")]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatingSelector_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34768fa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatingSelector_vue__ = __webpack_require__(839);
function injectStyle (ssrContext) {
  __webpack_require__(838)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatingSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34768fa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatingSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-star",class:{'ratingchecked':_vm.currentrating>0},on:{"click":function($event){_vm.ratingclicked(1)}}}),_vm._v(" "),_c('span',{staticClass:"fa fa-star",class:{'ratingchecked':_vm.currentrating>1},on:{"click":function($event){_vm.ratingclicked(2)}}}),_vm._v(" "),_c('span',{staticClass:"fa fa-star",class:{'ratingchecked':_vm.currentrating>2},on:{"click":function($event){_vm.ratingclicked(3)}}}),_vm._v(" "),_c('span',{staticClass:"fa fa-star",class:{'ratingchecked':_vm.currentrating>3},on:{"click":function($event){_vm.ratingclicked(4)}}}),_vm._v(" "),_c('span',{staticClass:"fa fa-star",class:{'ratingchecked':_vm.currentrating>4},on:{"click":function($event){_vm.ratingclicked(5)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotesEditor_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eeb5cd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotesEditor_vue__ = __webpack_require__(842);
function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotesEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eeb5cd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotesEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldModelValue),expression:"fieldModelValue"}],staticClass:"w3-input w3-border w3-bottom w3-bar TextBoxEditorDisplay",staticStyle:{"width":"92%"},attrs:{"max":"max","placeholder":_vm.placeholder,"maxlength":"maxlength"},domProps:{"value":(_vm.fieldModelValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldModelValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FavSelection_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b690ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FavSelection_vue__ = __webpack_require__(845);
function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FavSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b690ef4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FavSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa fa-plus-circle ratingselection",class:{'favcheck1':_vm.favrating===1,'favcheck2':_vm.favrating===2,'favcheck3':_vm.favrating===3},on:{"click":function($event){_vm.favclicked()}}},[(_vm.label && _vm.favrating===1)?_c('span',[_vm._v(" Ok")]):_vm._e(),_vm._v(" "),(_vm.label && _vm.favrating===2)?_c('span',[_vm._v(" Good")]):_vm._e(),_vm._v(" "),(_vm.label && _vm.favrating===3)?_c('span',[_vm._v(" Great")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusSelector_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde9c972_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusSelector_vue__ = __webpack_require__(848);
function injectStyle (ssrContext) {
  __webpack_require__(847)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde9c972_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type==='list')?_c('span',_vm._l((_vm.statuses),function(status,index){return _c('div',{key:index},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldModelValue),expression:"fieldModelValue"}],attrs:{"type":"radio","id":index},domProps:{"value":_vm.statusfull(index,status),"checked":_vm._q(_vm.fieldModelValue,_vm.statusfull(index,status))},on:{"change":function($event){_vm.fieldModelValue=_vm.statusfull(index,status)}}}),_vm._v(" "),_c('label',{attrs:{"for":index}},[_vm._v(_vm._s(status.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuantitySelector_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48a9a4ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuantitySelector_vue__ = __webpack_require__(851);
function injectStyle (ssrContext) {
  __webpack_require__(850)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuantitySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48a9a4ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuantitySelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"w3-badge w3-green"},[_vm._v(_vm._s(_vm.fieldModelValue))]),_vm._v(" \n    "),_c('span',{staticClass:"w3-button w3-small w3-circle w3-ripple w3-black minmaxbuttons",on:{"click":function($event){_vm.changevalue(-1)}}},[_vm._v("‹")]),_vm._v(" \n    "),_c('span',{staticClass:"w3-button w3-small w3-circle w3-ripple w3-black minmaxbuttons",on:{"click":function($event){_vm.changevalue(1)}}},[_vm._v("›")]),_vm._v("               \n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessDialog_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e116fea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessDialog_vue__ = __webpack_require__(853);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e116fea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"businessDialog",attrs:{"id":"businessDialog"},on:{"click":_vm.dialogActions}},[(_vm.business)?_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v(_vm._s(_vm.business.name))]):_vm._e(),_vm._v(" "),_c('business-info-layout',{attrs:{"business":_vm.business}}),_vm._v(" "),(!_vm.business)?_c('span',[_c('p',[_c('font',{attrs:{"color":"red"}},[_vm._v("Sorry the Business details could not be found, the business has probably been removed from the system. Please contact the Business directly if you know the details or contact your FIBI administrtor.")])],1)]):_vm._e(),_vm._v(" "),_vm._t("default",null,{meta:_vm.meta,business:_vm.business})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialDialog_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd8987e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialDialog_vue__ = __webpack_require__(855);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd8987e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"remedialDailog",attrs:{"id":"remedialDailog"},on:{"click":_vm.dialogActions}},[(_vm.remedial)?_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v("Remedial")]):_vm._e(),_vm._v(" "),_c('remedial-new-layout',{ref:"remediallayout",attrs:{"remedial":_vm.remedial,"templateconfig":_vm.templateconfig},on:{"click":_vm.c}}),_vm._v(" "),(_vm.remedial && !_vm.remedial.id  
            && _vm.remedial.createdfrombusiness 
            && _vm.remedial.linkedbusiness && _vm.remedial.issue)?_c('large-button',{on:{"click":_vm.addRemedial}},[_vm._v(_vm._s(_vm.remedial.type==='lodge'?'Lodge':'Add')+" Remedial")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessesLinksDialog_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a3ffd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessesLinksDialog_vue__ = __webpack_require__(857);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessesLinksDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a3ffd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessesLinksDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"businessesDialog",attrs:{"id":"businessesDialog"},on:{"click":_vm.dialogActions}},[_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v("Businesses")]),_vm._v(" "),_c('businesses-layout',{attrs:{"businesses":_vm.businesses},scopedSlots:_vm._u([{key:"buttons",fn:function(ref){
var business = ref.business;
return [_c('p',[_c('large-button',{on:{"click":function($event){_vm.$emit('link',business);_vm.cancelDialog()}}},[_vm._v("Link")])],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessesLinksList_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb5107f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessesLinksList_vue__ = __webpack_require__(859);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessesLinksList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fb5107f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessesLinksList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldModelValue),expression:"fieldModelValue"}],staticClass:"w3-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fieldModelValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Please select ...")]),_vm._v(" "),_vm._l((_vm.businessestemps),function(business,index){return _c('option',{key:index,domProps:{"value":_vm.constructbusinesslink(business,index)}},[_vm._v(_vm._s(business.name))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNoteDialog_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90844dd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNoteDialog_vue__ = __webpack_require__(862);
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNoteDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90844dd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNoteDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"addNoteDialog",attrs:{"id":_vm.id},on:{"click":_vm.dialogActions}},[_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v(_vm._s(_vm.headertext)+"?")]),_vm._v(" "),_c('span',[_c('p',[_c('font',{attrs:{"color":"green"}},[_c('b',[_vm._v("Notes restricted in length")])])],1),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.tempnote),expression:"tempnote"}],staticClass:"w3-input w3-border w3-validate",staticStyle:{"resize":"none"},attrs:{"cols":"6","placeholder":"short note","min":"0","max":"250","maxlength":"250"},domProps:{"value":(_vm.tempnote)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tempnote=$event.target.value}}})]),_vm._v(" "),(_vm.tempnote)?_c('large-button',{staticClass:"w3-theme-action",on:{"click":function($event){_vm.ok()}}},[_vm._v("Add Note")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageDialog_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b525c5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageDialog_vue__ = __webpack_require__(864);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b525c5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"imageDialog",attrs:{"id":"imageDialog"},on:{"click":_vm.dialogActions}},[(_vm.image)?_c('span',[_c('template',{slot:"headercontent"},[_vm._v(_vm._s(_vm.image.title))]),_vm._v(" "),_c('img',{staticClass:"w3-image",attrs:{"src":_vm.image.url,"width":"100%"}}),_vm._v(" "),_vm._t("default",null,{image:_vm.image})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61741b29_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelDialogButton_vue__ = __webpack_require__(866);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61741b29_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelDialogButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-grey",on:{"click":function($event){_vm.$emit('click',$event)}}},[_vm._t("default",[_vm._v("Cancel")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec92ce96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__ = __webpack_require__(868);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec92ce96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_vm._t("default",[_vm._v("««")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaa7e98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelButton_vue__ = __webpack_require__(870);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaa7e98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_vm._t("default",[_vm._v("Cancel")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cfe947_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RefreshButton_vue__ = __webpack_require__(872);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cfe947_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RefreshButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa fa-refresh",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Refresh")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535bd360_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveButton_vue__ = __webpack_require__(874);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_535bd360_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-floppy-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Save")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53bee810_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__ = __webpack_require__(876);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53bee810_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-plus-square-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Add")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a47c148_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCartButton_vue__ = __webpack_require__(878);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a47c148_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCartButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-cart-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Add")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b764e1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyNowButton_vue__ = __webpack_require__(880);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b764e1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyNowButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-shopping-cart",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Buy Now")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735945ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLinkButton_vue__ = __webpack_require__(882);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735945ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLinkButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-bar-item w3-button tablink"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d723659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CloneButton_vue__ = __webpack_require__(884);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d723659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CloneButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-clone",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Copy")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetLocationButton_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454696ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetLocationButton_vue__ = __webpack_require__(887);
function injectStyle (ssrContext) {
  __webpack_require__(886)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetLocationButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_454696ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetLocationButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w3-cell-row"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"w3-select w3-cell",staticStyle:{"width":"30%"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changed]}},[_c('option',{attrs:{"value":"currentlocation","selected":""}},[_vm._v("Current")]),_vm._v(" "),_c('option',{attrs:{"value":"mylocation"}},[_vm._v("Mine")]),_vm._v(" "),(_vm.home)?_c('option',{attrs:{"value":"shoplocaton"}},[_vm._v("Shop")]):_vm._e()]),_vm._v("\n   "),(_vm.fieldModelValue)?_c('open-gooogle-maps',{staticClass:"w3-cell",attrs:{"latitude":_vm.fieldModelValue.latitude,"longitude":_vm.fieldModelValue.longitude}},[_vm._v("Show")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenClose_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a852069_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenClose_vue__ = __webpack_require__(890);
function injectStyle (ssrContext) {
  __webpack_require__(889)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenClose_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a852069_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenClose_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":_vm.id},on:{"click":function($event){_vm.toggle()}}},[_c('i',{staticClass:"fa fa-arrow-up",class:{'w3-hide':_vm.tempshow,'w3-show':!_vm.tempshow}}),_vm._v(" "),_c('i',{staticClass:"fa fa-arrow-down",class:{'w3-hide':!_vm.tempshow,'w3-show':_vm.tempshow}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Installers_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4de0bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Installers_vue__ = __webpack_require__(892);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Installers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c4de0bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Installers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldModelValue),expression:"fieldModelValue"}],staticClass:"w3-select",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fieldModelValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Please select ...")]),_vm._v(" "),_vm._l((_vm.groupusers),function(user,index){return _c('option',{key:index,domProps:{"value":_vm.constructfulluser(index,user)}},[_vm._v(_vm._s(user.knownAs))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddbeb82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewButton_vue__ = __webpack_require__(894);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ddbeb82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("New")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502dd5c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteButton_vue__ = __webpack_require__(896);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502dd5c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Delete")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345f978a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateButton_vue__ = __webpack_require__(898);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345f978a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_c('i',{staticClass:"fa fa-pencil-square",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_vm._t("default",[_vm._v("Update")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenGoogleMaps_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df3d6f46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenGoogleMaps_vue__ = __webpack_require__(901);
function injectStyle (ssrContext) {
  __webpack_require__(900)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpenGoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df3d6f46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OpenGoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-theme-action",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.OpenGoogleMaps()}}},[_vm._t("default",[_vm._v("Open Map")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1654555b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LargeButton_vue__ = __webpack_require__(903);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1654555b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LargeButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$emit('click',$event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ac2fad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LargeButtonWide_vue__ = __webpack_require__(905);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ac2fad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LargeButtonWide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('large-button',{staticClass:"w3-block",on:{"click":function($event){_vm.$emit('click',$event)}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3394670a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__ = __webpack_require__(908);
function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3394670a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.usedefaultbutton)?_c('large-button',{staticClass:"w3-medium",on:{"click":function($event){_vm.openDialog()}}},[_vm._t("buttonicon"),_vm._v(_vm._s(_vm.buttontext))],2):_vm._e(),_vm._v(" "),_c('dialog-layout',{ref:"confirmDialog",attrs:{"id":_vm.id,"type":_vm.type},on:{"click":_vm.dialogActions}},[_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v(_vm._s(_vm.buttontext)+"?")]),_vm._v(" "),_c('span',[_c('p',[_vm._t("default")],2),_vm._v(" "),(_vm.meta)?_vm._t("controls",null,{meta:_vm.meta}):_vm._e(),_vm._v(" "),_c('cancel-dialog-button',{on:{"click":function($event){_vm.yesno(false)}}},[_vm._v("No")]),_vm._v("\n        \n                                         \n        "),_c('large-button',{class:[_vm.type==='warning'?'w3-red' : 'w3-green'],on:{"click":function($event){_vm.yesno(true)}}},[_vm._v(_vm._s(_vm.oktext))])],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpDialog_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da897f20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpDialog_vue__ = __webpack_require__(910);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da897f20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',{ref:"helpDialog",attrs:{"id":"helpDialog"},on:{"click":_vm.dialogActions}},[_c('h3',{attrs:{"slot":"headercontent"},slot:"headercontent"},[_vm._v(_vm._s(_vm.$route.meta.title||'Help'))]),_vm._v(" "),(_vm.help)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.help.htmlcontent)}}):_vm._e(),_vm._v(" "),(!_vm.help || !_vm.help.htmlcontent)?_c('div',[_vm._v("\n        Sorry no help content available..\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14bd5036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonPageLayout_vue__ = __webpack_require__(913);
function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14bd5036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonPageLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-container commonpagelayout"},[_c('span',{staticClass:"w3-bar pageeditbuttons"},[_vm._t("fixedtopbuttons")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"w3-hide-small w3-hide-medium"},[_vm._t("largescreen")],2),_vm._v(" "),_c('span',{staticClass:"w3-hide-large"},[_vm._t("smallscreen")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17fa31dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ULLayout_vue__ = __webpack_require__(915);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17fa31dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ULLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"w3-ul w3-border w3-round-large"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessInfoLayout_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67707849_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessInfoLayout_vue__ = __webpack_require__(917);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessInfoLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67707849_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessInfoLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.business)?_c('ul-layout',[(_vm.business.name)?_c('header',{staticClass:"w3-container w3-theme-d2"},[_c('h6',[_vm._t("headersideleft"),_vm._v(_vm._s(_vm.business.name)),_vm._t("headersideright")],2)]):_vm._e(),_vm._v(" "),(_vm.business.shortname)?_c('businesses-layout-item',[_vm._v(_vm._s(_vm.business.shortname))]):_vm._e(),_vm._v(" "),(_vm.business.address)?_c('businesses-layout-item',{staticClass:"w3-tiny"},[_vm._v(_vm._s(_vm.business.address))]):_vm._e(),_vm._v(" "),(_vm.business.phone)?_c('businesses-layout-item',[_c('b',[_vm._v("Cell")]),_vm._v(":"+_vm._s(_vm.business.phone))]):_vm._e(),_vm._v(" "),(_vm.business.phone2)?_c('businesses-layout-item',[_c('b',[_vm._v("Phone")]),_vm._v(":"+_vm._s(_vm.business.phone2))]):_vm._e(),_vm._v(" "),(_vm.business.email)?_c('businesses-layout-item',[_c('p',[_c('b',[_vm._v("Email")]),_vm._v(":"+_vm._s(_vm.business.email))])]):_vm._e(),_vm._v(" "),(_vm.business.website)?_c('businesses-layout-item',[_vm._v(_vm._s(_vm.business.website))]):_vm._e(),_vm._v(" "),(_vm.business.pwa && _vm.business.pwa.openhours)?_c('businesses-layout-item',[_vm._v(_vm._s(_vm.business.pwa.openhours))]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa7cf4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessInfoLayoutItem_vue__ = __webpack_require__(919);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa7cf4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessInfoLayoutItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogLayout_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2929c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogLayout_vue__ = __webpack_require__(922);
function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d2929c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-modal"},[_c('div',{staticClass:"w3-modal-content w3-card-4"},[_c('header',{staticClass:"w3-container",class:[_vm.type==='warning'?'w3-red' : 'w3-theme-d2'],staticStyle:{"height":"45px"},on:{"click":_vm.cancelDialog}},[_c('span',{staticClass:"w3-button w3-display-topright"},[_vm._v("×")]),_vm._v(" "),_vm._t("headercontent",[_c('h3',[_vm._v(" ")])],{meta:_vm.meta})],2),_vm._v(" "),_c('div',{staticClass:"w3-container dialogcontent"},[_vm._t("default",[_vm._v(" ")],{meta:_vm.meta})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabLinkLayout_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81b956f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLinkLayout_vue__ = __webpack_require__(925);
function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabLinkLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81b956f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLinkLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-bar w3-theme-l3 w3-round-large",on:{"click":_vm.opentabfromlayout}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialsTableLayout_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66cd6b0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialsTableLayout_vue__ = __webpack_require__(928);
function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialsTableLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66cd6b0e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialsTableLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alladminrights)?_c('span',_vm._l((_vm.alladminrights),function(businessadminright,businessindex){return _c('li',{key:businessindex,staticClass:"w3-cell-row"},[_c('span',[_c('business-info-layout',{attrs:{"business":{name:("" + (businessadminright.name)) }}},[_c('span',{attrs:{"slot":"headersideleft"},slot:"headersideleft"},[_c('i',{staticClass:"fa fa-refresh w3-left",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.refreshlist($event,businessindex)}}}),_vm._v("                        \n              ")]),_vm._v(" "),_c('span',{attrs:{"slot":"headersideright"},slot:"headersideright"},[_c('open-close',{ref:'openclose' + businessindex,refInFor:true,staticClass:"w3-right",attrs:{"show":false},on:{"change":function($event){_vm.toggleMenu($event,businessindex)}}})],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none","border":"none"},attrs:{"id":businessindex + 'menu'}},[_c('table',{staticClass:"w3-table-all"},[(_vm.tempremedialslisting && _vm.tempremedialslisting[businessindex]==='loading')?_c('tr',{staticClass:"w3-theme-l3"},[_c('th',[_vm._v("\n                  Loading ......\n              ")])]):_vm._e(),_vm._v(" "),(_vm.tempremedialslisting && _vm.tempremedialslisting[businessindex] && _vm.tempremedialslisting[businessindex]!=='loading')?_c('tr',[_c('th',{staticClass:"w3-hide-small"},[_vm._v("Unique Id")]),_vm._v(" "),_c('th',{staticClass:"w3-hide-small"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Job#")]),_vm._v(" "),_c('th',{staticClass:"w3-hide-small"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("issue")]),_vm._v(" "),_c('th')]):_vm._e(),_vm._v(" "),_vm._l((_vm.tempremedialslisting[businessindex]),function(remedial,index){return (_vm.tempremedialslisting && _vm.tempremedialslisting[businessindex] && _vm.tempremedialslisting[businessindex]!=='loading')?[_c('tr',{key:index,class:_vm._f("statustype")(remedial.status,'colour')},[_c('td',{staticClass:"w3-hide-small"},[_vm._v(_vm._s(remedial.shortid))]),_vm._v(" "),_c('td',{staticClass:"w3-hide-small"},[_vm._v(_vm._s(_vm._f("remedialtype")(remedial.type))+" "+_vm._s(remedial.linkedbusiness.name)+"\n                  "),(remedial.Received)?_c('span',[_c('br'),_vm._v("Received: ("+_vm._s(_vm._f("formatDate")(remedial.Received))+")")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(remedial.jobnumber||'-'))]),_vm._v(" "),_c('td',{staticClass:"w3-hide-small"},[_vm._v(_vm._s(_vm._f("statustype")(remedial.status,'name')))]),_vm._v(" "),_c('td',{staticClass:"tooltip"},[_c('i',{staticClass:"fa fa-sticky-note",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(remedial.issue))])]),_vm._v(" "),_c('td',{on:{"click":function($event){_vm.$emit('remedialclick',{data:{business:{id:businessindex,name:businessadminright.name},remedial:{id:index}}})}}},[_vm._v("                    \n                   »»                    \n                ")])])]:_vm._e()})],2),_vm._v(" "),_c('br')])])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialTabsLayout_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab12ce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialTabsLayout_vue__ = __webpack_require__(930);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialTabsLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab12ce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialTabsLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.remedial)?_c('span',[_c('p',{staticClass:"w3-hide-small"},[_c('font',{attrs:{"color":"green"}},[_c('b',[_vm._v("Here you can process new/existing remedials.  Click the Refresh button to load background changes such as notes, pictures, activities.")])])],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.remedial.business.name))]),_vm._v(" "),_c('tablink-layout',{staticStyle:{"margin-top":"10px"},attrs:{"show":"notes"}},[(_vm.AuthsRemedialRights({remedial: _vm.remedial,check:'createremedials'}))?_c('tab-link-button',{attrs:{"id":"remedial"}},[_vm._v("Remedial")]):_vm._e(),_vm._v(" "),(_vm.AuthsRemedialRights({remedial: _vm.remedial,check:'createremedials'}))?_c('tab-link-button',{attrs:{"id":"status"}},[_vm._v("Status")]):_vm._e(),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"notes"}},[_vm._v("About")]),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"pictures"}},[_vm._v("Pictures")]),_vm._v(" "),_c('tab-link-button',{attrs:{"id":"activities"}},[_vm._v("Activities")])],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"status_tab"}},[_c('h3',[_vm._v("Remedial Status")]),_vm._v(" "),_c('p',[_c('b',[_c('font',{attrs:{"color":"green"}},[_vm._v("Set the status of the remedial.")])],1)]),_vm._v(" "),_c('status-selector',{attrs:{"statuses":_vm.templateconfig.statuses,"type":"list"},model:{value:(_vm.remedial.status),callback:function ($$v) {_vm.$set(_vm.remedial, "status", $$v)},expression:"remedial.status"}})],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"pictures_tab"}},[_c('p',[_c('b',[_c('font',{attrs:{"color":"green"}},[_vm._v("NOTE!! When adding an image you do not need to save as this happens in the background and in the cloud. It also takes some time to resize the image so please allow time for this to process")])],1)]),_vm._v(" "),(_vm.AuthsRemedialRights({remedial: _vm.remedial,check:'allowimageupload'}))?_c('image-editor',{attrs:{"config":{id:_vm.remedial.id,business_id:_vm.remedial.business.id, location:("/remedials/businesses/" + (_vm.remedial.business.id) + "/processingremedials"),linkedbusinesslocation:("/remedials/businesses/" + (_vm.remedial.linkedbusiness.id) + "/processingremedials"),maxsize:10}}}):_vm._e(),_vm._v(" "),_c('image-dialog',{ref:"imagedialog",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var image = ref.image;
return [_c('p',[_c('label',[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(image.title),expression:"image.title"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(image.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(image, "title", $event.target.value)}}})]),_vm._v(" "),_c('save-button',{staticClass:"w3-theme-action",on:{"click":function($event){_vm.$emit('tabsActions',{action:'saveImage',data:{image: image}});_vm.$refs.imagedialog.cancelDialog()}}})]}}])}),_vm._v(" "),_c('ol',{staticClass:"w3-ul"},_vm._l((_vm.remedial.images),function(image,index){return _c('li',{key:index},[_c('b',[_vm._v(_vm._s(image.title || 'No Title')+"  ")]),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.$refs.imagedialog.show({id:index, url:image.url,title:image.title})}}},[_vm._v("Open Editor"),_c('i',{staticClass:"fa fa-pencil-alt"})]),_vm._v(" \r\n                    "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.openfullscreen(image.url)}}},[_vm._v("Full Screen"),_c('i',{staticClass:"fa fa-chrome"})])])}))],1),_vm._v(" "),_c('tab-layout',{attrs:{"id":"activities_tab"}},[_c('ul',{staticClass:"w3-ul"},_vm._l((_vm.remedial.activities),function(activity,index){return _c('li',{key:index},[_c('b',[_vm._v(_vm._s(activity.user.name))]),_vm._v(" "+_vm._s(activity.action)+" - "),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(activity.actionedAt)))]),_c('br')])}))]),_vm._v(" "),_c('tab-layout',{attrs:{"id":"notes_tab"}},[_c('h4',[_c('u',[_vm._v("Remedial Info")])]),_vm._v(" "),_c('span',[(_vm.remedial.shortid)?_c('p',[_vm._v("\r\n              Unique Id: "),_c('b',[_vm._v(_vm._s(_vm.remedial.shortid))]),_vm._v(" Status: "),_c('span',{class:_vm._f("statustype")(_vm.remedial.status,'colour')},[_c('b',[_vm._v(_vm._s(_vm._f("statustype")(_vm.remedial.status,'name')))])])]):_vm._e(),_vm._v(" "),_c('p',[_c('label',[_vm._v(_vm._s(_vm._f("remedialtype")(_vm.remedial.type))+": "),_c('b',[_vm._v(_vm._s(_vm.remedial.linkedbusiness.name))]),_vm._v(" "),(_vm.remedial.linkedstatus)?_c('span',{class:_vm._f("statustype")(_vm.remedial.linkedstatus,'colour')},[_vm._v("("),_c('b',[_vm._v(_vm._s(_vm._f("statustype")(_vm.remedial.linkedstatus,'name')))]),_vm._v(")")]):_vm._e()])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Job/Remedial# : "),_c('b',[_vm._v(_vm._s(_vm.remedial.jobnumber))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("PO/Reference # : "),_c('b',[_vm._v(_vm._s(_vm.remedial.referencenumber))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Issue: "),_c('b',[_vm._v(_vm._s(_vm.remedial.issue))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Contact Info: "),_c('b',[_vm._v(_vm._s(_vm.remedial.address))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Assigned "),(_vm.remedial.assigned)?_c('span',[_c('b',[_vm._v("("+_vm._s(_vm.remedial.assigned.knownAs)+")")])]):_vm._e()])])]),_vm._v(" "),_c('h4',[_c('u',[_vm._v("Notes")])]),_vm._v(" "),_c('ul',{staticClass:"w3-ul"},_vm._l((_vm.remedial.notes),function(note,index){return _c('li',{key:index},[_c('b',[_vm._v(_vm._s(note.by.name))]),_vm._v(" added a comment - "),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(note.submittedAt)))]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(note.comment))])])}))]),_vm._v(" "),_c('tab-layout',{attrs:{"id":"remedial_tab"}},[_c('remedial-layout',{ref:"remediallayout",attrs:{"remedial":_vm.remedial,"statuses":_vm.templateconfig.statuses}}),_vm._v(" "),_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialLayout_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c017ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialLayout_vue__ = __webpack_require__(932);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c017ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.remedial)?_c('span',[(_vm.remedial.shortid)?_c('p',[_vm._v("\r\n          Unique Id: "),_c('b',[_vm._v(_vm._s(_vm.remedial.shortid))]),_vm._v(" Status: "),_c('span',{class:_vm._f("statustype")(_vm.remedial.status,'colour')},[_c('b',[_vm._v(_vm._s(_vm._f("statustype")(_vm.remedial.status,'name')))])])]):_vm._e(),_vm._v(" "),_c('p',[_c('label',[_vm._v(_vm._s(_vm._f("remedialtype")(_vm.remedial.type))+": "),_c('b',[_vm._v(_vm._s(_vm.remedial.linkedbusiness.name))]),_vm._v(" "),(_vm.remedial.linkedstatus)?_c('span',{class:_vm._f("statustype")(_vm.remedial.linkedstatus,'colour')},[_vm._v("("),_c('b',[_vm._v(_vm._s(_vm._f("statustype")(_vm.remedial.linkedstatus,'name')))]),_vm._v(")")]):_vm._e()])]),_vm._v(" "),(_vm.remedial.type==='createdby')?_c('span',[_c('p',[_c('label',[_vm._v("Job/Remedial# : "),_c('b',[_vm._v(_vm._s(_vm.remedial.jobnumber))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("PO/Reference # : "),_c('b',[_vm._v(_vm._s(_vm.remedial.referencenumber))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Issue: "),_c('b',[_vm._v(_vm._s(_vm.remedial.issue))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Contact Info: "),_c('b',[_vm._v(_vm._s(_vm.remedial.address))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Assigned "),(_vm.remedial.assigned)?_c('span',[_c('b',[_vm._v("("+_vm._s(_vm.remedial.assigned.knownAs)+")")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.remedial.type==='lodgedby')?_c('span',[_c('p',[_c('label',[_vm._v("Job/Remedial#")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.jobnumber),expression:"remedial.jobnumber"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.remedial.jobnumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "jobnumber", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("PO/Reference # : "),_c('b',[_vm._v(_vm._s(_vm.remedial.referencenumber))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Issue: "),_c('b',[_vm._v(_vm._s(_vm.remedial.issue))])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Contact Info: "),_c('b',[_vm._v(_vm._s(_vm.remedial.address))])])])]):_vm._e(),_vm._v(" "),(_vm.remedial.type==='lodgedto' || _vm.remedial.type==='createdto')?_c('span',[(_vm.remedial.type==='createdto')?_c('p',[_c('label',[_vm._v("Job/Remedial#")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.jobnumber),expression:"remedial.jobnumber"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.remedial.jobnumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "jobnumber", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('p',[_c('label',[_vm._v("PO/Reference #")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.referencenumber),expression:"remedial.referencenumber"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.remedial.referencenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "referencenumber", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("issue")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.issue),expression:"remedial.issue"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"3"},domProps:{"value":(_vm.remedial.issue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "issue", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Address of issue")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.address),expression:"remedial.address"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"3"},domProps:{"value":(_vm.remedial.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "address", $event.target.value)}}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("Assigned "),(_vm.remedial.assigned)?_c('span',[_c('b',[_vm._v("("+_vm._s(_vm.remedial.assigned.knownAs)+")")])]):_vm._e()]),_vm._v(" "),_c('installers-group',{attrs:{"business":_vm.remedial.business},model:{value:(_vm.remedial.assigned),callback:function ($$v) {_vm.$set(_vm.remedial, "assigned", $$v)},expression:"remedial.assigned"}})],1),_vm._v(" "),_c('p',[_c('label',[_vm._v("Chargable")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.chargeable),expression:"remedial.chargeable"}],staticClass:"w3-check",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.remedial.chargeable)?_vm._i(_vm.remedial.chargeable,null)>-1:(_vm.remedial.chargeable)},on:{"change":function($event){var $$a=_vm.remedial.chargeable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.remedial, "chargeable", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.remedial, "chargeable", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.remedial, "chargeable", $$c)}}}})])]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.remedial.lastUpdatedAt)?_c('p',[(_vm.remedial.lastUpdatedBy)?_c('b',[_vm._v(_vm._s(_vm.remedial.lastUpdatedBy.name)+" ")]):_vm._e(),_vm._v("last updated - "),_c('b',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.remedial.lastUpdatedAt)))]),_c('br')]):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialNewLayout_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beee7f08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialNewLayout_vue__ = __webpack_require__(934);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemedialNewLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beee7f08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemedialNewLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.remedial)?_c('span',[_c('p',[_vm._m(0),_vm._v(" "),_c('businesses-links-list',{attrs:{"required":"","type":"rights"},model:{value:(_vm.remedial.createdfrombusiness),callback:function ($$v) {_vm.$set(_vm.remedial, "createdfrombusiness", $$v)},expression:"remedial.createdfrombusiness"}})],1),_vm._v(" "),(_vm.remedial.createAs==='linkedremedial')?_c('span',[_c('p',[_c('label',[_vm._v("Job/Remedial#")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.jobnumber),expression:"remedial.jobnumber"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.remedial.jobnumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "jobnumber", $event.target.value)}}})]),_vm._v(" "),_c('p',[_vm._m(1),_vm._v(" "),_c('businesses-links-list',{attrs:{"required":"","type":"linked"},model:{value:(_vm.remedial.linkedbusiness),callback:function ($$v) {_vm.$set(_vm.remedial, "linkedbusiness", $$v)},expression:"remedial.linkedbusiness"}})],1)]):_vm._e(),_vm._v(" "),_c('p',[_c('label',[_vm._v("PO/Reference #")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.referencenumber),expression:"remedial.referencenumber"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"text"},domProps:{"value":(_vm.remedial.referencenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "referencenumber", $event.target.value)}}})]),_vm._v(" "),(_vm.remedial.createAs==='lodgedremedial')?_c('span',[_c('p',[(!_vm.remedial.id)?_c('span',[_vm._m(2),_vm._v(" "),_c('businesses-links-list',{staticClass:"w3-input w3-border w3-panel w3-border w3-border-red",attrs:{"required":"","type":"lodge"},model:{value:(_vm.remedial.linkedbusiness),callback:function ($$v) {_vm.$set(_vm.remedial, "linkedbusiness", $$v)},expression:"remedial.linkedbusiness"}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('p',[_c('label',[_vm._v("Contact/Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.address),expression:"remedial.address"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"3"},domProps:{"value":(_vm.remedial.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "address", $event.target.value)}}})]),_vm._v(" "),_c('p',[_vm._m(3),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remedial.issue),expression:"remedial.issue"}],staticClass:"w3-input w3-border w3-panel w3-border w3-border-red",staticStyle:{"resize":"none"},attrs:{"rows":"3","required":""},domProps:{"value":(_vm.remedial.issue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.remedial, "issue", $event.target.value)}}})]),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Created From "),_c('span',{staticClass:"w3-text-red"},[_vm._v("(required)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Requested by "),_c('span',{staticClass:"w3-text-red"},[_vm._v("(required)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Lodge with "),_c('span',{staticClass:"w3-text-red"},[_vm._v("(required)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Issue "),_c('span',{staticClass:"w3-text-red"},[_vm._v("(required)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d7e4a38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLayout_vue__ = __webpack_require__(936);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d7e4a38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tabs_display",staticStyle:{"display":"none"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessesLayout_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2728db9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessesLayout_vue__ = __webpack_require__(938);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessesLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2728db9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessesLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.businesses)?_c('span',[_c('ul',{staticClass:"ul-layout"},_vm._l((_vm.businesses),function(business,index){return _c('li',{key:index,staticClass:"li-layout"},[_c('business-info-layout',{attrs:{"business":{id:index, name:business.name,shortname:business.shortname||'',address:business.address||''}}},[_c('businesses-layout-item',[_vm._t("buttons",null,{business:{id:index, name:business.name,shortname:business.shortname||'',address:business.address||''}})],2)],1)],1)}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[398]);


// WEBPACK FOOTER //
// static/js/app.0ce2be9e7c3b09443cf1.js